<template>
    <div class="employee-preference-view has-header" v-bind:class="{'group-drag' : draggingGroup}">
        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>
        <div class="header main">
            <div class = "align-left">
                <dateselectionheader
                             :label="dateDisplay"
                            @PrevDate="SelectPreviousDate"
                            @NextDate="SelectNextDate"
                            @CalendarOpen="toggleDatePicker"
                            @SetToday="SelectToday"/>
            </div>
            <div class = "align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>

            <div class="align-right">
                <headerbuttonstack :state="sideButtons"/>
            </div>
        </div>

        <div class="sub-header-button-container">
                <buttonc type="square" icon="fa-filter" @click="OpenFilterPopup"/>
        </div>
        <div class="scrollbar-container">
            <div class="sub-header" v-if="displayedTimeframeSelected.label === 'D'">
                <div class="title" v-bind:style="{width: GetWidthFirstTitle()}">
                    <div class="label ">{{ $helpers.translateDayShort(timeFrameStart.format("dd")) + timeFrameStart.format(". DD.MM.") }}</div>
                </div>
                <div class="title second" v-bind:style="{width: GetWidthSecondTitle(), display: displayedTimeframeSelected.divisions < 36 ? 'none' : ''}">
                    <div class="label ">{{ $helpers.translateDayShort(timeFrameStart.clone().add(1,'day').format("dd")) + timeFrameStart.clone().add(1,'day').format(". DD.MM.") }}</div>
                </div>
            </div>

            <div class="day-container hours background" v-if="displayedTimeframeSelected.label !== 'D'"></div>
            <div class="day-container hours" v-if="displayedTimeframeSelected.label === 'M'">
                <div class="background"></div>
                <div class="day" v-for="(day, indexD) in daysDisplayed" :key="indexD"  v-bind:style="[GetTimeMarkWidth(indexD)]" v-bind:class="{'hovered': hoveredColumn == indexD}">
                    <div class="weather" v-if="saveWeatherFromDateFormat(day)"
                         v-on:mouseenter="OpenWeatherPopup($event, day.moment, false)"
                         v-on:mouseleave="CloseWeatherPopup($event)"
                         v-on:click="OpenWeatherPopup($event, day.moment, true)">
                        <img class="picture" v-bind:style="{filter: nightMode && GetWeatherIcon(day.moment.format('MM-DD')) === '../img/Warnung.svg' ? 'invert(1)' : ''}"  v-bind:src="GetWeatherIcon(day.moment.format('MM-DD'))"/>
                        <div class="label">{{GetWeatherTemp(day.moment.format('MM-DD'))}}°</div>
                    </div>
                    <div class="day-text" v-on:click="SelectDay(day)">
                        <div class="name">{{day.name}}
                        </div>
                        <div class="date">{{day.date}}
                        </div>
                    </div>
                    <div class="income" v-if="planningIndicator[day.moment.format('YYYY-MM-DD')]" v-tooltip="GetIndicatorAmountWrapper(day.moment)">
                        <div class="income-bar red" v-if="planningIndicator[day.moment.format('YYYY-MM-DD')].planned && planningIndicator[day.moment.format('YYYY-MM-DD')].actual" v-bind:style="{width: 'calc(100% - 10px)', 'margin-left': '1px'}"></div>
                        <div class="income-bar green" v-if="planningIndicator[day.moment.format('YYYY-MM-DD')].actual && planningIndicator[day.moment.format('YYYY-MM-DD')].planned" v-bind:style="{width: GetDailyIndicatorBarWidth(day.moment)}"></div>
                        <div class="income-bar green" v-if="!planningIndicator[day.moment.format('YYYY-MM-DD')].planned" v-bind:style="{width: 'calc(100% - 10px)'}"></div>
                        <div class="income-bar red" v-if="!planningIndicator[day.moment.format('YYYY-MM-DD')].actual" v-bind:style="{width: 'calc(100% - 10px)'}"></div>
                    </div>
                    <div class="income" v-if="!planningIndicator[day.moment.format('YYYY-MM-DD')]" v-tooltip="GetIndicatorAmountWrapper(day.moment)">
                        <div class="income-bar gray" style="width: calc(100% - 10px); margin-left: 1px;"></div>
                    </div>
                    <div class="event-marker fas fa-flag" v-if="HasEventsOnThatDay(day.moment)" v-bind:style="GetEventsColor(day.moment)" @mouseover="OpenEventHover($event,day.moment)" @mouseleave="CloseEventHover()"></div>
                </div>
            </div>
            <div class="grid">



                <div class="backdrop"></div>
                <div class="header">
                    <div class="label">{{ $tc('global.general.absence', 2) }}</div>
                     <!--
                    <div class="employee-filter button" v-on:click="OpenFilterPopup($event)">
                    <div class="label" style="padding-left: 4px; padding-top: 1px;">
                        <i class="fas fa-filter"></i>
                    </div>
                    </div>
                    -->

                </div>
                <div class="group" v-for="(group, indexGroup) in employeeGroups" :key="group.header"
                    v-if="!forceGroupRecompute && ((!rosterSortState.showBusinessUnits && !rosterSortState.showSpots) || spotVisibilityList.find(s => s === group.spot)) && (!group.spot.parentId || (group.spot.parentId && IsParentCollapsed(group)))"
                    v-bind:style="{'margin-bottom': (indexGroup == Object.values(employeeGroups).length - 1)? '100px !important':''}"
                    v-bind:indexGroup="group.spot.id"
                    v-bind:class="GetGroupClasses(group, indexGroup)">
                    <div class="header" v-bind:style="{ background: group.spot.id ? group.spot.color + ' !important' : ''}">
                        <div class="fa-stack drag" v-if="group.draggable" v-on:mousedown="DragStartBusinessUnit($event, group, indexGroup)">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-stack-2x fa-arrows-alt" v-bind:style="{color:  GetContrastingColor(group.spot.color)}"></i>
                        </div>
                        <div class="label" v-bind:style="{color:  GetContrastingColor(group.spot.color)}">{{group.header}}</div>
                        <div class="fa-stack" v-on:click="ToggleCollapseState(group)">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-stack-2x" v-bind:class="{'fa-angle-down' : IsCollapsed(indexGroup), 'fa-angle-up' : !IsCollapsed(indexGroup)}"></i>
                        </div>
                    </div>
                    <div class="drag-catch-area">&gt;&gt;</div>
                    <div class="drag-catch-area last">&gt;&gt;</div>
                    <div class="row" v-for="(employee, indexE) in group.employees" :key="employee.id" v-if="!IsCollapsed(indexGroup) && EmployeeIsVisible(employee.employee)" v-on:mousemove="UpdateCreateTimeFrame($event, employee, group)">
                        <div class="employee">
                            <div class="background"></div>
                            <div class="background shadow"></div>
                            <div class="picture" v-bind:style="{background: (employee !== null && !anonMode ? employee.picture : 'url(../img/default.jpg)'), 'background-size': 'contain'}"></div>
                            <div class="name">{{anonMode ? $t('roster.view.anonymousEmployee') : employee.name}}</div>
                            <div class="name shadow"></div>
                            <div class="entitled">
                                <div v-if="calculatedEntitlementEmployeeMap[employee.employee.id]" class="label">{{ calculatedEntitlementEmployeeMap[employee.employee.id] }}</div>

                            </div>
                            <!--
                            <div style= "width: 30px; height: 30px;">
                                    <div class="fa-stack detail"
                                    v-bind:style="{'z-index': 99}" v-on:click="OpenPreferenceButtonMenu($event, employee.employee, group.spot)">
                                        <i style="font-size:25px; right:0px;" class="fas fa-circle fa-stack-2x"></i>
                                        <i style="font-size:25px; margin-left:-1px;" class="fas fa-cog fa-stack-2x"></i>
                                    </div>
                            </div>
                            -->

                        </div>
                        <div class="timeframe create" v-if="timeFrameCreate.employee === employee" v-bind:style="[GetCreateTimeFrameStyles(), {opacity: timeFrameCreate.dragging ? 1 : 0}]"
                            v-on:mouseover="Hovering($event)" v-on:mouseleave="EndHovering($event)"  v-on:mousedown="TimeFrameCreateDrag($event)" v-on:mouseup="TimeFrameCreate()">
                            <div class="fas fa-plus"></div>
                            <div class="shadow"></div>
                        </div>
                        <div class="timeframe vacationban" v-if="isVacationBanVisible(vacationBan)" v-for="vacationBan in employee.vacationbans" :key="vacationBan.id"
                             v-bind:style="[GetVacationBanStyles(vacationBan)]">
                        </div>
                        <div class="timeframe" v-if="isTimeFrameVisible(timeFrame)" v-for="(timeFrame, indexF) in employee.timeFrames" :key="timeFrame.preference ? timeFrame.preference.id : employee.id + indexF" v-bind:style="[GetTimeFrameStyles(timeFrame)]" v-bind:id="timeFrame.preference.id"
                             v-on:mouseup="SelectTimeFrame($event, timeFrame)" v-on:mouseenter="CheckLabelLength($event)" v-tooltip="GetTimeFrameTooltip(timeFrame)">
                            <div class="handle start" v-if="!timeFrame.preference.locked" v-on:mousedown="StartDragTimeFrame($event, timeFrame, true)"><div class="inner"></div></div>
                            <div class="handle end" v-if="!timeFrame.preference.locked" v-on:mousedown="StartDragTimeFrame($event, timeFrame, false)"><div class="inner"></div></div>
                            <div class="label">{{timeFrame.label}}</div>
                            <div class="shadow"></div>
                            <div class="always-work-bar" v-if="timeFrame !== draggingTimeFrame" v-for="(missingDay, indexMissing) in timeFrame.missingDayStyles" :key="missingDay.left + indexMissing" v-bind:style="[missingDay]"></div>
                            <div class="always-work-bar" v-if="draggingTimeFrame && timeFrame === draggingTimeFrame" v-for="(missingDay, indexMissing) in draggingMissingDayStyles" :key="missingDay.left + indexMissing" v-bind:style="[missingDay]"></div>
                        </div>
                        <div class="top-line"></div>
                        <div class="bottom-line"></div>
                    </div>
                </div>
                <div class="time-marks" v-bind:class="{monthly: displayedTimeframeSelected.label === 'Y'}">
                    <div class="mark" v-for="(mark, indexMark) in timeMarks" v-bind:index="indexMark" :key="indexMark" v-bind:style="[GetTimeMarkWidth(indexMark)]" v-bind:class="{'day-split' : mark === '00', 'hovered': indexMark == hoveredColumn}">
                    </div>
                </div>
                <div class="time-marks labels" v-if="displayedTimeframeSelected.label === 'D'">
                    <div class="mark" v-for="(mark, indexMark) in timeMarks" v-bind:index="indexMark" :key="indexMark" v-bind:style="[GetTimeMarkWidth(indexMark)]" v-bind:class="{'day-split' : mark === '00'}">
                        <div class="label" v-if="displayedTimeframeSelected.label !== 'M'">{{displayedTimeframeSelected.label !== 'Y' ? mark : displayedTimeframeSelected.timeStart.clone().month(indexMark).format('MMM')}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="event-info" v-if="eventOnHover">
            <div class="header">{{eventOnHover.header}}</div>
            <div class="description">{{eventOnHover.description}}</div>
        </div>
        <div class="drag-info" v-if="dragging">
            <div class="description">{{draggingStart ? draggingTime.fromDate.format('YYYY-MM-DD HHa') : draggingTime.toDate.format('YYYY-MM-DD HHa') }}</div>
        </div>
        <div class="drag-group group" v-if="draggingGroup">
            <div class="header">
                <div class="fa-stack drag">
                    <i class="fas fa-stack-2x fa-arrows-alt"></i>
                </div>
                <div class="label">{{draggingGroup.header}}</div>
                <div class="fa-stack add">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fas fa-plus fa-stack-2x"></i>
                </div>
                <div class="fa-stack">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fas fa-stack-2x fa-angle-down"></i>
                </div>
            </div>
        </div>
        <div class="timeframe-popup" v-if="selectedTimeFrame" v-bind:style="{'left' : timeFramePopupOffsetX + 'px', 'top' : timeFramePopupOffsetY + 'px'}">
            <div class="background" v-on:click="selectedTimeFrame = null"></div>
            <div class="button" v-bind:class="{'disabled' : selectedTimeFrame.preference.denied || selectedTimeFrame.preference.approved}" v-on:click="ApproveRequest(selectedTimeFrame.preference)">
                <div class="label">Genehmigen</div>
            </div>
            <div class="button" v-bind:class="{'disabled' : selectedTimeFrame.preference.denied || selectedTimeFrame.preference.approved}" v-on:click="DenyRequest(selectedTimeFrame.preference)">
                <div class="label">Ablehnen</div>
            </div>
            <div class="button" v-on:click="DeleteRequest(selectedTimeFrame.preference)">
                <div class="label">{{ $t('global.ui.delete') }}</div>
            </div>
        </div>
        <dropdowncontainer ref="dropdowncontainer"/>
        <weatherpopup ref="weatherpopup"/>
        <filterpopup ref="filterpopup"/>
        <eventhover ref="eventhover"/>
        <employeeworkbalancecreation ref="employeeworkbalancecreation"></employeeworkbalancecreation>
    </div>
</template>

<script>

import dropdowncontainer from '../uicomponents/dropdowncontainer.vue';
import weatherpopup from '../weathercontext/WeatherPopup.vue';
import filterpopup from '../testroster/FilterPopupPreferences.vue';
import eventhover from '../testroster/EventHover.vue';
import employeeworkbalancecreation from '../workbalancecontext/EmployeeWorkBalanceCreation.vue';
import { mapGetters } from 'vuex';

export default {
        name: 'PreferenceView',
        components: {
            dropdowncontainer,
            weatherpopup,
            filterpopup,
            eventhover,
            employeeworkbalancecreation
        },
        data(){
            return{
                filterPopupOpen: false,
                dynamicEnabled: false,

                displayedTimeframes: [],
                displayedTimeframeSelected: null,
                eventOnHover: null,
                mouseX: 0,
                mouseY: 0,
                timeFrameStart: this.$helpers.getMomentTZ().hours(0).minutes(0), //this.$helpers.getMomentTZ().date(14).hours(0).minutes(0), //changing .date here for debugging for now
                timeFrameEnd: this.$helpers.getMomentTZ().hours(0).minutes(0), //this.$helpers.getMomentTZ().date(14).hours(0).minutes(0), //changing .date here for debugging for now
                timeFrameLength: 24 * 60 * 60 * 1000,
                employees: [],
                employeesFiltered: [],
                preferences: {},
                businessUnits: [],
                spots: [],
                customSpotMap: {},
                uiData: [],
                employeeAvailabilityStateMap: {},
                employeeAvailabilityTypeMap: {},
                employeeAvailabilitySubtypeMap: {},
                filterDropdownOptions: [],
                selectedTimeFrame: null,
                timeFramePopupOffsetY: 0,
                timeFramePopupOffsetX: 0,
                loading: false,
                loadingText: this.$t('global.ui.loadX', [this.$t('global.menubar.preferences')]),
                dragging: false,
                draggingTimeFrame: null,
                draggingTime: null,
                draggingMissingDayStyles: null,
                draggingStart: false,
                draggingStartPos: {x: 0, y: 0},
                draggingHandle: null,
                draggingGroup: null,
                userunitsort: [],
                spotVisibilityList: [],
                skillVisibilityList: [],
                employeeSkills: {},
                skills: [],

                calculatedEntitlementEmployeeMap: {},

                dayOfYearDateKeyMap: {},
                dayOfYearIsoWeekdayMap: {},
                dateSelectionStart: this.$helpers.getCurrentMonthMomentTZ().hours(0).minutes(0),

                groupCollapsedStates: {},
                forceGroupRecompute: false,
                currentYear: this.$helpers.getCurrentMonthMomentTZ().year(),
                currentMonth: this.$helpers.getCurrentMonthMomentTZ().month(),
                currentDate: 1,
                rawWeatherData: [],
                weather: {
                    data:[],
                },
                planningIndicator: {},
                timeFrameCreate: {
                    employee: null,
                    pos: {x: 0, y: 0},
                    width: '',
                    timeMark: null,
                },
                planningIndicatorTypeMap: {},
                storeEventMap: {},
                storeEventMomentMap: {},
                timeZone: '',
                hourlySelection: 36,
                vacationBanMap: {},
                countUnapprovedVacation: false,
                hoveredColumn: -1
            }
        },
        props:{
            currentDay: Object,
        },
        computed: {
             ...mapGetters(['storeId', 'anonMode', 'rosterFromTo', 'employeeMap', 'employeeSkillMap', 'spotMap', 'businessUnitMap', 'skillMap', 'employeeContractMap', 'employeePreferenceMap', 'holidayMap', 'nightMode', 'storeSettings', 'userUnitSortMap', 'employeeWorkbalanceMap', 'userInfo', 'employeeAvgWorktimeMap', 'rosterSortState']),
            currentMonthFromTZ(){
                let res = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1).startOf('month');
                return res;

            },
            currentMonthToTZ(){
                let res = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1).add(1, 'months').startOf('month');
                return res;
            },
            employeeIdEmployeeContractMap() {
                let map = {};
                Object.values(this.employeeContractMap).forEach(contract => {
                    if(!map[contract.employeeId]){
                        map[contract.employeeId] = [];
                    }
                    map[contract.employeeId].push(contract);
                })
                return map;
            },
            employeeContractMomentMap(){
                let map = {};
                Object.values(this.employeeContractMap).forEach(contract => {
                    let from = this.$helpers.getMomentFromStringTZ(contract.from);
                    let to = contract.to == null ? this.currentMonthToTZ : this.$helpers.getMomentFromStringTZ(contract.to);
                    map[contract.id] = {fromDate: from, toDate: to};
                })
                return map;
            },
            employeeMainContractMap() {
                let map =  {};
                Object.values(this.employeeMap).forEach(employee => {
                    let employeeId = employee.id;
                    let mainRatio = 0;
                    let mainContract = null;
                    if (this.employeeIdEmployeeContractMap[employeeId]) {
                        let contracts = this.employeeIdEmployeeContractMap[employeeId];
                        contracts.forEach(contract => {

                            let contractFrom = this.employeeContractMomentMap[contract.id].fromDate;
                            let contractTo = this.employeeContractMomentMap[contract.id].toDate == null ? this.currentMonthToTZ : this.employeeContractMomentMap[contract.id].toDate;
                            if (contractFrom < this.currentMonthFromTZ) {
                                contractFrom = this.currentMonthFromTZ;
                            }
                            if (contractTo > this.currentMonthToTZ) {
                                contractTo = this.currentMonthToTZ;
                            }

                            let ratio = contractTo.diff(contractFrom, 'days') / this.currentMonthToTZ.diff(this.currentMonthFromTZ, 'days');
                            if(ratio > mainRatio){
                                mainContract = contract;
                            }

                        });

                    }
                    map[employee.id] = mainContract;
                })
                return map;
            },
            employeeIdWorkBalanceMap() {
                let view = this;
                let map = {};
                if(this.employeeWorkbalanceMap){
                    Object.values(this.employeeWorkbalanceMap).forEach(w => {
                        map[w.employeeId] = w;
                    });
                }

                return map;
            },
            employeePreferenceMomentMap(){
                let map = {};
                Object.values(this.employeePreferenceMap).forEach(pref => {
                    let from = this.$helpers.getMomentFromStringTZ(pref.from);
                    let to = this.$helpers.getMomentFromStringTZ(pref.to);
                    map[pref.id] = {from: from, to: to};
                })
                return map;
            },

            employeeEmployeePreferenceMap() {
                let map = {};
                Object.values(this.employeePreferenceMap).forEach(pref => {
                    if(!map[pref.employeeId]){
                        map[pref.employeeId] = [];
                    }
                    map[pref.employeeId].push(pref);
                })
                return map;
            },
            previousMonth(){
                if(!this.rosterFromTo) return this.$helpers.getMomentTZ();
                let prev = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1).subtract(1, 'months').startOf('month');
                return prev;
            },
            previousMonthUTC(){
                if(!this.rosterFromTo) return this.$helpers.getMomentTZ();
                let prev = this.$helpers.getMomentFromValuesUTC(this.rosterFromTo.year, this.rosterFromTo.month, 1).subtract(1, 'months').startOf('month');
                return prev;
            },
            headerButtons() {
                let view = this;

                let state= {
                    buttons: []
                };
               if(this.displayedTimeframeSelected.label !=  'M'){
                    state.buttons.push({
                        type: "block border-r",
                        icon: "fa-chevron-left",
                        click: () => {view.onDatePicked(view.timeFrameStart, 'M', 24);},
                        tooltip: this.$t('roster.view.backToMonthlyView')
                    });
                }

                state.buttons.push({
                    type: "block border-r",
                    icon: "fa-refresh",
                    click: () => {
                       view.Refresh(true);
                    },
                    tooltip: this.$t('global.general.refreshData')
                });


                state.helperLinks = [
                {
                    icon: "fa-video",
                    title: this.$t('store.structure.watchTrainingVideo'),
                    helperText: this.$t('store.structure.watchTrainingVideoHelp'),
                    externalUrl: "https://www.youtube.com/watch_popup?v=dBXnotWZvwo",
                    externalLabel: this.$t('pref.main.trainingVideoAbsence'),
                    cancelLabel: this.$t('global.ui.close')
                },
                    {
                        title:  this.$t('store.structure.getSupport'),
                        helperText:  this.$t('store.structure.getSupportHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/14",
                        externalLabel:  this.$t('store.structure.getSupportLabel'),
                        cancelLabel: this.$t('global.ui.close')
                    }
                ];

                return state;




            },
            sideButtons() {
                let view = this;

                let state= {
                    buttons: []
                };
                 state.buttons.push({
                    type: "block border-r",
                    icon: "fa-filter",
                    click: ($event) => {
                       view.OpenFilterDropdown($event);
                    },
                    tooltip: this.$t('global.ui.viewFilter')
                });
                state.buttons.push({
                    type: "block border-r",
                    icon: "fa-eye",
                    tooltip: this.$t('global.ui.viewOptions'),
                    click: ($event) => {view.OpenMenuDetails($event, this.displayMenuState)}
                });
                state.buttons.push({
                    type: "block border-r",
                    icon: "fa-print",
                    tooltip: this.$t('global.ui.reportsExports'),
                    click: ($event) => {view.OpenMenuDetails($event, this.reportMenuState)}
                });
                state.buttons.push({
                    type: "block",
                    icon: "fa-bars",
                    tooltip: this.$t('global.ui.additionalOptions'),
                    click: ($event) => {view.OpenMenuDetails($event, this.burgerMenuState)}
                });

                return state;
            },
            unavailablityTransformationDeadline() {
               let date = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1).add(-1, 'months');
               let maxDate = date.clone().endOf('month').date();

               let limitDate =  this.storeSettings.appEmployeePreferencesDeadline;
               if(limitDate > maxDate){
                   limitDate = maxDate;
               }
               date.date(limitDate);
               return date;
            },
            displayMenuState(){
                let view = this;
                let state = {
                    componentref: 'burgermenustate',
                    groups: [
                        {
                            label: this.$t('global.ui.viewOptions'),
                            items: [
                                {
                                    closeOnClick: true,
                                    icon: !this.countUnapprovedVacation ? 'fa-toggle-off' : 'fa-toggle-on',
                                    text: this.$t('pref.main.countUnconfirmedVacation'),

                                    click: () => {
                                        this.$set(this, 'countUnapprovedVacation', !this.countUnapprovedVacation);

                                        let map = {};
                                        for(let id in this.calculatedEntitlementEmployeeMap){
                                            map[id]= this.getCalculatedEntitlementForEmployee(id);
                                        }
                                        this.$set(this, 'calculatedEntitlementEmployeeMap', map);


                                    },
                                },
                            ]
                        },


                    ],
                    items: []
                };


                return state;
            },
            reportMenuState() {
                let view = this;
                let state = {
                    componentref: 'burgermenustate',
                    groups: [
                        {
                            label: this.$t('pref.main.export'),
                            items: [
                                {
                                    closeOnClick: true,
                                    icon: 'fa-file-csv',
                                    text: this.$t('indicator.main.exportCurrentAsCsv'),
                                    click: () => {
                                        view.openExportSelection(1);
                                    }
                                },
                                {
                                    closeOnClick: true,
                                    icon: 'fa-file-pdf',
                                    text: this.$t('pref.main.exportCurrentViewAsPdf'),
                                    click: () => {
                                        view.openExportSelection(2);
                                    }
                                },
                                {
                                    closeOnClick: true,
                                    icon: 'fa-file-pdf',
                                    text: this.$t('pref.main.absenceTimeframeExport'),
                                    click: () => {
                                        view.OpenEmployeePrefDaysExportPopup();
                                    }
                                }

                            ]
                        },

                    ],
                    items: []
                };


                return state;
            },
            burgerMenuState(){
                let view = this;
                let state = {
                    componentref: 'burgermenustate',
                    groups: [

                        {
                            label: this.$t('pages.employeeContext.availabilities'),
                            items: [
                                {
                                    closeOnClick: true,
                                    icon: 'fa-retweet',
                                    disabled: this.storeSettings.enableAppEmployeePreferencesDeadline && this.$helpers.getMomentTZ() < this.unavailablityTransformationDeadline,
                                    text: this.$t('pref.main.convertIntoAvailabilities'),
                                    click: () => {
                                        view.OpenCreateUnavailibilitiesForEmployees();
                                    }
                                }
                            ]
                        },
                        {
                            label: this.$t('roster.view.holidays'),
                            items: [
                                {
                                    closeOnClick: true,
                                    icon: 'fa-retweet',
                                    disabled: this.storeSettings.workTimeMode == 3,
                                    text: this.$t('pref.main.convertHolidaysIntoPc'),
                                    click: () => {
                                        view.OpenTransformHolidaysPopup();
                                    }
                                },
                                {
                                    closeOnClick: true,
                                    icon: 'fa-retweet',
                                    disabled: this.storeSettings.workTimeMode != 3,
                                    text: this.$t('pref.main.convertHolidaysIntoZeroWorkTime'),
                                    click: () => {
                                        view.OpenTransformHolidaysToZeroWorkTimePopup();
                                    }
                                }
                            ]
                        },
                        

                    ],
                    items: []
                };


                return state;
            },
            holidayMomentMap(){

                 let view = this;
                 let map = {};
                 Object.values(this.holidayMap).forEach(e => {
                     let from =  view.$helpers.getMomentFromStringTZ(e.from);
                     let to =  view.$helpers.getMomentFromStringTZ(e.to);
                     let eventTemp = {};
                     for(let x in e){
                         eventTemp[x] = e[x];
                     }
                     eventTemp.fromDate = from;
                     eventTemp.toDate = to;
                     if(!map[from.format('YYYY-MM-DD')]) map[from.format('YYYY-MM-DD')] = [];
                     map[from.format('YYYY-MM-DD')].push(eventTemp);
                 });
                 return map;
            },
            holidayFederalMomentMap(){
                 let view = this;
                 let map = {};
                 for (let [key, e] of Object.entries(this.storeEventMomentMap)) {
                         map[key] = e.filter(ev => ev.federalHoliday);
                 }
                 return map;
            },
            daysDisplayed(){
                let days = [];
                let date = this.$helpers.getMomentTZ().date(this.currentDate).month(this.currentMonth).year(this.currentYear).minutes(0).seconds(0).milliseconds(0);
                for(let x = 0; x < date.daysInMonth(); x++){
                    date.date(x + 1);
                    days.push({
                        name: this.$helpers.translateDayShort(date.format('dddd').substring(0, 2)),
                        date: date.format('DD').substring(0,2) + '.' + date.format('MM').substring(0,2),
                        moment: date.clone(),
                    });
                }
                return days;

            },
            timeFrameSelectedStart(){
                let date = this.$helpers.getMomentTZ().date(this.currentDate).month(this.currentMonth).year(this.currentYear).startOf('day');
                return date;
            },
            timeFrameSelectedEnd(){
                let date = this.$helpers.getMomentTZ().date(this.currentDate).month(this.currentMonth).year(this.currentYear).startOf('day');
                if(this.displayedTimeframeSelected.label === 'Y') date.add(1, 'year');
                if(this.displayedTimeframeSelected.label === 'M') date.add(1, 'month');
                if(this.displayedTimeframeSelected.label === 'D') date.add(2, 'day');
                return date;
            },
            userUnitSortMapByUnitId(){
                let map = {};
                Object.values(this.userUnitSortMap).forEach(sort => {
                    map[sort.unitId] = sort;
                })
                return map;
            },
            employeeGroups() {
                let view = this;
                if(!this.preferences || !this.preferences.filter) return [];
                this.SortSpotsByPriority();
                let employeeGroups = [];
                const userUnitSortMap = this.userUnitSortMapByUnitId;
                if (!this.rosterSortState.showBusinessUnits && !this.rosterSortState.showSpots) {
                    employeeGroups = this.LoadGroupsAllInOne();
                } else {
                    let groups = this.LoadGroupsBySpots();

                    //first only add main groups

                    let mainGroups = groups.filter(g => g.spot.isMain);
                    mainGroups.forEach(g => employeeGroups.push(g));
                    //SORT MAIN GROUPS BY PRIORITY
                    mainGroups.sort((a,b) => {
                        let userunitsortA = userUnitSortMap[a.spot.id];
                        let userunitsortB = userUnitSortMap[b.spot.id];


                        let prioA = userunitsortA != null ? userunitsortA.priority : a.spot.priority;
                        let prioB = userunitsortB != null ? userunitsortB.priority : b.spot.priority;
                        if(prioA == null) return 1;
                        if(prioB == null) return -1;
                        if(prioA != prioB) return prioA - prioB;

                        return a.header.toUpperCase().localeCompare(b.header.toUpperCase());


                    });
                    employeeGroups = mainGroups;

                    //CREATE SUB GROUPS
                    let subGroups = groups.filter(g => !g.spot.isMain);
                    //SORT SUB GROUPS BY PRIORITY
                    subGroups.sort((a,b) => {
                        let userunitsortA = userUnitSortMap[a.spot.id];
                        let userunitsortB = userUnitSortMap[b.spot.id];
                        let prioA = userunitsortA != null ? userunitsortA.priority : a.spot.priority;
                        let prioB = userunitsortB != null ? userunitsortB.priority : b.spot.priority;

                        if(prioA == null) return 1;
                        if(prioB == null) return -1;
                        if(prioA != prioB) return prioA - prioB;

                        return a.header.toUpperCase().localeCompare(b.header.toUpperCase());
                    });

                    //SPLICE BY PARENT
                    if(subGroups.length > 0) {
                        subGroups = subGroups.reverse();
                        subGroups.forEach(g => {
                            let parent = employeeGroups.find(eg => eg.spot.isMain && eg.spot.unitId === g.spot.unitId);
                            let parentIndex = employeeGroups.indexOf(parent) + 1;
                            employeeGroups.splice(parentIndex, 0, g);
                        });
                    }


                }
                return employeeGroups;
            },

            groupedEmployeeMap(){
                let map = {};
                this.employeeGroups.forEach(g => {
                    g.employees.forEach(e => {
                        map[e.employee.id] = e;
                    });
                });
                return map;
            },

            dateDisplay: function() {
                if(this.timeFrameStart != null){
                    if(this.displayedTimeframeSelected.label === 'D') return this.timeFrameStart.format('DD.MM.YYYY');
                    if(this.displayedTimeframeSelected.label === 'M') return this.timeFrameStart.format('MMM YYYY');
                    if(this.displayedTimeframeSelected.label === 'Y') return this.timeFrameStart.format('YYYY');
                    return '-';
                } else {
                    return '-';
                }

            },
            timeMarks(){

                var marks = [];

                var timeFrame = this.displayedTimeframeSelected;
                for(var x = 0; x < timeFrame.divisions; x++){
                    var timemark = (x + 1 > 9 ? x + 1 : '0' + (x + 1));

                    if(timeFrame.length <= 48 * 60 * 60 * 1000) timemark = ((x % 24) > 9 ? (x % 24) : '0' + (x % 24));

                    marks.push(timemark.toString());
                }
                return marks;
            },
        },
        watch: {
            displayedTimeframeSelected(newVal, oldVal){
                if(newVal.label === 'D') this.timeFrameStart.date(this.currentDate).month(this.currentMonth);
                if(newVal.label === 'M') this.timeFrameStart.date(1).month(this.currentMonth);
                if(newVal.label === 'Y') this.timeFrameStart.date(1).month(0);
            },

            rosterFromTo(newVal, oldVal) {
                if(newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
                    this.Refresh();

                }
            },
            employeePreferenceMap(newVal, oldVal){
                this.preferences = Object.values(newVal);
                for(let id in this.calculatedEntitlementEmployeeMap){
                   this.calculatedEntitlementEmployeeMap[id] = this.getCalculatedEntitlementForEmployee(id);
                }

            },
            storeId(newVal, oldVal) {
                console.log("Changed storeId: "+newVal);
                this.Refresh();
            },
            storeSettings(newVal, oldVal){
                if(newVal.timeZone && this.timeZone !== newVal.timeZone) {
                    //DON'T
                    /*this.timeZone = newVal.timeZone;
                    let offset = this.$helpers.getMomentTZ().tz(newVal.timeZone).utcOffset();
                    this.timeFrameStart.utcOffset(offset);
                    */
                }
            },
        },
        created() {
            if(this.rosterFromTo != null){
                let startDate = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
                this.onDatePicked(startDate, 'M', 24);
            } else {
                this.onDatePicked(this.$helpers.getCurrentMonthMomentTZ(), 'M', 24);
            }



            window.employeepreference = this;


        },
        mounted() {
            this.Refresh();
        },
        updated(){
            if($(this.$el).find('.group').length > 0)$(this.$el).find('.time-marks').css({'height': ($(this.$el).find('.group').last()[0].getBoundingClientRect().bottom - 50) + 'px'});
        },
        beforeDestroy(){
            if(this.$refs.weatherpopup && this.$refs.weatherpopup.$el) $(this.$refs.weatherpopup.$el).remove();

            if(this.$refs.filterpopup && this.$refs.filterpopup.$el) $(this.$refs.filterpopup.$el).remove();
            if(this.$refs.eventhover && this.$refs.eventhover.$el) $(this.$refs.eventhover.$el).remove();
        },
        methods: {
            OpenPreferenceButtonMenu($event, employee, spot){
                let view = this;
                view.$helpers.OpenButtonContainer([
                    {color: '#6d8d23', icon: 'fa-plus', label: this.$t('global.ui.add'), click: () => { view.OpenNewPreferencePopup($event, employee, spot) }},


                ], { elRelative: $event.currentTarget, offsetx: 5, offsety: -10, closeOnSelect: true })

            },
            OpenMenuDetails($event, state){
                let view = this;

                this.$helpers.OpenPopup({
                    type: 'burgermenu',
                    componentState: state,
                    listStyle: true,
                    noScroll: true,
                    pointerDirection: 0,
                    elRelative: $event.currentTarget,
                    pointerOffset: -15,
                });
            },
            OpenEventHover($event, day){
                let events = [];
                let dateKey = day.format('YYYY-MM-DD');
                if(this.storeEventMomentMap[dateKey] && this.storeEventMomentMap[dateKey].length > 0){
                    for (let i in this.storeEventMomentMap[dateKey]) {
                        let event = this.storeEventMomentMap[dateKey][i];
                        if(event.federalHoliday){
                            let myEvent = {'name' : event.name, 'color' : "rgb(229, 196, 32)"};
                            events.push(myEvent);
                        }else{
                            let myEvent = {'name' : event.name, 'color' : "rgb(137, 197, 232)"};
                            events.push(myEvent);
                        }
                    }
                    this.$refs.eventhover.Init($event.currentTarget,events);
                }
            },
            GetContrastingColor(hex, lightcolor = 'white', darkcolor = '#444444') {
                return this.$helpers.GetContrastingColor(hex, lightcolor, darkcolor);
            },
            CloseEventHover(){
                this.$refs.eventhover.Close();
            },
            GetEventsColor(day){
                let styles = {};
                let color = "rgba(255, 255, 255, 0)";

                let dateKey = day.format('YYYY-MM-DD');
                if(this.storeEventMomentMap[dateKey] && this.storeEventMomentMap[dateKey].length > 0){
                    color = "rgb(137, 197, 232)";
                    styles["left"] = '';
                    let event = this.storeEventMomentMap[dateKey][0];
                    if(event.federalHoliday) {
                        color = "rgb(229, 196, 32)";
                        styles["left"] = 'calc(100% - 12px)';
                        //color = this.storeEventMap[event.id].color;
                    } else {

                        styles["left"] = '3px';
                    }
                }
                styles["color"] = color;
                return styles;
            },
            loadStoreEvents: function(storeId, rosterFromTo) {
                let url = '/api/sec/storeevent';

                let params = {
                    storeId: storeId,
                    active: true,
                    from: rosterFromTo.from,
                    to: rosterFromTo.to
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                });
            },
            HasEventsOnThatDay(day){
                let dateKey = day.format('YYYY-MM-DD');
                return this.storeEventMomentMap[dateKey] && this.storeEventMomentMap[dateKey].length > 0;
            },
            GetWidthFirstTitle(){
                let width = 100;
                if(this.displayedTimeframeSelected.divisions === 36) width = 66.6666;
                if(this.displayedTimeframeSelected.divisions === 48) width = 50;
                width += '%';
                return width;
            },
            GetWidthSecondTitle(){
                let width = 100;
                if(this.displayedTimeframeSelected.divisions === 36) width = 66.6666;
                if(this.displayedTimeframeSelected.divisions === 48) width = 50;
                width = 100 - width;
                width += '%';
                return width;
            },
            isTimeFrameVisible(timeFrame){
                if(timeFrame.preference.state != 1){
                    return this.filterDropdownOptions.find(o => o.state && o.state.id === timeFrame.preference.state && o.toggled) != null;
                } else {
                    return this.filterDropdownOptions.find(o => o.type && o.type.id === timeFrame.preference.type && o.toggled) != null;
                }

            },
            isVacationBanVisible(vacationban){
                if(vacationban.type == 1){
                    return vacationban.active && this.filterDropdownOptions.find(o => o.vacationban && o.toggled) != null;
                } else {
                    return vacationban.active && this.filterDropdownOptions.find(o => o.wishban && o.toggled) != null;
                }

            },

            RecalculatePreviousMonthWorkbalances() {
                let view = this;
                let employeeIds = [];
                for(let i in this.employees){
                    employeeIds.push(this.employees[i].id);

                }

                let yearDate = this.$helpers.getMomentFromValuesUTC(this.rosterFromTo.year, this.rosterFromTo.month, 2)

                view.loading= true;
                view.loadingText =this.$t('pref.main.updateMonthEndClosings')
                return this.$refs.employeeworkbalancecreation.recalculatePastInvalid(yearDate, employeeIds).then(res => {
                    view.loading = false;
                    view.loadingText =""
                    return new Promise((accept, resolve) => {
                        accept(true);
                    })
                }).catch(error => {
                    view.loading = false;
                    view.loadingText =""
                    console.log(error);
                    return new Promise((accept, resolve) => {
                        accept(false);
                    })
                });
            },
            getCalculatedEntitlementForEmployee(employeeId){

                //TODO: Replace with computed property because function is called for ALL employees everytime mouseover switches
                //Done except map cause computed aren't entirely predictable for element refresh
                let view = this;
                let employee = this.groupedEmployeeMap[employeeId];
                let curMonthVacation = 0;
                let currentContract = this.employeeMainContractMap[employeeId]
                let workDays = currentContract ? currentContract.workDays : this.storeSettings.workDays;
                if(employee && employee.timeFrames){
                     employee.timeFrames.forEach((timeFrame) => {
                        let preference = timeFrame.preference;
                        if(preference.type == 1 && (preference.approved || this.countUnapprovedVacation)){

                            let days = [];

                            let startDay = view.$helpers.GetMomentDayNumberFromUnixEpoch(timeFrame.fromDate);
                            let startDayMoment = timeFrame.fromDate;
                            let endDay = view.$helpers.GetMomentDayNumberFromUnixEpoch(timeFrame.toDate);
                            let endDayMoment = timeFrame.toDate;

                            if(timeFrame.fromDate < view.timeFrameStart.clone().startOf('month')) {
                                startDayMoment = view.timeFrameStart.clone().startOf('month');
                                startDay = view.$helpers.GetMomentDayNumberFromUnixEpoch(view.timeFrameStart.clone().startOf('month'));
                            }
                            if(timeFrame.toDate > view.timeFrameEnd) {
                                endDayMoment = view.timeFrameEnd;
                                endDay = view.$helpers.GetMomentDayNumberFromUnixEpoch(view.timeFrameStart.clone().endOf('month').add(1, 'days').startOf('day'));
                            }

                            if(!view.dayOfYearIsoWeekdayMap[startDay]) view.dayOfYearIsoWeekdayMap[startDay] = timeFrame.fromDate.isoWeekday();

                            for(let currentDay = startDay; currentDay <= endDay; currentDay++){
                                if(!view.dayOfYearIsoWeekdayMap[currentDay]) {
                                    view.dayOfYearIsoWeekdayMap[currentDay] = (view.dayOfYearIsoWeekdayMap[startDay] + (currentDay - startDay)) % 7;
                                    if(view.dayOfYearIsoWeekdayMap[currentDay] === 0) view.dayOfYearIsoWeekdayMap[currentDay] = 7;
                                }
                                if(!this.dayOfYearDateKeyMap[currentDay]) this.dayOfYearDateKeyMap[currentDay] = timeFrame.fromDate.clone().add(currentDay - startDay, 'days').format('YYYY-MM-DD');

                                let dateKey = this.dayOfYearDateKeyMap[currentDay];
                                if(!this.storeEventMomentMap[dateKey] || this.storeEventMomentMap[dateKey].length == 0 || !this.storeEventMomentMap[dateKey].find(e => e.federalHoliday) || preference.alwaysWork){
                                    days.push(currentDay);
                                }
                            }
                            let check = false;

                            days.forEach(d => {



                                let weekday = view.dayOfYearIsoWeekdayMap[d];
                                if(workDays.find(wd => wd === weekday || preference.alwaysWork)){
                                    if(d !== startDay && d !== endDay){

                                        curMonthVacation++;

                                    } else if(d === startDay && d === endDay) {

                                        curMonthVacation += (endDayMoment._d.getTime() - startDayMoment._d.getTime()) / (24 * 60 * 60 * 1000);

                                    } else if(d === startDay) {

                                        curMonthVacation += (startDayMoment.clone().endOf('day')._d.getTime() - startDayMoment._d.getTime()) / (24 * 60 * 60 * 1000);

                                    } else if(d === endDay) {

                                        curMonthVacation += (endDayMoment._d.getTime() - endDayMoment.clone().startOf('day')._d.getTime()) / (24 * 60 * 60 * 1000);

                                    }
                                }
                            });


                        }
                    });
                }

                if(this.employeeIdWorkBalanceMap[employeeId]){
                    let wb = this.employeeIdWorkBalanceMap[employeeId];
                    let vacationBalance = wb.vacationTimeBalance;



                    return this.$t('workBalance.summary.vacation') + ": " + curMonthVacation.toFixed(2) + "/" + (((vacationBalance + wb.vacationTime) / 60 / 24) - curMonthVacation).toFixed(2);
                } else {
                    return this.$t('workBalance.summary.vacation') + ": " + curMonthVacation.toFixed(2)
                }

            },
            toggleDatePicker($event) {
                let view = this;
                let date = this.dateSelectionStart;

                this.$helpers.OpenDatepickerPopup(
                    {viewsEnabled: ['M', 'D'], selectedTab: this.displayedTimeframeSelected.label, date: date, hourlyEnabled: true, hourlySelection: [12, 24, 36], hourlySelected: view.hourlySelection},
                    {
                        OnDateSelect: (date) => {

                        },
                        OnMonthSelect: (date) => {
                            view.onDatePicked(date, 'M');
                        },
                        OnDaySelect: (date, hours) => {
                            view.onDatePicked(date, 'D', hours);
                        },
                        OnYearSelect:  (date) => {
                            view.onDatePicked(date, 'Y');
                        }
                    }, {elRelative: $event.currentTarget});
            },


            onDatePicked(date, timeFrameType, hours = 24){
                this.hourlySelection = hours;
                let before = this.timeFrameStart.clone();
                if(timeFrameType === 'Y'){
                    this.timeFrameStart = date.clone().startOf('year');
                } else if(timeFrameType === 'M'){
                    this.timeFrameStart = date.clone().startOf('month');
                } else {
                    this.timeFrameStart = date.clone().startOf('day');
                }

                if(before.month() != this.timeFrameStart.month() || before.year() != this.timeFrameStart.year()){
                    //month / year change => trigger reload
                    let rosterDate = this.timeFrameStart.clone().startOf('month');
                    this.setDateSelection(rosterDate, true);
                } else {
                    this.setDateSelection(this.timeFrameStart, !this.rosterFromTo);
                }
                let displayTimeFrame;
                if(timeFrameType === 'Y'){
                    displayTimeFrame = {label: 'Y', length: this.$helpers.getMomentTZ().month(11).date(31).dayOfYear() * 24 * 60 * 60 * 1000, divisions: 12, timeStart: this.timeFrameStart.clone().month(0).date(1)};
                } else if (timeFrameType === 'M'){
                    displayTimeFrame = {label: 'M', length: this.timeFrameStart.daysInMonth() * 24 * 60 * 60 * 1000, divisions: this.timeFrameStart.daysInMonth(), timeStart: this.timeFrameStart.clone().date(1)};
                } else {
                    displayTimeFrame = {label: 'D', length: hours * 60 * 60 * 1000, divisions: hours, timeStart: this.timeFrameStart.clone()};
                }
                this.displayedTimeframes = [displayTimeFrame];
                this.timeFrameLength = displayTimeFrame.length;
                this.timeFrameEnd = this.timeFrameStart.clone().add(this.timeFrameLength, 'milliseconds');
                this.displayedTimeframeSelected = displayTimeFrame;


                this.$forceUpdate();

            },
            SelectDay(day){
                this.onDatePicked(day.moment, 'D', 36);
            },

            SelectToday(){
                let date = this.$helpers.getMomentTZ();
                this.onDatePicked(date, 'D', 36);

            },
            SelectPreviousDate(){
                if(this.displayedTimeframeSelected.label === 'M'){
                    let date = this.timeFrameStart.clone().add(-1, 'month');
                    this.onDatePicked(date, 'M', 24);
                } else if(this.displayedTimeframeSelected.label === 'Y'){
                    let date = this.timeFrameStart.clone().add(-1, 'year');
                    this.onDatePicked(date, 'Y', 24);
                } else {
                    let date = this.timeFrameStart.clone().add(-1, 'day');
                    this.onDatePicked(date, 'D', this.displayedTimeframeSelected.divisions);
                }


            },
            SelectNextDate(){
                if(this.displayedTimeframeSelected.label === 'M'){
                    let date = this.timeFrameStart.clone().add(1, 'month');
                    this.onDatePicked(date, 'M', 24);
                } else if(this.displayedTimeframeSelected.label === 'Y'){
                    let date = this.timeFrameStart.clone().add(1, 'year');
                    this.onDatePicked(date, 'Y', 24);
                } else {
                    let date = this.timeFrameStart.clone().add(1, 'day');
                    this.onDatePicked(date, 'D', this.displayedTimeframeSelected.divisions);
                }

            },
            setDateSelection(date, calculateRosterFromTo){
                let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
                this.dateSelectionStart = fixedDate;

                this.currentDate = date.date();
                this.currentMonth = date.month();
                this.currentYear = date.year();
                //if(this.displayedTimeframeSelected.label === 'D') this.displayedTimeframeSelected.timeStart = date.clone();

                if(calculateRosterFromTo){
                    //update vuex store with calculated from to => triggers reload of data via refresh

                    let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
                    this.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
                } else {
                    //dont update vuex from to, only update client side view
                }
            },

            GetDailyIndicatorBarWidth(date){
                let format = date.format('YYYY-MM-DD');
                if(!this.planningIndicator[format] || !this.planningIndicator[format].planned || !this.planningIndicator[format].actual) return 'calc(0% - 10px)';
                let length = (this.planningIndicator[format].actual.sumAmount / this.planningIndicator[format].planned.sumAmount) * 100;
                if(length > 100) length = 100;
                let ratio = (this.planningIndicator[format].actual.sumAmount / this.planningIndicator[format].planned.sumAmount);
                let margin = 10 * ratio;
                return 'calc(' + length + '% - ' + margin + 'px)';
            },
            RefreshPlanningIndicator(){
                let view = this;
                view.loadPlanningIndicatorTypes().then(response => {
                    view.planningIndicatorTypeMap = {};
                    response.data.forEach(ind => view.planningIndicatorTypeMap[ind.id] = ind);
                    view.loadPlanningIndicator()
                    .then(response => {
                        view.planningIndicator = {};
                        view.AddPlanningIndicator(response.data, false);
                        view.loadPlanningIndicatorPlanned()
                            .then(response => {
                                view.AddPlanningIndicator(response.data, true);
                                view.$forceUpdate();
                            }).catch(function (error) {
                            console.log(error)
                        })
                    })
                }).catch(function (error) {
                    console.log(error)
                })
            },

            AddPlanningIndicator(indicators, planned){
                let view = this;
                for(let x in indicators){
                    (function(indicator){
                        if(!view.planningIndicator[indicator.date]) view.planningIndicator[indicator.date] = {};
                        if(planned) view.planningIndicator[indicator.date].planned = indicator;
                        if(!planned) view.planningIndicator[indicator.date].actual = indicator;
                        indicator.dateMoment = view.$helpers.getMomentFromStringTZ(indicator.date, 'YYYY-MM-DD');
                    })(indicators[x]);
                }
            },
            loadPlanningIndicator : function() {

                let url = '/api/sec/planningindicator/grouped';

                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.$helpers.getMomentTZ().year(this.currentYear).startOf('year').startOf('isoWeek').format(),
                    to: this.$helpers.getMomentTZ().year(this.currentYear).endOf('year').add(1, 'weeks').startOf('isoWeek').format(),
                    planned: false
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })

            },
            loadPlanningIndicatorTypes : function() {

                let url = '/api/sec/planningindicatortype';

                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planningindicatortype');


                return this.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })

            },
            loadPlanningIndicatorPlanned : function() {

                let url = '/api/sec/planningindicator/grouped';

                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.$helpers.getMomentTZ().year(this.currentYear).startOf('year').startOf('isoWeek').format(),
                    to: this.$helpers.getMomentTZ().year(this.currentYear).endOf('year').add(1, 'weeks').startOf('isoWeek').format(),
                    planned: true
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })


            },
            GetIndicatorAmountWrapper(date){
                let view = this;
                return () => {
                    return view.GetIndicatorAmount(date)
                };
            },
            GetIndicatorAmount(date){
                let format = date.format('YYYY-MM-DD');
                let indicator = this.planningIndicator[format];
                let amount = '-/-';
                if(indicator){
                    let fractional = .01;
                    if(indicator.actual) fractional = this.planningIndicatorTypeMap[indicator.actual.typeId].fractional;
                    else if(indicator.planned) fractional = this.planningIndicatorTypeMap[indicator.planned.typeId].fractional;
                    if(indicator.actual && indicator.planned) amount = (indicator.actual.sumAmount/Math.pow(10, fractional)).toFixed(2)  + '/' + (indicator.planned.sumAmount/Math.pow(10, fractional)).toFixed(2);
                    if(!indicator.actual && indicator.planned) amount = '-/' + (indicator.planned.sumAmount/Math.pow(10, fractional)).toFixed(2);
                    if(indicator.actual && !indicator.planned) amount = (indicator.actual.sumAmount/Math.pow(10, fractional)).toFixed(2) + '/-';
                }
                return amount;
            },
            GetWeatherIcon(MMDD){
                let weather = this.GetWeatherFromDateFormat(MMDD);
                let code = weather.weatherCode;
                if(code === 'Warnung') code = weather.dWeatherCode;
                return '../img/' + code + '.svg';

            },
            GetWeatherTemp(MMDD){
                let weather = this.GetWeatherFromDateFormat(MMDD);
                if(weather && weather.dTemp !== -273) return weather.dTemp;
                return '- ';

            },
            saveWeatherFromDateFormat(day){
                return this.rawWeatherData.find(d => d.date.format('MM-DD') === day.moment.format('MM-DD') && !isNaN(d.dTemp));
            },
            GetWeatherFromDateFormat(MMDD){
                return this.rawWeatherData.find(d => d.date.format('MM-DD') === MMDD && !isNaN(d.dTemp));
            },
            OpenWeatherPopup($event, day, dontClose){
                if(!this.rawWeatherData.find(d => d.date.date() === day.date())) return;
                this.$refs.weatherpopup.Init({
                    date: day,
                    data: this.rawWeatherData.slice(),
                    elRelative: $event.currentTarget,
                    dontClose: dontClose,
                });
            },
            CloseWeatherPopup($event){
                if(!this.$refs.weatherpopup.dontClose) this.$refs.weatherpopup.toggled = false;
            },
            GetWeatherCode(id){
                switch (id){
                    case 201: // thunderstorm with rain
                    case 202: // thunderstorm with heavy rain
                    case 211: // thunderstorm
                    case 212: // heavy thunderstorm
                    case 221: // ragged thunderstorm
                    case 230: // thunderstorm with light drizzle
                    case 231: // thunderstorm with drizzle
                    case 232: // thunderstorm with heavy drizzle
                    case 233: // thunderstorm with hail
                        return "Thunderstorm_Rain";
                    case 200: // thunderstorm with light rain
                    case 210: // light thunderstorm
                        return "Thunderstorm";
                    case 300: // light intensity drizzle
                    case 301: // drizzle
                    case 302: // heavy intensity drizzle
                    case 310: // light intensity drizzle rain
                    case 311: // drizzle rain
                    case 312: // heavy intensity drizzle rain
                    case 313: // shower rain and drizzle
                    case 314: // heavy shower rain and drizzle
                    case 321: // shower drizzle
                    case 520: // light intensity shower rain
                    case 521: // shower rain
                    case 522: // heavy intensity shower rain
                    case 531: // ragged shower rain
                        return "Rain_Medium";
                    case 500: // light rain
                    case 501: // moderate rain
                    case 502: // heavy intensity rain
                    case 503: // very heavy rain
                    case 504: // extreme rain
                        return "Sun_Rain";
                    case 511: // freezing rain
                        return "Snow_Rain";
                    case 600: // light snow
                    case 601: // Snow
                    case 602: // Heavy snow
                    case 610: // Mix snow/rain
                    case 611: // Sleet
                    case 612: // Light shower sleet
                    case 613: // Shower sleet
                    case 615: // Light rain and snow
                    case 616: // Rain and snow
                    case 620: // Light shower snow
                    case 621: // Shower snow
                    case 622: // Heavy shower snow
                    case 623: // Flurries
                        return "Snow_Medium";
                    case 700: // mist
                    case 701: // mist
                    case 711: // Smoke
                    case 721: // Haze
                    case 731: // sand/ dust whirls
                    case 741: // fog
                    case 751: // sand
                    case 761: // dust
                    case 762: // volcanic ash
                    case 771: // squalls
                    case 781: // tornado
                        return "Fog";
                    case 800: // clear sky
                        return "Sunny";
                    case 801: // few clouds: 11-25%
                        return "Little_Cloudy";
                    case 802: // scattered clouds: 25-50%
                        return "Cloudy_Medium";
                    case 803: // broken clouds: 51-84%
                    case 804: // overcast clouds: 85-100%
                        return "Very_Cloudy";
                    case 900: // Unknown Precipitation
                        return "Warnung";
                    default:
                        return "Warnung";
                }
            },
            GetWeather(){
                let view = this;
                view.rawWeatherData = [];
                view.weather.data = [];
                let url = '/api/sec/weather';
                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.$store.state.rosterFromTo.from,
                    to: this.$store.state.rosterFromTo.to
                };
                //url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/weather');
                //url = this.$helpers.appendParam("from", this.$store.state.rosterFromTo.from, url, '/api/sec/weather');
                //url = this.$helpers.appendParam("to", this.$store.state.rosterFromTo.to, url, '/api/sec/weather');

                this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    for(let x in response.data){
                        (function(data){
                            view.rawWeatherData.push(data);
                            let last = view.rawWeatherData[view.rawWeatherData.length - 1];
                            last.date = view.$helpers.getActualMoment().unix(data.dt);

                            // 3HOURLY DATA - START
                            last.temp = Math.round(data.temp - 273.15);
                            last.tempMin = Math.round(data.tempMin - 273.15);
                            last.tempMax = Math.round(data.tempMax - 273.15);
                            last.humidity = data.humidity;
                            last.windspeed = data.windspeed;
                            //last.pop = data.pop; //The 3hourly weather API does not return the Prob of Precipitation. But it returns the rain in millimeters. We need a workaround to calculate some kind of percentage from the mm information.
                            last.weatherCode = view.GetWeatherCode(data.weatherId);
                            // 3HOURLY DATA - END


                            // DAY DATA - START
                            last.dTemp = Math.round(data.dTemp - 273.15);
                            last.dMinTemp = Math.round(data.dMinTemp - 273.15);
                            last.dMaxTemp = Math.round(data.dMaxTemp - 273.15);
                            last.dPop = data.dProbOfPrecipitation;
                            last.dHumidity = data.dHumidity;
                            last.dWindSpd = Math.round(data.dWindSpd * 3.6);
                            last.dWeatherCode = view.GetWeatherCode(data.dWeatherCode);
                            // DAY DATA - END

                            if(last.date.date() >= view.$helpers.getMomentTZ().date() && !view.weather.data.find(d => d.date.date() === last.date.date()))
                            {
                                let hasDTemp = view.rawWeatherData.find(d => d.date.date() == last.date.date() && d.dTemp);
                                if(hasDTemp) view.weather.data.push(hasDTemp);
                                else view.weather.data.push(last);
                            }
                            //console.log(last.date.format('LLLL'));
                        })(response.data[x]);

                    }
                }).catch(function (error) {
                    //TODO error handling
                })
            },
            CheckLabelLength($event){
                var el = $event.currentTarget;
                var box = el.getBoundingClientRect();
                var boxlabel = el.querySelector('.label').getBoundingClientRect();
                if(boxlabel.width > box.width) el.classList.add('show-under');
                else el.classList.remove('show-under');
            },
            IsParentCollapsed(group){
                return !this.groupCollapsedStates[group.spot.parentId];
            },
            IsCollapsed(indexGroup){
                var group = this.employeeGroups[indexGroup];
                var collapsed = false;
                collapsed = this.groupCollapsedStates[group.spot.id];
                if(this.draggingGroup) collapsed = true;
                return collapsed;
            },
            ToggleCollapseState(group){
                this.groupCollapsedStates[group.spot.id] = !this.groupCollapsedStates[group.spot.id];
                this.$forceUpdate();
            },

            Refresh(force = false){
                console.log("Refresh called")
                if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined && !this.loading){
                    var view = this;
                    this.loading = true;
                    view.$store.commit("setAllowContentSwitch", {allowContentSwitch: false});


                    this.RefreshPlanningIndicator();
                    this.$helpers.GetHolidayMap();
                    this.GetWeather();
                    let employeePayload = {ids: []};
                    let employeeRemoteIds = [];

                    this.$helpers.GetUiDataMap(force).then(uiData=> {
                        view.updateUIData(uiData);
                        return view.loadStoreEvents(view.storeSettings.id, view.rosterFromTo)


                    }).then(response => {
                        view.storeEventMap = {};
                        view.storeEventMomentMap = {};
                        response.data.forEach(e => {
                            view.storeEventMap[e.id] = e;
                            let date = view.$helpers.getMomentFromStringTZ(e.from);
                            let dateKey = date.format('YYYY-MM-DD');
                            if(!view.storeEventMomentMap[dateKey]) view.storeEventMomentMap[dateKey] = [];
                            view.storeEventMomentMap[dateKey].push(e);
                        });
                         return view.$helpers.GetEmployeeMap(force);
                    }).then(response => {
                        view.employees = [];
                        for(let i in this.employeeMap){
                            let employee = this.employeeMap[i];
                            if(employee.active){
                                employeePayload.ids.push(employee.id);
                                view.employees.push(employee);
                            }
                            if(employee.remoteId != null && employee.active){
                                employeeRemoteIds.push(employee.remoteId);
                            }
                        }
                        if(view.storeSettings.useAvgWorkTimeForPrefs){
                            return view.$helpers.GetAvgEmployeeWorktimeMap(employeeRemoteIds, force)
                        } else {
                            return new Promise((accept, resolve) => {
                                accept(true);
                            })
                        }


                    }).then(response => {
                        return view.$helpers.GetSkillMap(force);
                    }).then(response => {
                        view.skillVisibilityList = [];
                        view.skills = Object.values(this.skillMap);

                        return view.$helpers.GetEmployeeContractMap(force)

                    }).then(response => {

                        return view.$helpers.GetEmployeeSkillMapForEmployees(employeePayload, force);
                    }).then(response => {
                        view.employeeSkills = Object.values(this.employeeSkillMap);

                        return view.$helpers.GetEmployeePreferenceMap(force);
                    }).then(response => {
                        view.preferences = Object.values(this.employeePreferenceMap);
                        return  view.$helpers.GetBusinessUnitMap(force);
                    }).then(response => {
                        view.businessUnits = Object.values(this.businessUnitMap);

                        return view.$helpers.GetSpotMap(force);
                    }).then(response => {
                        view.spots = Object.values(this.spotMap);
                        view.spots.push({id: null, unitId: null, name: this.$t('indicator.eval.notAssigned'), isMain: true});
                        view.customSpotMap = {};
                        view.spots.forEach(s => view.customSpotMap[s.id] = s);


                        return view.$helpers.GetUserUnitSort(force);


                    }).then(response => {
                        view.updateUserUnitSort(Object.values(this.userUnitSortMap));

                        view.spots.forEach(s => {
                            let unitsort = view.userunitsort.find(u => u.unitId === s.id);
                            if(unitsort != null) {
                                unitsort.name = s.name;
                            }
                        });

                        view.SortSpotsByPriority();


                        view.spotVisibilityList = [];
                        view.groupCollapsedStates = {};
                        view.spots.forEach(s => {
                            view.spotVisibilityList.push(s);
                            view.groupCollapsedStates[s.id] = false;
                        });
                        view.groupCollapsedStates['All'] = false;
                        view.LoadFilterDropdown();
                        //view.LoadGroupsBySpots();

                    }).then(response => {
                        return view.RecalculatePreviousMonthWorkbalances();
                    }).then(response => {

                        return view.$helpers.GetCurrentMonthEmployeeWorkbalanceMapForEmployees(employeePayload, true);
                        //return view.$helpers.GetPreviousMonthEmployeeWorkbalanceMapForEmployees(employeePayload, force)
                    }).then(response => {
                      view.loadVacationBans();
                    }).then(response => {
                        employeePayload.ids.forEach(id => view.calculatedEntitlementEmployeeMap[id] = view.getCalculatedEntitlementForEmployee(id));
                        view.loading = false;
                        view.$store.commit("setAllowContentSwitch", {allowContentSwitch: true});

                        requestAnimationFrame(function(){
                                view.$forceUpdate();
                        });
                    }).catch(function (error) {
                        view.loading = false;
                        view.$store.commit("setAllowContentSwitch", {allowContentSwitch: true});
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                        console.log(error)
                    });
                }

            },


            GetGroupClasses(group, indexGroup){
                return {
                    'sub-spot': group.spot && !group.spot.isMain && group.spot.id,
                    'group-null': !group.spot || !group.spot.id,
                    'group-dragged': group === this.draggingGroup,
                    'show-drag-area': this.draggingGroup && this.draggingGroup.spot && group.spot &&                                              // make sure you're dragging and the spots are set
                        ((this.draggingGroup.spot.isMain && group.spot.isMain) ||                                                                 // if you're dragging a main group then the subgroups shouldn't show their drag areas
                        (!this.draggingGroup.spot.isMain && !group.spot.isMain && group.spot.unitId == this.draggingGroup.spot.unitId && group.spot)), // if you're dragging a subgroup then only show the drag areas of the same parent
                    'show-drag-area-last': this.draggingGroup && (indexGroup === this.employeeGroups.length - 1 ||                                     // this is for dragging in front of a group but only the last one should have it
                                                                                                                                                       // but for subgroups we have to get the last subgroup which I'll do by asking if the next one is a main group (wip)
                        (!this.draggingGroup.spot.isMain && this.draggingGroup !== group && group.spot.unitId === this.draggingGroup.spot.unitId && indexGroup + 1 !== this.employeeGroups.length && this.employeeGroups[indexGroup + 1].spot.isMain))}
            },
            DragStartBusinessUnit: function ($event, employeeGroup,indexGroup){
                var view = this;
                setTimeout(function(){
                    if(!window.mouse.click) return;

                    //view.groupCollapsedStates = {};
                    //view.employeeGroups.forEach(g => view.groupCollapsedStates[g.spot.id] = g.collapsed);

                    for(let x in view.employeeGroups){
                        view.employeeGroups[x].collapsed = true;
                        if(view.employeeGroups[x].spot == null || view.employeeGroups[x].spot.id === employeeGroup.spot.id){
                            view.employeeGroups[x].show = false;
                        }else{
                            view.employeeGroups[x].show = true;
                        }
                    }

                    view.draggingGroup = employeeGroup;
                    view.DragBusinessUnitWatch();
                }, 500);
            },
            DragBusinessUnitWatch(){
                var view = this;
                if($(this.$el).find('.drag-group').length > 0) $(this.$el).find('.drag-group').css({left: (window.mouse.x - ($(this.$el).find('.drag-group')[0].getBoundingClientRect().width * .025)) + 'px', top: (window.mouse.y - ($(this.$el).find('.drag-group')[0].getBoundingClientRect().height * .5)) + 'px'});


                view.$forceUpdate();
                requestAnimationFrame(function(){
                    if(window.mouse.click) view.DragBusinessUnitWatch();
                    else {
                        requestAnimationFrame(function(){
                            view.EndDragBusinessUnit();
                        });
                    }
                });
            },
            EndDragBusinessUnit(){
                var view = this;
                var groups = this.employeeGroups.slice();
                var elementInGroup = $(this.$el).find('.grid > .group .drag-catch-area').toArray().find(e => { //in all the current group drag areas check if the mouse is inside of it
                    var box = e.getBoundingClientRect();
                    return box.left < window.mouse.x && box.right > window.mouse.x && box.top < window.mouse.y && box.bottom > window.mouse.y;
                });
                if(elementInGroup) {
                    var groupDroppedOverIndex = $(elementInGroup).closest('.group').attr('indexgroup');
                    let priorityDragged = view.userunitsort.find(u => u.unitId === view.draggingGroup.spot.id);
                    if(this.employeeGroups[groupDroppedOverIndex] && this.employeeGroups[groupDroppedOverIndex].spot.id) {
                        let priorityDropped = view.userunitsort.find(u => u.unitId === view.employeeGroups[groupDroppedOverIndex].spot.id);


                        if(!priorityDropped || !priorityDragged) {

                            view.draggingGroup = null;
                            return;
                        }

                        let temp = priorityDragged.priority;
                        priorityDragged.priority = priorityDropped.priority;
                        priorityDropped.priority = temp;


                    } else {
                        view.userunitsort.filter(u => u.priority > priorityDragged.priority).forEach(u => u.priority--);
                        priorityDragged.priority = view.userunitsort.length - 1;
                    }

                    this.SendBusinessUnitsPriorityUpdate(view.userunitsort);
                }
                requestAnimationFrame(function() {
                    view.draggingGroup = null;
                });
            },
            GetEmployeesWithWish(){
                let employeeItems = []
                Object.values(this.employeePreferenceMap).forEach(pref => {
                    if(pref.state == 4 && employeeItems.filter(e => e.value == pref.employeeId).length == 0){
                        if(this.employeeMap[pref.employeeId]){
                            let item = {label: this.employeeMap[pref.employeeId].lastName+" "+this.employeeMap[pref.employeeId].firstName, value: pref.employeeId}
                            employeeItems.push(item);
                        }

                    }
                })
                return employeeItems;
            },
            OpenCreateUnavailibilitiesForEmployees(){
                let view = this;
                let employeeitems = this.GetEmployeesWithWish();

                let dataEntries = [
                    {label: this.$tc('global.general.employee'), key: 'employeeIds', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: true, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: employeeitems.map(i => {
                            return {
                                label: i.label,
                                value: i.value,
                               selected: true
                            }
                        }),
                        selectMultiple: true,

                        styleLight: true,
                        placeholder: this.$tc('global.general.employee'),
                    },
                    },

                ];


                this.$helpers.OpenPopup({
                    elRelative: null,
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        selectCallback: function (item) {
                            view.CreateUnavailablitiesForEmployees(item.employeeIds);
                        },
                    },
                    header: this.$t('pref.main.convertIntoAvailabilities'),
                    remainAfterSelect: false,
                    expanded: true,
                    centered: true
                });
            },
            CreateUnavailablitiesForEmployees(employeeIds){


                let startDate = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
                let endDate = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1).add(1, 'months').startOf('month');
                let requests = [];
                employeeIds.forEach(id => {
                    let prefs = this.employeeEmployeePreferenceMap[id] ? this.employeeEmployeePreferenceMap[id] : [];

                    requests = this.generateUnavailableRequests(requests, id, startDate, endDate, prefs);

                })
                if(requests.length > 0){
                    this.createMultipleEmployeePreferences(requests);
                }
            },
            generateUnavailableRequests(requests, employeeId, startDate, endDate, prefs){
                let sortedPrefs = prefs.filter(pref => pref.state == 1 || pref.state == 4).sort((a, b) => this.employeePreferenceMomentMap[a.id].from.unix() - this.employeePreferenceMomentMap[b.id].from.unix());
                let currentFrom = startDate.clone();
                for(let i = 0; i<sortedPrefs.length; i++){
                    let pref = sortedPrefs[i];
                    let from = this.employeePreferenceMomentMap[pref.id].from;
                    let to = this.employeePreferenceMomentMap[pref.id].to;

                    if(currentFrom < from){
                        let payload = {
                            storeId: this.$store.state.storeId,
                            exclusive: true,
                            approved: true,
                            denied: false,
                            state: 1,
                            type: 4,
                            workValue: -1,
                            overrideContract: false,
                            alwaysWork: false,
                            factor: 1,
                            employeeId: employeeId,
                            from: currentFrom,
                            to: endDate < from ? endDate : from,
                        };
                        if(payload.to > payload.from){
                            payload.from = payload.from.format();
                            payload.to = payload.to.format();
                            requests.push(payload);
                        }

                        currentFrom = to;
                    } else if(to > currentFrom){
                        currentFrom = to;

                    }
                }
                if(currentFrom < endDate){
                    let payload = {
                        storeId: this.$store.state.storeId,
                        exclusive: true,
                        approved: true,
                        denied: false,
                        state: 1,
                        type: 4,
                        workValue: -1,
                        overrideContract: false,
                        alwaysWork: false,
                        factor: 1,
                        employeeId: employeeId,
                        from: currentFrom,
                        to: endDate,
                    };
                    if(payload.to > payload.from){
                        payload.from = payload.from.format();
                        payload.to = payload.to.format();
                        requests.push(payload);
                    }
                }
                return requests;
            },
            SelectTimeFrame($event, timeFrame){
                let view = this;
                if(!view.dragging){
                    let labelOptions = [];
                    let timeObject = this.displayedTimeframeSelected;



                    labelOptions.push({text: this.$t('pref.main.confirm'), type: 'block', disabled: timeFrame.preference.approved || timeFrame.preference.locked, click: () => {
                            view.ApproveRequest(timeFrame.preference);
                        }});

                    labelOptions.push({text: this.$t('global.ui.deny'), type: 'block', disabled: timeFrame.preference.locked || timeFrame.preference.denied, click: () => {
                            view.DenyRequest(timeFrame.preference);
                        }});

                    labelOptions.push({text: this.$t('global.ui.edit'), type: 'block', disabled: timeFrame.preference.locked, click: () => {
                            let pref = Object.assign({}, timeFrame.preference);
                            let fromM = view.$helpers.getMomentFromStringTZ(pref.from);
                            let toM = view.$helpers.getMomentFromStringTZ(pref.to);

                            if(timeObject.label=='M' && toM.unix() == toM.clone().startOf('day').unix() && fromM.unix() == fromM.clone().startOf('day').unix()){

                                toM = toM.add(-1, 'days');
                                pref.to = toM.format();
                            }

                            let state = view.GetPreferenceDatafillState(pref);

                            view.$helpers.OpenPopup({
                                type: 'datafill',
                                componentState: state,
                                header: this.$t('global.ui.editX', [this.$tc('global.general.entry')]),
                                expanded: true,
                                centered: true,
                            });
                        }});
                    labelOptions.push({text: this.$t('global.ui.delete'), type: 'block', disabled: timeFrame.preference.locked, click: () => {
                            view.DeleteRequest(timeFrame.preference);
                        }});
                    this.$helpers.OpenListLabel(labelOptions,{allowOverflow: true});
                }

            },
            requestSuccessCallback(preference) {
                return (response) => {
                    let result = response.data.data;
                    let isInMap = this.employeePreferenceMap[preference.id];
                    if (isInMap) {
                        this.$store.commit('setEmployeePreferenceMapEntry', result);
                    }
                    this.$store.commit('deleteEmployeeAllUnapprovedPreferenceMapEntry', result);
                    this.selectedTimeFrame = null;
                    this.$forceUpdate();
                }
            },
            ApproveRequest(preference){
                this.$helpers.approvePreference(preference, this.requestSuccessCallback(preference))
            },
            DenyRequest(preference){
                this.$helpers.denyPreference(preference, this.requestSuccessCallback(preference));
            },
            DeleteRequest(preference){
                let view = this;
                let url = '/api/sec/employeepreference';

                url = this.$helpers.appendParam("id", preference.id, url, '/api/sec/employeepreference');
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');


                this.axios({
                    method: 'delete',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    view.selectedTimeFrame = null;
                    view.preferences = view.preferences.filter(p => p.id !== preference.id);
                    view.$store.commit("deleteEmployeePreferenceMapEntry", {id: preference.id});
                    view.$store.commit("deleteEmployeeAllUnapprovedPreferenceMapEntry", preference);
                    view.calculatedEntitlementEmployeeMap[preference.employeeId] = view.getCalculatedEntitlementForEmployee(preference.employeeId);
                    view.$helpers.success(view.$t('shift.template.deleted'), view.$t('roster.comp.absenceDeleted'));
                    if(view.rosterSortState.showBusinessUnits || view.rosterSortState.showSpots) view.LoadGroupsBySpots();
                    else view.LoadGroupsAllInOne();
                    view.$forceUpdate();
                }).catch(function (error) {
                    view.$helpers.error(view.$t('global.ui.deleteFailed'), view.$t('roster.comp.deleteAbsenceError'));
                })

            },
            EventMouseTrack(){
                if($(window.mouse.element).hasClass('event') || $(window.mouse.element).closest('.event').length > 0){
                    this.mouseX = window.mouse.x;
                    this.mouseY = window.mouse.y + 20;
                    $(this.$el).find('.event-info').css({left: (this.mouseX - ($(this.$el).find('.event-info')[0].getBoundingClientRect().width * .5)) + 'px', top: this.mouseY + 'px'});
                } else {
                    this.eventOnHover = null;
                }

            },
            SortSpotsByPriority(){
                var view = this;
                view.spots.sort(function(a, b){

                    let sortA = view.userunitsort.find(u => u.unitId === a.id);
                    let sortB = view.userunitsort.find(u => u.unitId === b.id);
                    let prioA = sortA ? sortA.priority : a.priority;
                    let prioB = sortB ? sortB.priority : b.priority;
                    if ( prioA < prioB ) return -1;
                    if ( prioA > prioB ) return 1;
                    return a.name.toUpperCase().localeCompare(b.name.toUpperCase());

                });
            },
            SortGroupsByParentUnit(groups){
                var subSpotGroups = groups.filter(g => !g.spot.isMain);
                var nullGroup = groups.find(g => g.spot.isMain && g.spot.id === null);
                groups = groups.filter(g => g.spot.isMain && g.spot.id !== null);
                if(subSpotGroups.length > 0) {
                    subSpotGroups = subSpotGroups.reverse();
                    subSpotGroups.forEach(g => {
                        var parent = groups.find(gm => gm.spot.isMain && gm.spot.unitId === g.spot.unitId);
                        var parentIndex = groups.indexOf(parent) + 1;
                        groups.splice(parentIndex, 0, g);
                    });
                }
                if(nullGroup) groups.push(nullGroup);
                return groups;
            },
            GetColorForType(typeId, approved = true){
                if(typeId === 1) return approved? '#e5c420' : '#dadada'; //vacation
                if(typeId === 2) return approved?'#e5154f': '#dadada'; //sickness
                if(typeId === 3) return approved?'#40eded': '#dadada'; //holiday adjustment
                if(typeId === 4) return approved?'#e51650': '#dadada'; //miscellaneous
                if(typeId === 5) return '#808080'; //no contract
                if(typeId === 6) return approved?'#f99a86': '#dadada'; //nursing vacation
                if(typeId === 7) return approved?'#348feb': '#dadada'; //education
                if(typeId === 8) return approved?'#eb7d34': '#dadada'; //wage continuation

            },
            GetColorForState(stateId, approved = true){
                if(stateId === 1) return  approved? '#e51650': '#dadada'; //unavailable
                if(stateId === 2) return  approved? '#294285': '#dadada'; //only available
                if(stateId === 3) return  approved? '#ff1655': '#dadada'; //undesired
                if(stateId === 4) return  approved? '#aace27': '#dadada'; //desired
            },
            LoadFilterDropdown(){
                var view = this;
                this.filterDropdownOptions = [];
                Object.values(view.employeeAvailabilityTypeMap).filter(type => type.selectable).forEach(function(type){

                        var option = {label: type.label_de, toggled: true, type: type};
                        option.color = view.GetColorForType(type.id);
                        view.filterDropdownOptions.push(option);


                });
                Object.values(view.employeeAvailabilityStateMap).filter(type => type.selectable).forEach(function(state){
                    if(state.id != 1){
                        var option = {label: state.label_de, toggled: true, state: state};
                        option.color = view.GetColorForState(state.id);

                        view.filterDropdownOptions.push(option);
                    }

                });
                this.filterDropdownOptions.push({label: this.$t('pref.main.vacationBan'), toggled: true, vacationban: true, color: "#fec5e5"})
                this.filterDropdownOptions.push({label: this.$t('pref.main.preferenceBan'), toggled: true, wishban: true, color: "#d598fe"})
                this.filterDropdownOptions.push({label: this.$t('global.ui.all'), toggled: true, all: true, color: "#eeeeee"})
            },
            StartDragTimeFrame($event, timeFrame, isStart){
                var view = this;
                this.dragging = true;
                this.draggingStart = isStart;
                this.draggingTimeFrame = timeFrame;
                this.draggingMissingDayStyles = this.GetAlwaysWorkStyle(timeFrame);
                this.draggingTimeInit = isStart ? timeFrame.fromDate.clone() : timeFrame.toDate.clone();
                this.draggingStartPos = {x: window.mouse.x, y: window.mouse.y};
                this.draggingHandle = $event.currentTarget;
                this.DragWatch();
            },
            DragWatch(){
                var view = this;
                var time = view.draggingStart ? view.draggingTimeFrame.fromDate : view.draggingTimeFrame.toDate;
                var timeLimit = !view.draggingStart ? view.draggingTimeFrame.fromDate : view.draggingTimeFrame.toDate;
                if($(this.$el).find('.drag-info').length > 0) $(this.$el).find('.drag-info').css({left: (window.mouse.x - ($(this.$el).find('.drag-info')[0].getBoundingClientRect().width * .5)) + 'px', top: (this.draggingHandle.getBoundingClientRect().top - 45)+ 'px'});
                var totalWidth = $(this.$el).find('.grid').width() - 225;
                var timePixelRatio = totalWidth / this.timeFrameLength;

                var delta = window.mouse.x - this.draggingStartPos.x;
                var deltaTime = this.draggingTimeInit.clone().add(delta / timePixelRatio, 'milliseconds');
                time.year(deltaTime.year());
                time.month(deltaTime.month());
                time.date(deltaTime.date());
                if(this.displayedTimeframeSelected.label === 'D') {
                    time.hours(deltaTime.hours());
                    if(view.draggingTimeFrame.toDate._d.getTime() - view.draggingTimeFrame.fromDate._d.getTime() < (60 * 60 * 1000)) {
                        if(time === view.draggingTimeFrame.fromDate) view.$helpers.SetMomentTimeFromMoment(time, timeLimit).add(-1, 'hours');
                        else view.$helpers.SetMomentTimeFromMoment(time, timeLimit).add(1, 'hours');
                    }
                } else {
                    if(view.draggingTimeFrame.toDate._d.getTime() - view.draggingTimeFrame.fromDate._d.getTime() < (24 * 60 * 60 * 1000)) {
                        if(time === view.draggingTimeFrame.fromDate) view.$helpers.SetMomentTimeFromMoment(time, timeLimit).add(1, 'days');
                        else view.$helpers.SetMomentTimeFromMoment(time, timeLimit).add(1, 'days');

                    }
                }

                if(time === view.draggingTimeFrame.fromDate) {
                    view.draggingTime = {fromDate: time.clone(), toDate: view.draggingTimeFrame.toDate};
                    view.$helpers.SetMomentTimeFromMoment(view.draggingTimeFrame.fromDate, time);
                } else {
                    view.draggingTime = {fromDate: view.draggingTimeFrame.fromDate, toDate: time.clone()};
                    view.$helpers.SetMomentTimeFromMoment(view.draggingTimeFrame.toDate, time);
                }
                view.draggingMissingDayStyles = view.GetAlwaysWorkStyle(view.draggingTimeFrame);
                //console.log(this.draggingTimeFrame.preference.id);

                time.minutes(0);
                time.seconds(0);
                time.milliseconds(0);

                view.$forceUpdate();
                requestAnimationFrame(function(){
                    if(window.mouse.click) view.DragWatch();
                    else {
                        view.dragging = false;
                        requestAnimationFrame(function(){
                            view.EndDragTimeFrame();
                        });
                    }
                });
            },
            EndDragTimeFrame(){
                let view = this;
                let timeframe = this.draggingTimeFrame;
                this.UpdateEmployeePreferenceTime(this.draggingTimeFrame.preference, this.draggingTime.fromDate, this.draggingTime.toDate, function(response){
                    timeframe.missingDayStyles = view.GetAlwaysWorkStyle(timeframe);
                    view.calculatedEntitlementEmployeeMap[timeframe.preference.employeeId] = view.getCalculatedEntitlementForEmployee(timeframe.preference.employeeId);
                });
            },

            LoadGroupsBySpots(){
                var view = this;
                var collapseStates = {};
                //view.employeeGroups.forEach(g => collapseStates[g.spot.id] = g.collapsed);
                var employeeGroups = [];
                //view.employeeGroups.push({header: 'All', collapsed: false, businessUnit: {}, employees: []});
                view.spots.forEach(function(spot){
                    var group = {header: spot.name, collapsed: view.groupCollapsedStates[spot.id], spot: spot, draggable: false, isMain: spot.isMain};
                    group.employees = [];
                    employeeGroups.push(group);
                });
                view.employees.forEach(function(employee){
                    if(employee.active){
                        var group = employeeGroups.find(g => g.spot.id === employee.spotId);
                        var employeeTemp = {name: employee.lastName + ' ' + employee.firstName, employee: employee};
                        employeeTemp.progressCurrent = 15;
                        employeeTemp.progressMax = 25;
                        employeeTemp.picture = view.GetProfilePictureUrl(employee);
                        employeeTemp.timeFrames = [];
                        employeeTemp.vacationbans = [];

                        view.preferences.filter(p => p.employeeId === employee.id && view.$helpers.getMomentFromStringTZ(p.to) > view.timeFrameSelectedStart && view.$helpers.getMomentFromStringTZ(p.from) < view.timeFrameSelectedEnd).forEach(function(preference){
                            var timeFrame = {preference: preference, fromDate: view.$helpers.getMomentFromStringTZ(preference.from, 'YYYY-MM-DDTHH:mmZ'), toDate: view.$helpers.getMomentFromStringTZ(preference.to, 'YYYY-MM-DDTHH:mmZ')};
                            if(view.AlwaysWorkCheck(timeFrame)) timeFrame.missingDayStyles = view.GetAlwaysWorkStyle(timeFrame);

                            let label = "";
                            if(preference.state != 1 || (preference.state == 1 && preference.type == 4)){
                                if(preference.type == 4 && preference.alwaysWork && preference.comment != null && preference.comment.length > 0){
                                    label = preference.comment;
                                }else{
                                    label = view.employeeAvailabilityStateMap[preference.state].label_de;
                                }
                            } else {
                                label = view.employeeAvailabilityTypeMap[preference.type].label_de;
                            }
                            timeFrame.label = label;
                            employeeTemp.timeFrames.push(timeFrame);
                        });
                        Object.values(view.vacationBanMap).filter(ban => (ban.spotId === employee.spotId || ban.spotId === null) && view.$helpers.getMomentFromStringTZ(ban.to) > view.timeFrameSelectedStart && view.$helpers.getMomentFromStringTZ(ban.from) < view.timeFrameSelectedEnd).forEach(function(vacationban){
                            employeeTemp.vacationbans.push(vacationban);
                        });
                        if(group) {
                            group.employees.push(employeeTemp);
                        }
                        employee.displayData = employeeTemp;
                    }

                });
                employeeGroups.forEach(function(group){
                    group.employees.sort(view.sortEmployeeByName);
                });
                employeeGroups.forEach(function(group){
                    group.employeesFiltered = group.employees.slice();
                });
                return employeeGroups;
            },
            LoadGroupsAllInOne(){
                var view = this;
                var employeeGroups = [];
                //view.employeeGroups.push({header: 'All', collapsed: false, businessUnit: {}, employees: []});
                var group = {header: this.$t('global.ui.allEmployees'), collapse: view.groupCollapsedStates['All'], spot: {spotId: 'All', color: 'white'}};
                group.employees = [];
                employeeGroups.push(group);
                view.employees.forEach(function(employee){
                    if(employee.active){
                        var employeeTemp = {name: employee.lastName + ' ' + employee.firstName, employee: employee};
                        employeeTemp.progressCurrent = 15;
                        employeeTemp.progressMax = 25;
                        employeeTemp.picture = view.GetProfilePictureUrl(employee);
                        employeeTemp.timeFrames = [];
                        employeeTemp.vacationbans = [];

                        view.preferences.filter(p => p.employeeId === employee.id && view.$helpers.getMomentFromStringTZ(p.to) > view.timeFrameSelectedStart && view.$helpers.getMomentFromStringTZ(p.from) < view.timeFrameSelectedEnd).forEach(function(preference){
                            var timeFrame = {preference: preference, fromDate: view.$helpers.getMomentFromStringTZ(preference.from, 'YYYY-MM-DDTHH:mmZ'), toDate: view.$helpers.getMomentFromStringTZ(preference.to, 'YYYY-MM-DDTHH:mmZ')};
                            if(view.AlwaysWorkCheck(timeFrame)) timeFrame.missingDayStyles = view.GetAlwaysWorkStyle(timeFrame);

                            let label = "";
                            if(preference.state != 1 || (preference.state == 1 && preference.type == 4)){
                                label = view.employeeAvailabilityStateMap[preference.state].label_de;
                            } else {
                                label = view.employeeAvailabilityTypeMap[preference.type].label_de;
                            }
                            timeFrame.label = label;
                            employeeTemp.timeFrames.push(timeFrame);
                        })
                        Object.values(view.vacationBanMap).filter(ban => (ban.spotId === employee.spotId || ban.spotId === null) && view.$helpers.getMomentFromStringTZ(ban.to) > view.timeFrameSelectedStart && view.$helpers.getMomentFromStringTZ(ban.from) < view.timeFrameSelectedEnd).forEach(function(vacationban){
                        employeeTemp.vacationbans.push(vacationban);
                        });
                        group.employees.push(employeeTemp);
                        employee.displayData = employeeTemp;
                    }

                });
                employeeGroups.forEach(function(group){
                    group.employees.sort(view.sortEmployeeByName);
                });
                employeeGroups.forEach(function(group){
                    group.employeesFiltered = group.employees.slice();
                });
                return employeeGroups;
            },
            calculateWorkValueForPref(pref, overridePrefFrom = null, overridePrefTo = null){
                let workValue = 0;

                if (pref.state == 1) {
                    let currentContract = this.employeeMainContractMap[pref.employeeId]
                    let workDays = currentContract ? currentContract.workDays : this.storeSettings.workDays;

                    let baseWorkValue = pref.workValue;
                    let prefFrom = this.$helpers.getMomentFromStringTZ(pref.from);
                    let prefTo = this.$helpers.getMomentFromStringTZ(pref.to);


                    let prefStart = prefFrom.clone();
                    let employee = this.employeeMap[pref.employeeId];
                    let mainContract = this.employeeMainContractMap[pref.employeeId]
                    let dayTimeRegular =  mainContract != null ? Math.round((mainContract.weekTimeRegular / mainContract.weekWorkDaysRegular)) : 9 * 60;
                    if (employee.remoteId && this.employeeAvgWorktimeMap[employee.remoteId] && this.storeSettings.useAvgWorkTimeForPrefs) {
                        dayTimeRegular = this.employeeAvgWorktimeMap[employee.remoteId].averageMinutes;
                    }
                    let alwaysWork = pref.alwaysWork;

                    while (prefStart < prefTo) {
                        //step through day, and check interval
                        let endOfDay = prefStart.clone().add(1, 'days').startOf('day');
                        let checkEnd = endOfDay < prefTo ? endOfDay : prefTo;
                        if (checkEnd.utcOffset() != prefStart.utcOffset()) {
                            checkEnd = checkEnd.clone().utcOffset(prefStart.utcOffset(), true);
                        }
                        let diff = checkEnd.diff(prefStart, 'minutes');



                        let ratioFrom = prefStart < this.currentMonthFromTZ ? this.currentMonthFromTZ : (prefStart > this.currentMonthToTZ ? this.currentMonthToTZ : prefStart);
                        let ratioTo = checkEnd > this.currentMonthToTZ ? this.currentMonthToTZ : (checkEnd < this.currentMonthFromTZ ? this.currentMonthFromTZ : checkEnd);



                       if (ratioFrom.utcOffset() != ratioTo.utcOffset()) {
                            ratioTo = ratioTo.clone().utcOffset(ratioFrom.utcOffset(), true);
                        }

                        let ratio = ratioTo.diff(ratioFrom) / checkEnd.diff(prefStart);


                        let prefTime = Math.round(diff * ratio);
                        if (prefTime > 0) {
                            let isWeekend = !workDays.includes(prefStart.isoWeekday());

                            let tWorkValue = 0;
                            if (baseWorkValue > -1) {
                                //use preference.workValue instead of preference duration to determine workValue
                                //first determine the ratio that the current day interval has compared to entire preference length
                                let pFrom = overridePrefFrom;
                                let pTo = overridePrefTo;
                                if(pFrom == null){
                                    pFrom = prefFrom;
                                }
                                if(pTo == null){
                                    pTo = prefTo;
                                }
                                let workValueRatio = ratioTo.diff(ratioFrom) / pTo.diff(pFrom);
                                tWorkValue = Math.round(baseWorkValue * workValueRatio);
                            } else {
                                if (prefTime > dayTimeRegular) {
                                    tWorkValue += dayTimeRegular;
                                } else {
                                    tWorkValue += prefTime;
                                }
                            }

                            if (pref.type == 1 || pref.type == 2 || pref.type == 3 || pref.type == 6 || pref.type == 7 || pref.type == 8) {
                                if (!isWeekend || alwaysWork) {
                                    workValue += tWorkValue;
                                }
                            } else if (pref.type == 4 && alwaysWork){
                                workValue += tWorkValue;
                            }

                        }

                        prefStart = prefStart.add(1, 'days').startOf('day');
                    }

                }

                return workValue;
            },

            openExportSelection(type = 1){
                let view = this;
                let visibleSpots = view.filterDropdownOptions.filter(item => item.toggled).map(item => item.id);

                let allGroup = this.LoadGroupsAllInOne();
                let empls = allGroup[0].employees;

                let emplsMapped = empls.map(e => e.employee).map(emp => {return {label: emp.lastName+" "+emp.firstName,
                                                                value: emp.id, selected: false}}).sort((a, b) => a.label.localeCompare(b.label));
                let dataEntries = [];
                dataEntries.push({label: this.$t('global.ui.allEmployees'), key: 'allEmployees', hidden: false, type: 'bool', value: true, flexGroup: false});
                dataEntries.push({label: this.$t('global.ui.selectEmployee'), key: 'employees', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('allEmployees'), type: 'dropdownsearch', value: null, selectMultiple: true, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: emplsMapped,
                        selectMultiple: true,
                        selectedItems: emplsMapped.filter(item => item.selected),
                        selectedItem: {},
                        onceSelected: function ($event, item, searchbar){

                        },
                    styleLight: true,
                    placeholder: this.$t('global.ui.selectEmployee'),
                    },
                });
                dataEntries.push({label: this.$t('pref.main.singleDays'), key: 'asDays', hidden: false, type: 'bool', value: false, flexGroup: false});
                dataEntries.push({label: this.$t('pref.main.confirmedOnly'), key: 'approvedOnly', hidden: false, type: 'bool', value: true, flexGroup: false});

                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: '',
                        selectCallback: function (data) {
                            let employees = data.allEmployees ? empls.map(e => e.employee.id) : data.employees;
                            if(type == 1){
                                view.exportCSV(employees, data.asDays, data.approvedOnly)
                            } else if(type == 2) {
                                view.exportPDF(employees, data.asDays, data.approvedOnly)
                            }
                        }
                    },
                    header: this.$t('global.ui.exportSelection'),
                    expanded: true,
                    width: "700px",
                    centered: true
                });
            },
            exportCSV(employees = [], asDays = false, approvedOnly = true){
                var date = new Date();
                let ts = ( date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2( date.getDate()) + this.$helpers.pad2( date.getHours() ) + this.$helpers.pad2( date.getMinutes() ) + this.$helpers.pad2( date.getSeconds() ) );

                let view = this;
                let csvPre = "data:text/csv;charset=utf-8,";
                let csv = "";
                let headers = [this.$t('pages.employeeCoreData.personnelNumber'), this.$t('pages.employeeData.name'), this.$t('pages.employeeCoreData.mainPosition'), this.$t('global.general.from').toLowerCase(), this.$t('global.general.to').toLowerCase(), 'Abwesenheit', this.$t('pref.main.detail'), this.$t('global.general.comment'), 'Arbeitszeit (h)', this.$t('global.ui.approved'), this.$t('pref.main.denied'), 'Bestätigt am', 'Zuletzt geändert am', this.$t('roster.main.changedBy')];
                if(this.storeSettings.empApprovablePrefTypes.length > 0){
                    headers.push(this.$t('pref.main.confirmedByEmployee'));
                }
                let filename = this.$t('global.menubar.preferences') + '_' + this.dateDisplay + '_' + this.storeSettings.name + '_' + ts +  '.csv';

                csv += headers.join(";");
                csv += "\n";

                let allGroup = this.LoadGroupsAllInOne();
                let empls = allGroup[0].employees;
                empls.filter(e => employees.includes(e.employee.id)).forEach((e) => {
                    let empl = e.employee;
                    let personnelId = empl.personnelId;
                    let name = empl.lastName + ' ' + empl.firstName;
                    let spotName = empl.spotId ? view.spotMap[empl.spotId].name : "";
                    // state 1 / type 4 ==> Nicht verfübar / Sonstiges
                    e.timeFrames.forEach((tf) => {
                        let pref = tf.preference;
                        if(view.isTimeFrameVisible(tf) && (pref.approved || !approvedOnly)){
                            if(asDays){

                                let from = tf.fromDate.clone();
                                let to = tf.toDate.clone();



                                let current = from.clone();
                                while(current < to){
                                    let end = current.clone().add(1,'days').startOf('day');
                                    if(end > to){
                                        end = to.clone();
                                    }
                                    let fedHoliday = Object.values(this.holidayMap)
                                    .filter(h => h.federalHoliday && current >= view.$helpers.getMomentFromStringTZ(h.from)  &&  current < view.$helpers.getMomentFromStringTZ(h.to) ).length > 0;
                                    let fedComment = pref.state == 1 && fedHoliday ? this.$t('roster.comp.holiday') : "";
                                    let comment = pref.comment ? pref.comment : null;
                                    let subtype = pref.subtype ? this.employeeAvailabilitySubtypeMap[pref.subtype].label_de : null;
                                    if(subtype != null && comment != null && subtype == comment){
                                        comment = null;
                                    }
                                    let cur = [personnelId, name, spotName];
                                    if(current.hours() == 0 && current.minutes() == 0 && current.seconds() == 0){
                                        cur.push(current.format("DD.MM.YYYY"));
                                    }else{
                                        cur.push(current.format("DD.MM.YYYY HH:mm"));
                                    }
                                    if(end.hours() == 0 && end.minutes() == 0 && end.seconds() == 0){
                                        let tend = end.clone().subtract("days", 1);
                                        cur.push(tend.format("DD.MM.YYYY"));
                                    }else{
                                        cur.push(end.format("DD.MM.YYYY HH:mm"));
                                    }
                                    cur.push(tf.label);
                                    cur.push(subtype ? subtype : "");
                                    cur.push(comment ? fedComment+" - "+comment : fedComment+"");
                                    let prefCopy = Object.assign({}, pref);
                                    prefCopy.from = current.format();
                                    prefCopy.to = end.format();

                                    let workValue = ((this.calculateWorkValueForPref(prefCopy, from, to)/60).toFixed(2)+"").replace(".", ",");
                                    cur.push(workValue);
                                    cur.push(pref.approved ? this.$t('global.ui.yes') : this.$t('global.ui.no'));
                                    cur.push(pref.denied ? this.$t('global.ui.yes') : this.$t('global.ui.no'));
                                    cur.push(pref.approvedAt ? this.$helpers.getMomentFromStringTZ(pref.approvedAt).format("DD.MM.YYYY HH:mm") : '-')
                                    cur.push(pref.editedAt ? this.$helpers.getMomentFromStringTZ(pref.editedAt).format("DD.MM.YYYY HH:mm") : '-')
                                    cur.push(pref.editedByName ? pref.editedByName : '-')
                                    if(this.storeSettings.empApprovablePrefTypes.length > 0){
                                        cur.push(pref.approvedByEmployeeAt ? this.$helpers.getMomentFromStringTZ(pref.approvedByEmployeeAt).format("DD.MM.YYYY HH:mm") : '-')
                                    }
                                    csv += cur.join(";");
                                    csv += "\n";
                                    current = current.add(1, 'days').startOf('day');
                                }

                            } else {
                                let cur = [personnelId, name, spotName];
                                let from = tf.fromDate.clone();
                                let to = tf.toDate.clone();
                                let comment = pref.comment ? pref.comment : null;
                                let subtype = pref.subtype ? this.employeeAvailabilitySubtypeMap[pref.subtype].label_de : null;
                                if(subtype != null && comment != null && subtype == comment){
                                    comment = null;
                                }
                                if(from.hours() == 0 && from.minutes() == 0 && from.seconds() == 0){
                                    cur.push(from.format("DD.MM.YYYY"));
                                }else{
                                    cur.push(from.format("DD.MM.YYYY HH:mm"));
                                }
                                if(to.hours() == 0 && to.minutes() == 0 && to.seconds() == 0){
                                    to.subtract("days", 1);
                                    cur.push(to.format("DD.MM.YYYY"));
                                }else{
                                    cur.push(to.format("DD.MM.YYYY HH:mm"));
                                }
                                cur.push(tf.label);
                                cur.push(subtype ? subtype : "");
                                cur.push(comment ? comment : "");
                                let workValue = ((this.calculateWorkValueForPref(pref)/60).toFixed(2)+"").replace(".", ",");
                                cur.push(workValue);
                                cur.push(pref.approved ? this.$t('global.ui.yes') : this.$t('global.ui.no'));
                                cur.push(pref.denied ? this.$t('global.ui.yes') : this.$t('global.ui.no'));
                                cur.push(pref.approvedAt ? this.$helpers.getMomentFromStringTZ(pref.approvedAt).format("DD.MM.YYYY HH:mm") : '-')

                                cur.push(pref.editedAt ? this.$helpers.getMomentFromStringTZ(pref.editedAt).format("DD.MM.YYYY HH:mm") : '-')
                                cur.push(pref.editedByName ? pref.editedByName : '-')
                                if(this.storeSettings.empApprovablePrefTypes.length > 0){
                                    cur.push(pref.approvedByEmployeeAt ? this.$helpers.getMomentFromStringTZ(pref.approvedByEmployeeAt).format("DD.MM.YYYY HH:mm") : '-')
                                }
                                csv += cur.join(";");
                                csv += "\n";
                            }

                        }
                    });

                });

                let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", filename);
                document.body.appendChild(link); // Required for FF

                link.click();
            },
            exportPDF(employees = [], asDays = false, approvedOnly = true){
                let view = this;
                var date = new Date();
                let ts = ( date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2( date.getDate()) + this.$helpers.pad2( date.getHours() ) + this.$helpers.pad2( date.getMinutes() ) + this.$helpers.pad2( date.getSeconds() ) );


                let headers = [this.$t('pages.employeeCoreData.personnelNumber'), 
                    this.$t('pages.employeeData.name'),
                    'Stammposition', 
                    this.$t('global.general.from').toLowerCase(), 
                    this.$t('global.general.to').toLowerCase(), 
                    this.$tc('global.general.absence'), 
                    this.$t('pref.main.detail'),
                    this.$t('global.general.comment'), 
                    this.$t('shift.template.workTime') + this.$t('indicator.crew.hourBubble'), 
                    this.$t('global.ui.approved'), 
                    this.$t('pref.main.denied'), 
                    this.$t('pages.employeeContract.approvedAt').split(" ").join("\n"),
                    this.$t('pref.main.lastChangedAt'), 
                    this.$t('roster.main.changedBy').split(" ").join("\n")];
                if(this.storeSettings.empApprovablePrefTypes.length > 0){
                    headers.push(this.$t('pref.main.confirmedByEmployee').split(" ").join("\n"));
                }
                let filename = this.$t('global.menubar.preferences') + '_' + this.dateDisplay + '_' + this.storeSettings.name + '_' + ts ;

                var body = [];

                var repDoc = this.$helpers.tableReportDoc(
                    headers,
                    this.$t('global.menubar.preferences') + ' ' + this.timeFrameStart.format('MMMM YYYY'),
                    this.storeSettings.name,
                    this.storeSettings.description,
                    this.userFullname,
                    9);
                var doc = repDoc.doc;
                var contentOffsetY = repDoc.contentOffsetY;
                doc.setFontSize(12);

                let allGroup = this.LoadGroupsAllInOne();
                let empls = allGroup[0].employees;
                empls.filter(e => employees.includes(e.employee.id)).forEach((e) => {
                    let empl = e.employee;
                    let personnelId = empl.personnelId;
                    let name = empl.lastName + ' ' + empl.firstName;
                    let spotName = empl.spotId ? view.spotMap[empl.spotId].name : "";
                    // state 1 / type 4 ==> Nicht verfübar / Sonstiges
                    e.timeFrames.forEach((tf) => {
                        let pref = tf.preference;
                        if(view.isTimeFrameVisible(tf) && (pref.approved || !approvedOnly)){
                            if(asDays){

                                let from = tf.fromDate.clone();
                                let to = tf.toDate.clone();



                                let current = from.clone();
                                while(current < to){
                                    let end = current.clone().add(1,'days').startOf('day');
                                    if(end > to){
                                        end = to.clone();
                                    }
                                    let fedHoliday = Object.values(this.holidayMap)
                                    .filter(h => h.federalHoliday && current >= view.$helpers.getMomentFromStringTZ(h.from)  &&  current < view.$helpers.getMomentFromStringTZ(h.to) ).length > 0;
                                    let fedComment = pref.state == 1 && fedHoliday ? this.$t('roster.comp.holiday') : "";
                                    let comment = pref.comment ? pref.comment : null;
                                    let subtype = pref.subtype ? this.employeeAvailabilitySubtypeMap[pref.subtype].label_de : null;
                                    if(subtype != null && comment != null && subtype == comment){
                                        comment = null;
                                    }
                                    let cur = [personnelId, name, spotName];
                                    if(current.hours() == 0 && current.minutes() == 0 && current.seconds() == 0){
                                        cur.push(current.format("DD.MM.YYYY"));
                                    }else{
                                        cur.push(current.format("DD.MM.YYYY HH:mm").replace(" ", "\n"));
                                    }
                                    if(end.hours() == 0 && end.minutes() == 0 && end.seconds() == 0){
                                        let tend = end.clone().subtract("days", 1);
                                        cur.push(tend.format("DD.MM.YYYY"));
                                    }else{
                                        cur.push(end.format("DD.MM.YYYY HH:mm").replace(" ", "\n"));
                                    }
                                    cur.push(tf.label);
                                    cur.push(subtype ? subtype : "");
                                    cur.push(comment ? fedComment+" - "+comment : fedComment+"");
                                    let prefCopy = Object.assign({}, pref);
                                    prefCopy.from = current.format();
                                    prefCopy.to = end.format();

                                    let workValue = ((this.calculateWorkValueForPref(prefCopy, from, to)/60).toFixed(2)+"").replace(".", ",");
                                    cur.push(workValue);
                                    cur.push(pref.approved ? this.$t('global.ui.yes') : this.$t('global.ui.no'));
                                    cur.push(pref.denied ? this.$t('global.ui.yes') : this.$t('global.ui.no'));
                                    cur.push(pref.approvedAt ? this.$helpers.getMomentFromStringTZ(pref.approvedAt).format("DD.MM.YYYY HH:mm").replace(" ", "\n") : '-')

                                    cur.push(pref.editedAt ? this.$helpers.getMomentFromStringTZ(pref.editedAt).format("DD.MM.YYYY HH:mm").replace(" ", "\n") : '-')
                                    cur.push(pref.editedByName ? pref.editedByName : '-')
                                    if(this.storeSettings.empApprovablePrefTypes.length > 0){
                                        cur.push(pref.approvedByEmployeeAt ? this.$helpers.getMomentFromStringTZ(pref.approvedByEmployeeAt).format("DD.MM.YYYY HH:mm").replace(" ", "\n") : '-')
                                    }
                                    body.push(cur);

                                    current = current.add(1, 'days').startOf('day');
                                }

                            } else {
                                let cur = [personnelId, name, spotName];
                                let comment = pref.comment ? pref.comment : null;
                                let subtype = pref.subtype ? this.employeeAvailabilitySubtypeMap[pref.subtype].label_de : null;
                                if(subtype != null && comment != null && subtype == comment){
                                    comment = null;
                                }
                                let from = tf.fromDate.clone();
                                let to = tf.toDate.clone();
                                if(from.hours() == 0 && from.minutes() == 0 && from.seconds() == 0){
                                    cur.push(from.format("DD.MM.YYYY"));
                                }else{
                                    cur.push(from.format("DD.MM.YYYY HH:mm").replace(" ", "\n"));
                                }
                                if(to.hours() == 0 && to.minutes() == 0 && to.seconds() == 0){
                                    to.subtract("days", 1);
                                    cur.push(to.format("DD.MM.YYYY"));
                                }else{
                                    cur.push(to.format("DD.MM.YYYY HH:mm").replace(" ", "\n"));
                                }
                                cur.push(tf.label);
                                cur.push(subtype ? subtype : "");
                                cur.push(comment ? comment : "");
                                let workValue = ((this.calculateWorkValueForPref(pref)/60).toFixed(2)+"").replace(".", ",");
                                cur.push(workValue);
                                cur.push(pref.approved ? this.$t('global.ui.yes') : this.$t('global.ui.no'));
                                cur.push(pref.denied ? this.$t('global.ui.yes') : this.$t('global.ui.no'));
                                cur.push(pref.approvedAt ? this.$helpers.getMomentFromStringTZ(pref.approvedAt).format("DD.MM.YYYY HH:mm").replace(" ", "\n") : '-')

                                cur.push(pref.editedAt ? this.$helpers.getMomentFromStringTZ(pref.editedAt).format("DD.MM.YYYY HH:mm").replace(" ", "\n") : '-')

                                cur.push(pref.editedByName ? pref.editedByName : '-')
                                if(this.storeSettings.empApprovablePrefTypes.length > 0){
                                    cur.push(pref.approvedByEmployeeAt ? this.$helpers.getMomentFromStringTZ(pref.approvedByEmployeeAt).format("DD.MM.YYYY HH:mm").replace(" ", "\n") : '-')
                                }

                                body.push(cur);
                            }

                        }
                    });
                });

                doc.autoTable({
                    startY: contentOffsetY,
                    head: [headers],
                    body: body,
                    headStyles: {
                        fillColor: [109,141,33],
                        fontSize: 7,
                    },
                    bodyStyles: {
                        fontSize: 7
                    },
                    columnStyles: {

                    }
                })
                view.$helpers.previewPdf(doc, filename+ '.pdf');
            },

            OpenFilterDropdown($event){
                var view = this;
                var target = $event.currentTarget;


                this.$helpers.OpenPopup({
                    elRelative: target,
                    type: 'list',
                    componentState: {
                        entries: view.filterDropdownOptions,
                    },
                    remainAfterSelect: true,
                    pointerDirection: 0,
                    iconsLeft: true,
                    selectCallback: function($event, item, dropdown){
                        item.toggled = !item.toggled;
                        if(item.state) item.state.show = item.toggled;
                        if(item.type) item.type.show = item.toggled;
                        if(item.all) {
                            view.filterDropdownOptions.forEach(option => {
                                if(option.state || option.type || option.vacationban || option.wishban){
                                    option.toggled = item.toggled;
                                    if(option.state)option.state.show = item.toggled;
                                    if(option.type) option.type.show = item.toggled;
                                }
                            })
                        }
                    },
                });
            },
            ToggleEmployeeSkill(skill){
                if(this.skillVisibilityList.find(s => s === skill)) this.skillVisibilityList = this.skillVisibilityList.filter(s => s !== skill);
                else this.skillVisibilityList.push(skill);
                this.$forceUpdate();
            },
            ToggleAllEmployeeSkill(val){
                if(val) this.skillVisibilityList = [];
            },
            EmployeeIsVisible(employee){
                var view = this;
                return view.skillVisibilityList.length === 0 || view.skillVisibilityList.every(s => view.employeeSkills.find(es => es.employeeId === employee.id && s.id === es.skillId));
            },
            GenerateTypeSelect(stateId){
                let typeItems = [];
                Object.values(this.employeeAvailabilityTypeMap).forEach(type =>{
                    if(type.id != 5){
                        if(!stateId || type.id == 4 || stateId == 1) {
                            let option = {label: type.label_de, value: type.id, type: type};
                            typeItems.push(option);
                        }
                    }
                });
                return typeItems;
            },
            GenerateSubtypeSelect(parentType){
                let typeItems = [];
                Object.values(this.employeeAvailabilitySubtypeMap).forEach(type =>{

                    if(type.parentType == parentType) {
                        let option = {label: type.label_de, value: type.id, type: type};
                        typeItems.push(option);
                    }

                });
                return typeItems;
            },
            ApplyNewStateSelect($event, item, dropdownsearch){
                let datafill = dropdownsearch.$parent;
                let typeEntry = datafill.entries.find(e => e.key == 'type');
                if(typeEntry){
                    let typeDropdown = datafill.$children.find(c => c.state === typeEntry.dropdownSearchState)
                    typeEntry.dropdownSearchState.items = this.GenerateTypeSelect(item.value);
                    if(typeDropdown.selectedItem) {
                        let val = typeDropdown.selectedItem.value;
                        typeEntry.dropdownSearchState.selectIf = (i) => {
                            return i.value === val
                        };
                    }
                    typeDropdown.Init();
                }
            },
            OpenNewPreferencePopup($event, employee, spot){
                var view = this;
                var target = $event.currentTarget;

                let state = this.GetPreferenceDatafillState({employeeId: employee.id, spotId: spot ? spot.id : null, state: 1, type: 1});

                this.$helpers.OpenPopup({
                    elRelative: target,
                    type: 'datafill',
                    componentState: state,
                    header: this.$t('pref.main.newAbsence') + ': '+employee.firstName+" "+employee.lastName,
                    expanded: true,
                    centered: true,
                });
            },
            GetPreferenceDatafillState(preference){
                let view = this;

                let preferenceTemplate = {
                    employeeId: null,
                    spotId: null,
                    from: preference.from ? preference.from : this.$helpers.convertDateStringTZ(this.$helpers.getMomentTZ().hours(0).minutes(0)),
                    to: preference.to? preference.to : this.$helpers.convertDateStringTZ(this.$helpers.getMomentTZ().hours(0).minutes(0)),
                    factor: 1,
                    workValue: preference.workValue != null ? preference.workValue : -1,
                    overrideContract: true,
                    alwaysWork: false,
                    comment: '',
                    state: 1,
                    type: 1,
                    subtype: null,
                };

                for(let x in preferenceTemplate){
                    if(!preference[x]) preference[x] = preferenceTemplate[x];
                }

                let stateItems = [];
                Object.values(view.employeeAvailabilityStateMap).filter(s => s.selectable).forEach(function(state){
                    var option = {label: state.label_de, value: state.id, state: state};
                    stateItems.push(option);
                });

                let typeItems = this.GenerateTypeSelect(preference.state);
                let subtypeItems_8 = this.GenerateSubtypeSelect(8);
                let selectedSubtypeItem_8 = subtypeItems_8.find(i => i.value == preference.subtype);

                let subtypeItems_2 = this.GenerateSubtypeSelect(2);
                subtypeItems_2 = subtypeItems_2.sort((a, b) => b.value - a.value);
                let selectedSubtypeItem_2 = subtypeItems_2.find(i => i.value == preference.subtype);

                let subtypeItems_4 = this.GenerateSubtypeSelect(4);
                subtypeItems_4 = subtypeItems_4.sort((a, b) => b.value - a.value);
                let selectedSubtypeItem_4 = subtypeItems_4.find(i => i.value == preference.subtype);


                let hideOptions = preference.state != 1 || !(preference.type == 1 || preference.type == 2 || preference.type == 3 || preference.type == 6 || preference.type == 7 || preference.type == 8 || (preference.type == 4 && preference.alwaysWork))
                let hideOptions2 = preference.state != 1 || !(preference.type == 1 || preference.type == 2 || preference.type == 3 || preference.type == 6 || preference.type == 7 || preference.type == 8 || (preference.type == 4))
                let hideOptions3 = preference.state != 1 || !(preference.type == 2 || preference.type == 7 || preference.type == 8 || (preference.type == 4))


                let dataEntries = [
                    {label: 'ID', key: 'id', hidden: true, type: '', value: preference.id},
                    {label: 'Employee Id', key: 'employeeId', hidden: true, type: '', value: preference.employeeId},
                    {label: 'Spot Id', key: 'spotId', hidden: true, type: '', value: preference.spotId},
                    {label: this.$t('global.general.from').toLowerCase(), key: 'from', hidden: false, type: 'timeframe', value: preference.from, flexGroup: true, timeBig: true, startTime: true, focusProceedKey: 'to'},
                    {label: this.$t('global.general.to').toLowerCase(), key: 'to', hidden: false, type: 'timeframe', value: preference.to, flexGroup: true, timeBig: true, endTime: true,},
                    {divider: true},
                    {label: this.$t('global.general.fromDay'), key: 'fromDate', hidden: false, type: 'date', value: preference.from, flexGroup: true, styles:{'margin-right' : '10px'}},
                    {label: this.$t('global.general.toDay'), key: 'toDate', hidden: false, type: 'date', value: preference.to, flexGroup: true},
                    {label: 'Factor', key: 'factor', hidden: true, type: 'numeric', value: preference.factor},
                    {label: 'Override Contract', key: 'overrideContract', hidden: true, type: 'bool', value: true},
                    {label: this.$t('global.general.comment'), key: 'comment', hidden: false, type: 'text', value: preference.comment, length: 20},
                    {label: this.$t('global.general.status'), key: 'state', hidden: false, type: 'dropdownsearch', value: preference.state, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: stateItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst: true,
                            selectIf: (item) => { return item.value === preference.state},
                            styleLight: true,
                        }},
                    {label: this.$tc('global.general.type'), key: 'type', hidden: false, type: 'dropdownsearch', value: preference.type, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: typeItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst: true,
                            selectIf: (item) => { return item.value === preference.type},
                            styleLight: true,
                        }
                    },
                    {label: this.$t('global.ui.reason'), key: 'subtype_8', hidden: preference.type != 8, type: 'dropdownsearch', value: selectedSubtypeItem_8 ? selectedSubtypeItem_8.value : null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: subtypeItems_8,
                            selectMultiple: false,
                            selectedItem: selectedSubtypeItem_8,
                            selectedItems: [selectedSubtypeItem_8],
                            selectFirst: false,
                            styleLight: true,
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let state = datafill.entries.find(i => i.key == 'state').value;
                            let type = datafill.entries.find(i => i.key == 'type').value;

                            if(state != 1 || (type != 8)){
                                entryBeforeUpdate.value = null;
                                entryBeforeUpdate.hidden = true;
                            } else {
                               entryBeforeUpdate.hidden = false;
                            }
                            return entryBeforeUpdate;
                        }

                    },
                    {label: this.$t('pref.main.detail'), key: 'subtype_2', hidden: preference.type != 2, type: 'dropdownsearch', value: selectedSubtypeItem_2 ? selectedSubtypeItem_2.value : null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: subtypeItems_2,
                            selectMultiple: false,
                            selectedItem: selectedSubtypeItem_2,
                            selectedItems: [selectedSubtypeItem_2],
                            selectFirst: preference.id == null,
                            styleLight: true,
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let state = datafill.entries.find(i => i.key == 'state').value;
                            let type = datafill.entries.find(i => i.key == 'type').value;

                            if(state != 1 || (type != 2)){
                                entryBeforeUpdate.value = null;
                                entryBeforeUpdate.hidden = true;
                            } else {
                               entryBeforeUpdate.hidden = false;
                            }
                            return entryBeforeUpdate;
                        }

                    },
                    {label: this.$t('pref.main.detail'), key: 'subtype_4', hidden: preference.type != 4, type: 'dropdownsearch', value: selectedSubtypeItem_4 ? selectedSubtypeItem_4.value : null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: subtypeItems_4,
                            selectMultiple: false,
                            selectedItem: selectedSubtypeItem_4,
                            selectedItems: [selectedSubtypeItem_4],
                            selectFirst: preference.id == null,
                            styleLight: true,
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let state = datafill.entries.find(i => i.key == 'state').value;
                            let type = datafill.entries.find(i => i.key == 'type').value;
                            

                            if(state != 1 || (type != 4)){
                                entryBeforeUpdate.value = null;
                                entryBeforeUpdate.hidden = true;
                            } else {
                               entryBeforeUpdate.hidden = false;
                            }
                            return entryBeforeUpdate;
                        }

                    },
                    {label: this.$t('workBalance.payroll.holidayWorkTime'), key: 'countsAsHoliday', hidden: hideOptions3, type: 'bool', value: preference.countsAsHoliday,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let state = datafill.entries.find(i => i.key == 'state').value;
                            let type = datafill.entries.find(i => i.key == 'type').value;
                            let alwaysWork = datafill.entries.find(i => i.key == 'alwaysWork').value;
                            if(state != 1 || !(type == 2 || type == 7 || type == 8 || (type == 4 && alwaysWork))){
                                entryBeforeUpdate.value = false;
                                entryBeforeUpdate.hidden = true;
                            } else {
                               entryBeforeUpdate.hidden = false;
                            }
                            return entryBeforeUpdate;
                        }
                    },
                    {label: this.$t('shift.template.automaticWorkTime'), key: 'autoWorkValue', hidden: hideOptions, type: 'bool', value: preference.workValue == -1,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let state = datafill.entries.find(i => i.key == 'state').value;
                            let type = datafill.entries.find(i => i.key == 'type').value;
                            let alwaysWork = datafill.entries.find(i => i.key == 'alwaysWork').value;
                            if(state != 1 || !(type == 1 || type == 2 || type == 3 || type == 6 || type == 7 || type == 8 || (type == 4 && alwaysWork))){
                                entryBeforeUpdate.value = true;
                                entryBeforeUpdate.hidden = true;
                            } else {
                               entryBeforeUpdate.hidden = false;
                            }
                            return entryBeforeUpdate;
                        }
                    },
                    {label: this.$t('shift.template.workTime'), key: 'workValue', hidden: preference.state != 1 || preference.workValue == -1, value: preference.workValue,
                        slider: {
                            min: 0,
                            max: 24*60,
                            hideMin: true,
                            hideMax: true,
                            value: preference.workValue,
                            step: 1,
                            DisplayLabel: (val) => {
                                let hours = this.$helpers.pad2(Math.floor(val / 60));
                                let minutes = this.$helpers.pad2(val % 60);
                                return hours + ':' + minutes +"/"+(val/60).toFixed(2)+"h";
                            },
                            inputControl: true,
                            sliderInput: (x) => {return x * 60},
                            labelToInt: (x) => {return x.slice(0, -1)},
                            shorterDisplayLabel: (x) => {return (x / 60.0).toFixed(2)+'h'},

                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                                let autoWorkValue = datafill.entries.find(i => i.key == 'autoWorkValue').value;

                                if(autoWorkValue && entryBeforeUpdate.value != -1){
                                    entryBeforeUpdate.value = -1;
                                    entryBeforeUpdate.slider.value = -1;
                                    entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                                }
                                if(!autoWorkValue && entryBeforeUpdate.value <= -1){
                                    entryBeforeUpdate.value = 0;
                                    entryBeforeUpdate.slider.value = 0;
                                    entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                                }

                                if(autoWorkValue){
                                    entryBeforeUpdate.hidden = true;
                                } else {
                                    entryBeforeUpdate.hidden = false;
                                }
                                return entryBeforeUpdate;
                        }

                    },
                    {label: this.$t('pref.main.alwaysCountsAsWorkDay'), key: 'alwaysWork', hidden: hideOptions2, type: 'bool', value: preference.alwaysWork,
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let state = datafill.entries.find(i => i.key == 'state').value;
                            let type = datafill.entries.find(i => i.key == 'type').value;
                            if(state != 1 || !(type == 1 || type == 2 || type == 3 || type == 4 || type == 6 || type == 7 || type == 8)){
                                entryBeforeUpdate.value = false;
                                entryBeforeUpdate.hidden = true;
                            } else {
                                if(type == 8 || type == 3){
                                    entryBeforeUpdate.value = true;
                                }
                                entryBeforeUpdate.hidden = false;
                            }
                            return entryBeforeUpdate;

                        }
                    },
                ];

                if(!preference.id){
                    dataEntries.push({label: this.$t('global.ui.approved'), key: 'approved', hidden: false, type: 'bool', value: true});
                } else {
                    let createdText = preference.createdByName ? preference.createdByName+this.$t('pref.main.atBubbles')+(preference.createdAt ? this.$helpers.getMomentFromStringTZ(preference.createdAt).format("DD.MM.YYYY HH:mm") : '-') : "-";
                    let approvedText = preference.approvedByName ? preference.approvedByName+this.$t('pref.main.atBubbles')+(preference.approvedAt ? this.$helpers.getMomentFromStringTZ(preference.approvedAt).format("DD.MM.YYYY HH:mm") : '-') : "-"
                    let editedText = preference.editedByName ? preference.editedByName+this.$t('pref.main.atBubbles')+(preference.editedAt ? this.$helpers.getMomentFromStringTZ(preference.editedAt).format("DD.MM.YYYY HH:mm") : '-') : "-"
                    let approvedByEmployeeAtText = (preference.approvedByEmployeeAt ? this.$helpers.getMomentFromStringTZ(preference.approvedByEmployeeAt).format("DD.MM.YYYY HH:mm") : '-');


                    dataEntries.push({label: this.$t('pref.main.createdBy'), key: 'createdByName', hidden: false, type: 'text', value: createdText, disabled: true});
                    if(preference.approved || !preference.denied){
                        dataEntries.push({label: this.$t('pref.main.confirmedBy'), key: 'approvedByName', hidden: false, type: 'text', value: approvedText, disabled: true});
                    } else {
                        dataEntries.push({label: this.$t('pref.main.deniedBy'), key: 'approvedByName', hidden: false, type: 'text', value: approvedText, disabled: true});
                    }
                    if(this.storeSettings.empApprovablePrefTypes.length > 0){
                        dataEntries.push({label: this.$t('pref.main.confirmedByEmployee'), key: 'approvedByEmployeeAt', hidden: false, type: 'text', value: approvedByEmployeeAtText, disabled: true});
                    }
                    dataEntries.push({label: this.$t('pref.main.lastChangedBy'), key: 'editedByName', hidden: false, type: 'text', value: editedText, disabled: true});
                }

                let type = dataEntries.find(e => e.key === 'type');
                if(type){
                    type.computed = (datafill, lastVal) => {
                        let entry =
                            {label: this.$tc('global.general.type'), key: 'type', hidden: false, type: 'dropdownsearch', value: lastVal, selectMultiple: false, dropdownSearchState:{
                                    styleLight: true,
                                    selectFirst: true,
                                    selectIf: (i) => { return i.value === lastVal},
                                }};
                        let state = datafill.entries.find(e => e.key === 'state');

                        if(state) state = state.value;
                        entry.dropdownSearchState.items = view.GenerateTypeSelect(state);
                        return entry;
                    }
                }

                let startOfMonth = this.currentMonthFromTZ;
                let startOfNextMonth = this.currentMonthToTZ;
                return {
                    entries: dataEntries,
                    errorCheck: [
                                    (entries) => {
                                        if(entries['type'] == 4 && entries['state'] == 1 && entries['alwaysWork'] == true && (entries['comment'] == null || entries['comment'].length == 0)){
                                            return {key: 'comment', type: 'error', label: this.$t('global.general.comment'), text: this.$t('pref.main.pleaseCommentAbsence')}
                                        } else {
                                            return null
                                        }
                                    },
                                    (entries) => {
                                        if(entries['type'] == 8  && entries['state'] == 1 && entries['subtype_8'] === null){
                                            return {key: 'subtype', type: 'error', label: this.$t('global.ui.reason'), text: this.$t('pref.main.pleaseSelectAbsenceReason')}
                                        } else {
                                            return null
                                        }
                                    },
                                    (entries) => {
                                        if(entries['type'] == 4 && entries['state'] == 1 && entries['subtype_4'] === null){
                                            return {key: 'subtype', type: 'error', label: this.$t('global.ui.reason'), text: this.$t('pref.main.pleaseSelectAbsenceReason')}
                                        } else {
                                            return null
                                        }
                                    },
                                    (entries) => {
                                        if(entries['type'] == 2 && entries['state'] == 1 && entries['subtype_2'] === null){
                                            return {key: 'subtype', type: 'error', label: this.$t('global.ui.reason'), text: this.$t('pref.main.pleaseSelectAbsenceReason')}
                                        } else {
                                            return null
                                        }
                                    },
                                    (entries) => {
                                        if(entries.hasOwnProperty('fromDate') && entries['fromDate'] < startOfMonth){
                                            return {key: 'fromDate', type: 'error', label: this.$t('global.general.fromDay'), text: this.$t('pref.main.itsCurrentMonth')}
                                        } else {
                                            return null
                                        }
                                    },
                                    (entries) => {
                                        if(entries.hasOwnProperty('toDate') && entries['toDate'] >= startOfNextMonth && entries.id != null){
                                            return {key: 'toDate', type: 'error', label: this.$t('global.general.toDay'), text: this.$t('pref.main.itsCurrentMonth')}
                                        } else {
                                            return null
                                        }
                                    },
                                    (entries) => {
                                        if(entries.hasOwnProperty('toDate') && entries['toDate'] >= startOfNextMonth && entries.id == null && entries.toDate.diff(startOfNextMonth, 'months') > 12){
                                            return {key: 'toDate', type: 'error', label: this.$t('global.general.toDay'), text: this.$t('pref.main.twelveMonthDistance')}
                                        } else {
                                            return null
                                        }
                                    },
                                ],
                    selectCallback: function (preference) {
                        preference.from.year(preference.fromDate.year());
                        preference.from.month(preference.fromDate.month());
                        preference.from.date(preference.fromDate.date());

                        preference.to.year(preference.toDate.year());
                        preference.to.month(preference.toDate.month());
                        preference.to.date(preference.toDate.date());

                        if(preference.to.hours() == 0 && preference.to.minutes() == 0){
                            //add 1 day because brainlets don't understand what an exclusive time range is
                            preference.to.add(1,'days');
                        }
                        if(preference.type == 8){
                            preference.subtype = preference.subtype_8;
                        } else if (preference.type == 4){
                            preference.subtype = preference.subtype_4;
                        } else if (preference.type == 2){
                            preference.subtype = preference.subtype_2;
                        }

                        delete preference.subtype_8;
                        delete preference.subtype_4;
                        delete preference.subtype_2;

                        if(preference.id){
                            view.updateEmployeePreference(preference);
                        } else {
                            if(preference.to > startOfNextMonth){
                                delete preference.fromDate;
                                delete preference.toDate;

                                let first = Object.assign({}, preference);
                                first.workValue = -1;
                                let to = preference.to.clone();
                                let start = startOfNextMonth.clone();
                                first.to = startOfNextMonth.clone();
                                let rest = [];
                                while(start < to){

                                    let nextEnd = start.clone().add(1, 'month').endOf('month');
                                    if(nextEnd > to){
                                        nextEnd = to;
                                    }
                                    let nextPref = Object.assign({}, first);
                                    nextPref.from = start;
                                    nextPref.to = nextEnd;
                                    rest.push(view.convertPreferenceToPayload(nextPref));

                                    start = nextEnd.clone();
                                }
                                rest.push(view.convertPreferenceToPayload(first))
                                view.createMultipleEmployeePreferences(rest);

                            } else {
                                view.createEmployeePreference(preference);
                            }

                        }

                    }
                };
            },

            OpenFilterPopup($event){
                this.$refs.filterpopup.Init(this.dynamicEnabled);
            },
            OpenBusinessUnitFilterDropdown($event){
                var view = this;
                var target = $event.currentTarget;

                var list = [];
                this.spots.forEach(s => list.push({label: s.name, toggled: (view.spotVisibilityList.find(p => s === p)) ? true : false, spot: s,
                    styles: s.isMain ? [] : [{'margin-left' : '30px'}]
                }));
                this.$helpers.OpenPopup({
                    type: 'list',
                    elRelative: target,
                    componentState: {
                        entries: list,
                    },
                    header: this.$t('shift.template.toggleWorkspaces'),
                    expanded: true,
                    iconsLeft: true,
                    remainAfterSelect: true,
                    selectCallback: function($event, item, dropdown){
                        item.toggled = !item.toggled;
                        if(item.toggled) {
                            if (!item.spot.isMain) {
                                dropdown.items.filter(i => !i.toggled && i.spot.unitId === item.spot.unitId && i.spot.isMain).forEach(i => {
                                    i.toggled = true;
                                    view.spotVisibilityList.push(i.spot);
                                });
                            }
                            view.spotVisibilityList.push(item.spot);
                        }
                        else {
                            view.spotVisibilityList = view.spotVisibilityList.filter(s => s !== item.spot);
                            if (item.spot.isMain) {
                                dropdown.items.filter(i => i.spot.unitId === item.spot.unitId).forEach(i => i.toggled = false);
                                view.spotVisibilityList = view.spotVisibilityList.filter(s => s.unitId !== item.spot.unitId);
                            }
                        }
                    },
                });
            },
            GetTimeMarkWidth(index) {

                var timeFrame = this.displayedTimeframeSelected;
                if(timeFrame.label === 'Y') {
                    var lengthYear = timeFrame.length;
                    var lengthMonth = timeFrame.timeStart.clone().month(index).daysInMonth() * 24 * 60 * 60 * 1000;
                    var widthMonth =  lengthYear / lengthMonth;
                    return {width: ($(this.$el).find('.time-marks').width() / widthMonth) + 'px'};
                }
                return {width: ($(this.$el).find('.time-marks').width() / parseInt(timeFrame.divisions)) + 'px'};
            },

            UpdateCreateTimeFrame($event, employee, group){
                let timeMark = $(this.$el).find('.mark').toArray().find(m => {
                    let box = m.getBoundingClientRect();
                    return ($event.clientX > box.left && $event.clientX < box.right);
                });
                if(timeMark) this.timeFrameCreate.timeMark = timeMark;
                if(!this.timeFrameCreate.dragging) {
                    this.timeFrameCreate.employee = employee;
                    this.timeFrameCreate.spot = group.spot;
                }
            },
            GetCreateTimeFrameStyles(){
                let indexTimeMark = 0;
                let left = '';
                if(this.timeFrameCreate.timeMark) {
                    indexTimeMark = parseInt(this.timeFrameCreate.timeMark.attributes.index.value);
                    let box = this.timeFrameCreate.timeMark.getBoundingClientRect();
                    let boxParent = this.timeFrameCreate.timeMark.parentNode.getBoundingClientRect();
                    left = box.left - boxParent.left;
                    left += 'px';
                }
                let styles = this.GetTimeMarkWidth(indexTimeMark);
                if(this.timeFrameCreate.dragging && styles.width) {
                    let currentIndex = parseInt(this.timeFrameCreate.timeMarkStart.attributes.index.value);
                    let markStart = this.timeFrameCreate.timeMark;
                    let markEnd = this.timeFrameCreate.timeMarkStart;
                    if(indexTimeMark > currentIndex){
                        let temp = currentIndex;
                        currentIndex = indexTimeMark;
                        indexTimeMark = temp;
                        markStart = markEnd;
                        markEnd = this.timeFrameCreate.timeMark;
                        let box = this.timeFrameCreate.timeMarkStart.getBoundingClientRect();
                        let boxParent = this.timeFrameCreate.timeMarkStart.parentNode.getBoundingClientRect();
                        left = box.left - boxParent.left;
                        left += 'px';
                        styles.left = left;
                    }
                    for(let x = indexTimeMark; x < currentIndex; x++){
                        let width = this.GetTimeMarkWidth(x);
                        if(width.width) styles.width = (markEnd.getBoundingClientRect().right - markStart.getBoundingClientRect().left) + 'px';
                    }
                }
                styles.left = left;
                return styles;
            },
            Hovering($event){
                let col = this.timeFrameCreate.timeMark.attributes.index.value;
                if(col != this.hoveredColumn) this.hoveredColumn = col;
            },
            EndHovering($event){
                this.hoveredColumn = -1;
            },
            TimeFrameCreateDrag($event){
                if(window.mouse.element.classList.contains('handle') || $(window.mouse.element).closest('.timeframe:not(.create)').length > 0) return;
                this.timeFrameCreate.dragging = true;
                this.timeFrameCreate.timeMarkStart = this.timeFrameCreate.timeMark;
                this.$forceUpdate();
            },
            TimeFrameCreate(){
                var view = this;
                if(!this.timeFrameCreate.dragging) return;
                this.timeFrameCreate.dragging = false;

                let indexStart = parseInt(this.timeFrameCreate.timeMark.attributes.index.value);
                let indexEnd = parseInt(this.timeFrameCreate.timeMarkStart.attributes.index.value);
                if(indexStart > indexEnd){
                    let temp = indexEnd;
                    indexEnd = indexStart;
                    indexStart = temp;
                }
                indexEnd++;

                let timeObject = this.displayedTimeframeSelected;

                let divisionTimeStep = timeObject.length / timeObject.divisions;
                let timeStart = this.timeFrameStart.clone();

                let from;
                let to;
                if(timeObject.label=='M'){
                    from = timeStart.clone().add(indexStart, 'days').startOf('day');
                    to = timeStart.clone().add(indexEnd, 'days').startOf('day').add(-1, 'days');

                } else {
                    from = timeStart.clone().add(indexStart * divisionTimeStep, 'milliseconds');
                    to = timeStart.clone().add(indexEnd * divisionTimeStep, 'milliseconds');
                }


                let state = this.GetPreferenceDatafillState({
                    employeeId: this.timeFrameCreate.employee.employee.id,
                    spotId: null,
                    from: from,
                    to: to,
                });

                this.$helpers.OpenPopup({
                    elRelative: $(this.$el).find('.timeframe.create')[0],
                    type: 'datafill',
                    componentState: state,
                    header: this.$t('pages.positionOverview.newEntry'),
                    centered: true,
                    expanded: true,
                });
            },
            GetAlwaysWorkStyle(timeFrame){
                let view = this;
                let currentContract = this.employeeMainContractMap[timeFrame.preference.employeeId]
                let workDays = currentContract ? currentContract.workDays : this.storeSettings.workDays;

                let days = [];
                let startDay = view.$helpers.GetMomentDayNumberFromUnixEpoch(timeFrame.fromDate);
                let endDay = view.$helpers.GetMomentDayNumberFromUnixEpoch(timeFrame.toDate);
                if(!view.dayOfYearIsoWeekdayMap[startDay]) view.dayOfYearIsoWeekdayMap[startDay] = timeFrame.fromDate.isoWeekday();

                let preference = timeFrame.preference;
                let styles = [];
                if(preference.approved){
                    for(let currentDay = startDay; currentDay <= endDay; currentDay++){
                        if(!view.dayOfYearIsoWeekdayMap[currentDay]) {
                            view.dayOfYearIsoWeekdayMap[currentDay] = (view.dayOfYearIsoWeekdayMap[startDay] + (currentDay - startDay)) % 7;
                            if(view.dayOfYearIsoWeekdayMap[currentDay] === 0) view.dayOfYearIsoWeekdayMap[currentDay] = 7;
                        }
                        if(!this.dayOfYearDateKeyMap[currentDay]) this.dayOfYearDateKeyMap[currentDay] = timeFrame.fromDate.clone().add(currentDay - startDay, 'days').format('YYYY-MM-DD');

                        days.push(currentDay);
                    }
                    /*if((timeFrame.toDate._d.getTime() - timeFrame.fromDate._d.getTime()) > (6 * 60 * 60 * 24 * 1000)){
                        startDay = 1;
                        endDay = 7;
                    }*/
                    //days.push(isoWeekDay);
                    /*for(let x = 1; x <= endDay; x++){
                        days.push(x);
                    }*/

                    let daysMissing = [];

                    days.forEach(d => {
                        if(!workDays.find(wd => wd === view.dayOfYearIsoWeekdayMap[d]) || (!preference.alwaysWork && preference.workValue == 0)){
                            daysMissing.push({index: d, color: "#a9a9a9"})

                        } else if(preference.state === 1 && preference.type === 1){
                            let dateKey = this.dayOfYearDateKeyMap[d];
                            if(this.holidayFederalMomentMap[dateKey] && this.holidayFederalMomentMap[dateKey].length > 0){
                                daysMissing.push({index: d, color: "#f8eb73"});
                            }
                        }

                    });



                    let from = timeFrame.fromDate;
                    let to = timeFrame.toDate;
                    let total = to._d.getTime() - from._d.getTime();
                    daysMissing.forEach(item => {
                        let d = item.index;
                        let left = 0;
                        let width = 0;
                        let fromMissing = from.clone().add(d - startDay, 'days').startOf('day');
                        let toMissing = fromMissing.clone().endOf('day');
                        /*if(fromMissing._d.getTime() < from._d.getTime()){

                            fromMissing.add(1, 'week');
                            toMissing.add(1, 'week');
                        }*/



                        left = (fromMissing._d.getTime() - from._d.getTime()) / total;

                        width = (toMissing._d.getTime() - fromMissing._d.getTime()) / total;

                        left *= 100;
                        if(left > 100) left = 100;
                        width *= 100;
                        if(left + width > 100) width = 100 - left;
                        if(left < 0) {
                            width += left;
                            left = 0;
                        }
                        left = left + '%';
                        width = width + '%';

                        styles.push({left: left, width: width, background: item.color});
                    });
                }

                return styles;
            },
            AlwaysWorkCheck(timeFrame){
                let view = this;
                let preference = timeFrame.preference;
                if(preference.state !== 1 || preference.alwaysWork) return false;


                let currentContract = this.employeeMainContractMap[preference.employeeId]
                let workDays = currentContract ? currentContract.workDays : this.storeSettings.workDays;

                let days = [];
                let startDay = view.$helpers.GetMomentDayNumberFromUnixEpoch(timeFrame.fromDate);
                let endDay = view.$helpers.GetMomentDayNumberFromUnixEpoch(timeFrame.toDate);
                if(!view.dayOfYearIsoWeekdayMap[startDay]) view.dayOfYearIsoWeekdayMap[startDay] = timeFrame.fromDate.isoWeekday();

                for(let currentDay = startDay; currentDay <= endDay; currentDay++){
                    if(!view.dayOfYearIsoWeekdayMap[currentDay]) {
                        view.dayOfYearIsoWeekdayMap[currentDay] = (view.dayOfYearIsoWeekdayMap[startDay] + (currentDay - startDay)) % 7;
                        if(view.dayOfYearIsoWeekdayMap[currentDay] === 0) view.dayOfYearIsoWeekdayMap[currentDay] = 7;
                    }
                    if(!this.dayOfYearDateKeyMap[currentDay]) this.dayOfYearDateKeyMap[currentDay] = timeFrame.fromDate.clone().add(currentDay - startDay, 'days').format('YYYY-MM-DD');

                    days.push(currentDay);
                }
                let check = false;

                days.forEach(d => {
                    if(preference.state === 1 && preference.type === 1){
                        let dateKey = this.dayOfYearDateKeyMap[d];
                        if(this.holidayFederalMomentMap[dateKey] && this.holidayFederalMomentMap[dateKey].length > 0){
                            check = true;
                        }
                    }
                    if(!workDays.find(wd => wd === view.dayOfYearIsoWeekdayMap[d]) || preference.workValue == 0){
                        check = true;
                    }
                });

                return check;
            },
            GetTimeFrameTooltip(timeFrame) {
                return () => {
                    let comment = null;
                    if(timeFrame.preference && this.employeePreferenceMap[timeFrame.preference.id] && this.employeePreferenceMap[timeFrame.preference.id].comment){
                        comment = this.$t('global.general.comment') + ': ' +this.employeePreferenceMap[timeFrame.preference.id].comment;
                    }
                    return comment;
                }

            },
            GetTimeFrameStyles(timeFrame){

                var totalWidth = $(this.$el).find('.time-marks').width();
                var timePixelRatio = totalWidth / this.timeFrameLength;
                var backgroundState = null;
                var backgroundType = null;

                var background = '';
                if(this.filterDropdownOptions.find(o => o.state && o.toggled && timeFrame.preference.state
                                                        && o.state.id === timeFrame.preference.state
                                                        && (timeFrame.preference.state != 1 ))){
                    backgroundState = this.GetColorForState(timeFrame.preference.state, timeFrame.preference.approved);
                }
                if(this.filterDropdownOptions.find(o => o.type && o.toggled && timeFrame.preference.type && o.type.id === timeFrame.preference.type && timeFrame.preference.state == 1 )){
                    backgroundType = this.GetColorForType(timeFrame.preference.type, timeFrame.preference.approved);
                }

                if(backgroundState) background = backgroundState;
                if(backgroundType) background = backgroundType;
                if(backgroundType && backgroundState) background = 'linear-gradient(-45deg, ' + backgroundState + ', ' + backgroundState + ' 50%, ' + backgroundType + ' 50%, ' + backgroundType + ')';
                var boxShadow = 'inset -5px 0 2px -2px ' + (backgroundState ? backgroundState : backgroundType);
                var styles = {
                    width: (this.TimeDiff(timeFrame.fromDate, timeFrame.toDate) * timePixelRatio) + 'px',
                    'min-width': this.displayedTimeframeSelected.label !== 'D' ? ((8 * 60 * 60 * 1000) * timePixelRatio) + 'px' : '',
                    left: (this.TimeDiff(this.timeFrameStart, timeFrame.fromDate) * timePixelRatio) + 'px',
                    background: background,
                    'box-shadow': boxShadow,
                };
                if(this.draggingTimeFrame && this.draggingTimeFrame.preference.id === timeFrame.preference.id) {
                    styles = {
                        width: (this.TimeDiff(this.draggingTime.fromDate, this.draggingTime.toDate) * timePixelRatio) + 'px',
                        'min-width': this.displayedTimeframeSelected.label !== 'D' ? ((8 * 60 * 60 * 1000) * timePixelRatio) + 'px' : '',
                        left: (this.TimeDiff(this.timeFrameStart, this.draggingTime.fromDate) * timePixelRatio) + 'px',
                        background: background,
                        'box-shadow': boxShadow,
                    };
                }
                return styles;
            },
            GetVacationBanStyles(vacationBan){
                let view = this;

                let totalWidth = $(this.$el).find('.time-marks').width();
                let timePixelRatio = totalWidth / this.timeFrameLength;

                let background = 'repeating-linear-gradient(' +
                    '45deg,'+
                    '#fec5e5,'+
                    '#fec5e5 16px,'+
                    '#ffd9ee 16px,'+
                    '#ffd9ee 32px'+
                    ')';
                if(vacationBan.type != 1){
                    background = 'repeating-linear-gradient(' +
                    '45deg,'+
                    '#d598fe,'+
                    '#d598fe 16px,'+
                    '#e7c3fe 16px,'+
                    '#e7c3fe 32px'+
                    ')';
                }

                var fromDate = view.$helpers.getMomentFromStringTZ(vacationBan.from, 'YYYY-MM-DDTHH:mmZ');
                var toDate = view.$helpers.getMomentFromStringTZ(vacationBan.to, 'YYYY-MM-DDTHH:mmZ');

                var styles = {
                    width: (this.TimeDiff(fromDate, toDate) * timePixelRatio) + 'px',
                    'min-width': this.displayedTimeframeSelected.label !== 'D' ? ((8 * 60 * 60 * 1000) * timePixelRatio) + 'px' : '',
                    left: (this.TimeDiff(this.timeFrameStart, fromDate) * timePixelRatio) + 'px',
                    background: background
                };
                return styles;
            },
            TimeDiff(a, b){
                return b._d.getTime() - a._d.getTime();
            },
            GetProfilePictureUrl(employee){
                if(!employee || !employee.employeePicture || !employee.employeePicture.server) return 'var(--contrast-1) no-repeat center/cover  url(../img/default.jpg)';
                var d = new Date();
                return 'var(--contrast-1) no-repeat center/cover  url(' + employee.employeePicture.server + '/api/file?id='+ employee.employeePicture.fileId +'&accessToken='+employee.employeePicture.accessToken +"&thumb=small"+ '&time='+Date.now()+')';
            },
            WeeksInMonth(moment) {
                var temp = moment.clone();

                var first = temp.startOf('month').week();
                var last = temp.endOf('month').week();

                if( first > last) {
                    last = first + last;
                }
                return last - first + 1;
            },
            updateEmployees: function(data) {
                // set employee data
                //console.log(data);
                let overviewA = [];
                var i;
                var roster = this;
                let tEmployeeMap = {};
                for (i = 0; i < data.length; i++) {
                    data[i].shiftsDate = {};
                    data[i].picture = this.GetProfilePictureUrl(data[i]);
                    tEmployeeMap[data[i].id] = data[i];
                    overviewA.push(data[i]);

                }
                this.employeeMap = tEmployeeMap;
                this.employees = overviewA;
                this.employees.sort( this.sortByName );
                //this.employeesFiltered = this.employees.slice();

            },
            sortByName: function(a,b){
                var x = a.lastName + " " + a.firstName;
                var y = b.lastName + " " + b.firstName;
                if ( x.toUpperCase() < y.toUpperCase() ) return -1;
                if ( x.toUpperCase() > y.toUpperCase() ) return 1;
                return 0;
            },
            updateUIData: function(data){
                this.uiData = data;
                let stateMap =  {};
                let typeMap = {};
                let subtypeMap = {};
                for(let i = 0; i < data.employeeAvailabilityStates.length; i++){
                    let employeeAvailabilityState = data.employeeAvailabilityStates[i];
                    stateMap[employeeAvailabilityState.id] = employeeAvailabilityState;

                }
                for(let i = 0; i < data.employeeAvailabilityTypes.length; i++){
                    let employeeAvailabilityType = data.employeeAvailabilityTypes[i];
                    typeMap[employeeAvailabilityType.id] = employeeAvailabilityType;

                }
                for(let i = 0; i < data.employeeAvailabilitySubtypes.length; i++){
                    let employeeAvailabilitySubtype = data.employeeAvailabilitySubtypes[i];
                    subtypeMap[employeeAvailabilitySubtype.id] = employeeAvailabilitySubtype;

                }

                this.employeeAvailabilityStateMap = stateMap;
                this.employeeAvailabilityTypeMap = typeMap;
                this.employeeAvailabilitySubtypeMap = subtypeMap;
            },
            loadActiveEmployees : function() {
                let url = '/api/sec/employee';

                let params = {
                    storeId: this.$store.state.storeId,
                    activeAtFrom: this.$helpers.getMomentTZ().year(this.currentYear).startOf('year').startOf('isoWeek').format(),
                    activeAtTo: this.$helpers.getMomentTZ().year(this.currentYear).endOf('year').add(1, 'weeks').startOf('isoWeek').format(),
                    active: true
                };


                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })

            },
            loadEmployeePreferences : function() {

                let url = '/api/sec/employeepreference';

                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.$helpers.getMomentTZ().year(this.currentYear).startOf('year').startOf('isoWeek').format(),
                    to: this.$helpers.getMomentTZ().year(this.currentYear).endOf('year').add(1, 'weeks').startOf('isoWeek').format()
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })

            },
            loadEmployeeSkills : function(payload) {
                if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
                    return new Promise((resolve, reject) => {
                        resolve({data:[]});
                    })
                } else {
                    let url = '/api/sec/employeeskill/any/employee';

                    let params = {
                        storeId: this.$store.state.storeId,
                    };

                    return this.axios({
                        method: 'post',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    });
                }
            },
            loadBusinessUnits : function() {

                let url = '/api/sec/businessunit';

                let params = {
                    storeId: this.$store.state.storeId,
                };


                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })


            },
            loadSpots : function() {

                let url = '/api/sec/spot';

                let params = {
                    storeId: this.$store.state.storeId,
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })


            },
            UpdateEmployeePreferenceTime(employeePreference, fromDate, toDate,callbackResponse){
                let view = this;
                let url = '/api/sec/employeepreference';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');

                let payload = {
                    storeId: this.$store.state.storeId,
                    id: employeePreference.id,
                    updateFields: []
                };

                let cfrom = this.$helpers.convertDateString(fromDate);
                payload.from = cfrom;
                payload.updateFields.push("from");
                let cto = this.$helpers.convertDateString(toDate);
                payload.to = cto;
                payload.updateFields.push("to");

                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    let result = response.data.data;
                    let preference = view.preferences.find(p => p.id === employeePreference.id);
                    if(preference) {
                        let isInMap = view.employeePreferenceMap[preference.id] != null;
                        preference.from = payload.from;
                        preference.to = payload.to;
                        let timeFrame = view.groupedEmployeeMap[preference.employeeId].timeFrames.find(t => t.preference.id === preference.id);
                        if(timeFrame) {
                            timeFrame.fromDate = view.$helpers.getMomentFromStringTZ(preference.from);
                            timeFrame.toDate = view.$helpers.getMomentFromStringTZ(preference.to);
                        }
                        if(isInMap){
                            view.$store.commit("setEmployeePreferenceMapEntry", result);
                        }

                    }
                    view.draggingTimeFrame = null;
                    view.draggingTime = null;
                    view.draggingMissingDayStyles = null;
                    view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('global.ui.editedX', [view.$tc('global.general.absence')]));
                    if(callbackResponse) callbackResponse(response);
                }).catch(function (error) {
                    view.error=true;
                    view.draggingTimeFrame = null;
                    view.draggingMissingDayStyles = null;
                    view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('global.ui.editedErrorX', [view.$t('global.general.absence')]));
                    console.log(error)
                })

            },
            createMultipleEmployeePreferences(requests){
                let view = this;
                let url = '/api/sec/employeepreference/multi';

                let params = {
                    storeId: this.$store.state.storeId
                }
                let payload = {
                    requests: requests
                };

                this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    params: params,
                    data: payload
                }).then(response => {
                    view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('roster.comp.absenceCreated'));
                    view.Refresh(true);

                }).catch(function (error) {
                    view.$helpers.error(view.$t('global.ui.creationFailed'), view.$t('roster.comp.createAbsenceError'));
                })
            },
            updateMultipleEmployeePreferences(requests){
                let view = this;
                let url = '/api/sec/employeepreference/multi';

                let params = {
                    storeId: this.$store.state.storeId
                }
                let payload = {
                    requests: requests
                };

                return this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    params: params,
                    data: payload
                })
            },
            convertPreferenceToPayload(preference){
                let payload = {
                    storeId: this.$store.state.storeId,
                    exclusive: true,
                    approved: preference.approved,
                    denied: preference.denied != null ? preference.denied : false,
                };
                payload.factor = preference.factor;
                /*payload.from = this.$helpers.convertDateTimeString(preference.fromDate, preference.fromTime);
                payload.to = this.$helpers.convertDateTimeString(preference.toDate, preference.toTime);*/
                if(preference.to < preference.from){
                    preference.to = preference.to.add(1, 'days');
                }
                payload.from = this.$helpers.convertDateString(preference.from);
                payload.to = this.$helpers.convertDateString(preference.to);
                if(!this.$helpers.isBlank(preference.employeeId)){
                    payload.employeeId = preference.employeeId
                }
                if(!this.$helpers.isBlank(preference.spotId)){
                    payload.spotId = preference.spotId
                }
                if(!this.$helpers.isBlank(preference.comment)){
                    payload.comment = preference.comment
                }
                payload.state = preference.state;
                if(payload.state != 1){
                    payload.type = null;
                    payload.subtype = null;
                    payload.workValue = null;
                } else {
                    payload.type = preference.type;
                    if(payload.type == 8 || payload.type == 4 || payload.type == 2){
                        payload.subtype = preference.subtype;
                        if(payload.comment == null && payload.subtype != null){
                            payload.comment = this.employeeAvailabilitySubtypeMap[payload.subtype].label_de;
                        }
                    } else {
                        payload.subtype = null;
                    }
                    payload.workValue = preference.workValue;
                }
                payload.alwaysWork = preference.alwaysWork;
                payload.overrideContract = preference.overrideContract;
                payload.countsAsHoliday = preference.countsAsHoliday;
                if(!(payload.type == 4 || payload.type == 2 || payload.type == 7 || payload.type == 8) || payload.state != 1){
                    payload.countsAsHoliday = false;
                }

                return payload;
            },
            createEmployeePreference: function(preference){
                let view = this;
                let url = '/api/sec/employeepreference';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');

                let payload = this.convertPreferenceToPayload(preference);

                this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    let preference = response.data.data;
                    view.preferences.push(response.data.data);
                    if(view.$helpers.getMomentFromStringTZ(preference.from) <= view.$helpers.getMomentFromStringTZ(view.rosterFromTo.to)
                        && view.$helpers.getMomentFromStringTZ(preference.from) >= view.$helpers.getMomentFromStringTZ(view.rosterFromTo.from)){
                        view.$store.commit("setEmployeePreferenceMapEntry", preference);
                    }
                    if(!preference.approved) view.$store.commit("setEmployeeAllUnapprovedPreferenceMapEntry", preference);
                    if(preference.employeeId) view.calculatedEntitlementEmployeeMap[preference.employeeId] = view.getCalculatedEntitlementForEmployee(preference.employeeId);
                    view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('roster.comp.absenceCreated'));

                    view.$forceUpdate();

                }).catch(function (error) {
                    view.$helpers.error(view.$t('global.ui.creationFailed'), view.$t('roster.comp.createAbsenceError'));
                })
            },


            updateEmployeePreference: function(preference){

                let view = this;
                let url = '/api/sec/employeepreference';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');

                let preferenceObject = this.preferences.find(p => p.id === preference.id);
                let payload = {
                    storeId: this.$store.state.storeId,
                    id: preference.id,
                    updateFields: []
                }
                if(preference.to < preference.from){
                    preference.to = preference.to.add(1, 'days');
                }
                let ofrom = preferenceObject.from;
                let cfrom = preference.from;
                if(ofrom != cfrom){
                    payload.from = cfrom.format();
                    payload.updateFields.push("from");
                }
                let oto = preferenceObject.to;
                let cto = preference.to;
                if(oto != cto){
                    payload.to = cto.format();
                    payload.updateFields.push("to");
                }
                if(preferenceObject.factor != preference.factor){
                    payload.factor = preference.factor;
                    payload.updateFields.push("factor");
                }

                if(preferenceObject.spotId != preference.spotId){
                    payload.spotId = preference.spotId;
                    payload.updateFields.push("spotId");
                }

                if(preferenceObject.comment != preference.comment){
                    payload.comment = preference.comment;
                    payload.updateFields.push("comment");
                }

                if(preferenceObject.overrideContract != preference.overrideContract){
                    payload.overrideContract = preference.overrideContract;
                    payload.updateFields.push("overrideContract");
                }

                payload.state = preference.state;
                payload.updateFields.push("state");
                if(payload.state != 1){
                    payload.workValue = -1;
                    payload.updateFields.push("workValue");
                    payload.type = null;
                    payload.updateFields.push("type");
                    payload.subtype = null
                    payload.updateFields.push("subtype");
                } else {
                    payload.workValue = preference.workValue;
                    payload.updateFields.push("workValue");
                    payload.type = preference.type;
                    payload.updateFields.push("type");
                    if(payload.type == 8 || payload.type == 4 || payload.type == 2){
                        payload.subtype = preference.subtype;
                        payload.updateFields.push("subtype");
                        if(this.employeeAvailabilitySubtypeMap[preference.subtype]){
                            let labelKey = "label_de"; //for switching to english in future
                            let label = this.employeeAvailabilitySubtypeMap[preference.subtype][labelKey];
                            if(this.$helpers.isBlank(preference.comment) || Object.values(this.employeeAvailabilitySubtypeMap).filter(i => i[labelKey] === preference.comment).length > 0){
                                payload.comment = label;
                                preference.comment = label;
                                payload.updateFields.push("comment");
                            }
                        }

                    } else {
                        payload.subtype = null
                        payload.updateFields.push("subtype");
                    }

                }
                if(preferenceObject.alwaysWork != preference.alwaysWork){
                    payload.alwaysWork = preference.alwaysWork;
                    payload.updateFields.push("alwaysWork");
                }
                payload.countsAsHoliday = preference.countsAsHoliday;
                if(!(payload.type == 4 || payload.type == 2 || payload.type == 7 || payload.type == 8) || payload.state != 1){
                    payload.countsAsHoliday = false;
                }
                payload.updateFields.push("countsAsHoliday");


                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    let existing = view.preferences.find(p => p.id === preference.id);
                    let result = response.data.data;

                    if(existing){
                        let keys = Object.keys(existing);
                        for(let x in keys){
                            delete existing[x];
                        }
                        for(let x in result){
                            existing[x] = result[x];
                        }
                    } else {
                        view.preferences.push(result);
                    }
                    if(view.$helpers.getMomentFromStringTZ(result.from) <= view.$helpers.getMomentFromStringTZ(view.rosterFromTo.to)
                        && view.$helpers.getMomentFromStringTZ(result.from) >= view.$helpers.getMomentFromStringTZ(view.rosterFromTo.from)){

                        view.$store.commit("invalidateState", {states: ['employeePreferenceMapState']});
                        view.$store.commit("setEmployeePreferenceMapEntry", result);

                    }
                    view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('global.ui.editedX', [view.$tc('global.general.absence')]));

                    if(result.employeeId) view.calculatedEntitlementEmployeeMap[result.employeeId] = view.getCalculatedEntitlementForEmployee(result.employeeId);

                    if(result.approved || result.denied){
                        view.$store.commit("deleteEmployeeAllUnapprovedPreferenceMapEntry", result);
                    }else{
                        view.$store.commit("setEmployeeAllUnapprovedPreferenceMapEntry", result);
                    }
                    view.$forceUpdate();

                }).catch(function (error) {
                    console.log(error);
                    view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('global.ui.editedErrorX', [view.$t('global.general.absence')]));
                })

            },

            SendBusinessUnitsPriorityUpdate: function(data){
                let view = this;
                let url = '/api/sec/userunitsortupdate';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/userunitsortupdate');

                data = data.filter(d => d.unitId);

                let payload = {
                    data: data
                };
                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.updateUserUnitSort(data);
                    view.$helpers.success(view.$t('global.notifications.saved'), view.$t('shift.template.newOrderSaved'));
                }).catch(function (error) {
                    view.$helpers.warning(view.$t('global.notifications.error'), view.$t('global.notifications.errorMessage'));
                    view.error=true;
                    console.log(error)
                })
            },

            loadUserUnitSort : function() {

                let url = '/api/sec/userunitsort';

                let params = {
                    storeId: this.$store.state.storeId,
                };
                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })
            },
            updateUserUnitSort: function(data){
                let userunitsort = []
                for (let i = 0; i < data.length; i++) {
                    userunitsort.push(data[i]);
                }
                Object.values(this.customSpotMap).forEach(u => {
                    if(!userunitsort.find(s => s.unitId === u.id)){
                        userunitsort.push({name: u.name, unitId: u.id, priority: userunitsort.length});
                    }
                });
                this.userunitsort = userunitsort;
            },
            sortEmployeeByName: function(a,b){
                if ( a.employee.lastName.toUpperCase() < b.employee.lastName.toUpperCase() ) return -1;
                if ( a.employee.firstName.toUpperCase() > b.employee.firstName.toUpperCase() ) return 1;
                return 0;
            },
            loadSkills : function() {

                let url = '/api/sec/skill';

                let params = {
                    storeId: this.$store.state.storeId,
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })


            },
            loadVacationBans: function () {
              let view = this;
              let url = '/api/sec/vacationban';
              let params = {
                storeId: this.$store.state.storeId,
                from: this.$helpers.getMomentTZ().year(this.$store.state.rosterFromTo.year).month(this.$store.state.rosterFromTo.month).startOf('month').format(),
                to: this.$helpers.getMomentTZ().year(this.$store.state.rosterFromTo.year).month(this.$store.state.rosterFromTo.month).startOf('month').add(1, 'month').format()
              };

              return this.axios({
                method: 'get',
                params: params,
                headers: {
                  'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
              }).then(response => {
                view.updateVacationBans(response.data)
              }).catch(function (error) {
                console.log(error)
              });
            },
            updateVacationBans: function (data) {
              let tvacationsbans = [];
              let tMap = {};
              for (let i = 0; i < data.length; i++) {
                tvacationsbans.push(data[i]);
                tMap[data[i].id] = data[i];

              }

              this.vacationBanMap = tMap;
            },
            OpenEmployeePrefDaysExportPopup(){
                let view = this;

                let preference = {state: 1, type: 1, subtype: null, from: this.$helpers.getMomentTZ().startOf('year'), to: this.$helpers.getMomentTZ().endOf('year')}

                let stateItems = [];
                Object.values(view.employeeAvailabilityStateMap).filter(s => s.selectable).forEach(function(state){
                    var option = {label: state.label_de, value: state.id, state: state};
                    stateItems.push(option);
                });

                let typeItems = this.GenerateTypeSelect(preference.state);
                let subtypeItems_8 = this.GenerateSubtypeSelect(8);
                let selectedSubtypeItem_8 = subtypeItems_8.find(i => i.value == preference.subtype);

                let subtypeItems_2 = this.GenerateSubtypeSelect(2);

                let selectedSubtypeItem_2 = subtypeItems_2.find(i => i.value == preference.subtype);

                let subtypeItems_4 = this.GenerateSubtypeSelect(4);
                let selectedSubtypeItem_4 = subtypeItems_4.find(i => i.value == preference.subtype);


                let employeeItems = Object.values(this.employeeMap).filter(e => e.active).sort((a, b) => a.lastName.localeCompare(b.lastName)).map(e => {return {label: e.lastName+" "+e.firstName, value: e.id}});

                let dataEntries = [
                        {label: this.$t('global.ui.allEmployees'), key: 'allEmployees', hidden: false, disabled: false, type: 'bool', value: true,
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let empl = datafill.entries.find(i => i.key == 'employees');

                            if(entryBeforeUpdate.value == true){

                                employeeItems.forEach(bal => bal.selected = false);
                                empl.dropdownSearchState = {
                                    toggled: false,
                                    displayedItems: [],
                                    input: '',
                                    items: employeeItems,
                                    selectMultiple: true,
                                    selectedItems: employeeItems.filter(item => item.selected),
                                    selectedItem: {},
                                    onceSelected: function ($event, item, searchbar){

                                    },
                                styleLight: true,
                                placeholder: this.$t('global.ui.selectEmployee'),
                                }
                                empl.hidden = true;


                            } else {
                                empl.hidden = false;
                            }

                            return entryBeforeUpdate;
                        }
                    },
                    {label: this.$tc('global.general.employee'), key: 'employees', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: employeeItems,
                            selectMultiple: true,
                            selectedItems: [],
                            selectFirst: false,

                            styleLight: true,
                        }},
                    {label: this.$t('global.general.fromDay'), key: 'fromDate', hidden: false, type: 'date', value: preference.from, flexGroup: true, styles:{'margin-right' : '10px'}},
                    {label: this.$t('global.general.toDay'), key: 'toDate', hidden: false, type: 'date', value: preference.to, flexGroup: true},

                    {label: this.$t('global.general.status'), key: 'state', hidden: false, type: 'dropdownsearch', value: preference.state, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: stateItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst: true,
                            selectIf: (item) => { return item.value === preference.state},
                            styleLight: true,
                        }},
                    {label: this.$tc('global.general.type'), key: 'type', hidden: false, type: 'dropdownsearch', value: preference.type, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: typeItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst: true,
                            selectIf: (item) => { return item.value === preference.type},
                            styleLight: true,
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let state = datafill.entries.find(i => i.key == 'state').value;

                            if(state != 1){
                                entryBeforeUpdate.value = null;
                                entryBeforeUpdate.hidden = true;
                            } else {
                               entryBeforeUpdate.hidden = false;
                            }
                            return entryBeforeUpdate;
                        }
                    },
                    {label: this.$t('global.ui.reason'), key: 'subtype_8', hidden: preference.type != 8, type: 'dropdownsearch', value: selectedSubtypeItem_8 ? selectedSubtypeItem_8.value : null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: subtypeItems_8,
                            selectMultiple: false,
                            selectedItem: selectedSubtypeItem_8,
                            selectedItems: [selectedSubtypeItem_8],
                            selectFirst: false,
                            styleLight: true,
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let state = datafill.entries.find(i => i.key == 'state').value;
                            let type = datafill.entries.find(i => i.key == 'type').value;

                            if(state != 1 || (type != 8)){
                                entryBeforeUpdate.value = null;
                                entryBeforeUpdate.hidden = true;
                            } else {
                               entryBeforeUpdate.hidden = false;
                            }
                            return entryBeforeUpdate;
                        }

                    },
                    {label: this.$t('pref.main.detail'), key: 'subtype_2', hidden: preference.type != 2, type: 'dropdownsearch', value: selectedSubtypeItem_2 ? selectedSubtypeItem_2.value : null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: subtypeItems_2,
                            selectMultiple: false,
                            selectedItem: selectedSubtypeItem_2,
                            selectedItems: [selectedSubtypeItem_2],
                            selectFirst: false,
                            styleLight: true,
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let state = datafill.entries.find(i => i.key == 'state').value;
                            let type = datafill.entries.find(i => i.key == 'type').value;

                            if(state != 1 || (type != 2)){
                                entryBeforeUpdate.value = null;
                                entryBeforeUpdate.hidden = true;
                            } else {
                               entryBeforeUpdate.hidden = false;
                            }
                            return entryBeforeUpdate;
                        }

                    },
                    {label: this.$t('pref.main.detail'), key: 'subtype_4', hidden: preference.type != 4, type: 'dropdownsearch', value: selectedSubtypeItem_4 ? selectedSubtypeItem_4.value : null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: subtypeItems_4,
                            selectMultiple: false,
                            selectedItem: selectedSubtypeItem_4,
                            selectedItems: [selectedSubtypeItem_4],
                            selectFirst: false,
                            styleLight: true,
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let state = datafill.entries.find(i => i.key == 'state').value;
                            let type = datafill.entries.find(i => i.key == 'type').value;


                            if(state != 1 || (type != 4)){
                                entryBeforeUpdate.value = null;
                                entryBeforeUpdate.hidden = true;
                            } else {
                               entryBeforeUpdate.hidden = false;
                            }
                            return entryBeforeUpdate;
                        }

                    },
                    {label: this.$t('pref.main.includeDetail'), key: 'includeDetail', hidden: false, type: 'bool', value: true},
                    {label: this.$t('pref.main.includeAmountDays'), key: 'includeDays', hidden: false, type: 'bool', value: true},
                    {label: this.$t('pref.main.includeAmountWorkDays'), key: 'includeWorkDays', hidden: false, type: 'bool', value: true},
                    {label: this.$t('pref.main.includeSignature'), key: 'includeSigning', hidden: false, type: 'bool', value: true},

                ];





                let state =  {
                    entries: dataEntries,
                    errorCheck: [
                        (entries) => {
                            if((entries.employees == null || entries.employees.length == 0) && !entries.allEmployees){
                                return {key: 'employeeId', type: 'error', label: this.$tc('global.general.employee'), text: this.$t('pref.main.pleaseSelectEmployee')}
                            } else {
                                return null
                            }
                        },
                        (entries) => {
                            if(entries.fromDate > entries.toDate){
                                return {key: 'fromDate', type: 'error', label: this.$t('global.general.fromDay'), text: this.$t('indicator.meo.startBeforeEnd')}
                            } else {
                                return null
                            }
                        },
                        (entries) => {
                            if(entries.toDate.diff(entries.fromDate, 'days') > 367){
                                return {key: 'toDate', type: 'error', label: this.$t('global.general.toDay'), text: this.$t('pref.main.twelveMonthDistance')}
                            } else {
                                return null
                            }
                        },
                    ],
                    selectCallback: function (preference) {

                        if(preference.type == 8){
                            preference.subtype = preference.subtype_8;
                        } else if (preference.type == 4){
                            preference.subtype = preference.subtype_4;
                        } else if (preference.type == 2){
                            preference.subtype = preference.subtype_2;
                        }

                        delete preference.subtype_8;
                        delete preference.subtype_4;
                        delete preference.subtype_2;

                        if(preference.allEmployees){
                            preference.employees = Object.values(view.employeeMap).filter(e => e.active).map(e => e.id);
                        }

                        view.loadEmployeePreferencesForDayExport(preference)
                        .then(result => {
                            view.exportEmployeePreferencesForDayPDF(preference.employees, preference.fromDate, preference.toDate, result, preference.includeDetail, preference.includeDays,preference.includeWorkDays, preference.includeSigning);
                        }).catch(function (error) {
                            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.createdErrorX'[view.$t('roster.view.report')]));

                            console.log(error)
                        })


                    }
                };


                this.$helpers.OpenPopup({

                    type: 'datafill',
                    componentState: state,
                    header: this.$t('pref.main.absenceTimeframeExport'),
                    centered: true,
                    expanded: true,
                });
            },
            loadEmployeePreferencesForDayExport: function (pref) {
                let url = '/api/sec/employeepreference/any/employee';
                let params = {
                    storeId: this.$store.state.storeId,
                    from: pref.fromDate.format(),
                    to: pref.toDate.format(),
                    approved: true,
                };
                if(pref.state != null){
                    params.state = pref.state;
                }
                if(pref.type != null){
                    params.type = pref.type;
                }
                if(pref.subtype != null){
                    params.subtype = pref.subtype
                }

                let payload = {
                    ids: pref.employees
                }

                return this.$helpers.RecursivePOSTPaged(url, [], params, payload, 1)
                .then((result) => {
                    return new Promise((resolve, reject) => {
                        resolve(result);
                    });
                }).catch((e) => {
                    return new Promise((resolve, reject) => {
                        reject(e);
                    });

                });
            },
            exportEmployeePreferencesForDayPDF(employees, from, to, prefs, includeDetail = true, includeDays = true, includeWorkDays = true, includeSigning = false){
                let view = this;
                var date = new Date();
                let ts = ( date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2( date.getDate()) + this.$helpers.pad2( date.getHours() ) + this.$helpers.pad2( date.getMinutes() ) + this.$helpers.pad2( date.getSeconds() ) );


                let headers = [this.$t('pages.employeeCoreData.personnelNumber'), this.$t('pages.employeeData.name'), this.$t('global.general.from').toLowerCase(), this.$t('global.general.to').toLowerCase(), this.$tc('global.general.absence'), this.$tc('global.general.type')];
                if(includeDetail){
                    headers.push(this.$t('pref.main.detail'))
                }
                if(includeDays){
                    headers.push('Tage');
                }
                if(includeWorkDays){
                    headers.push(this.$t('store.settings.workingDays'))
                }
                /*
                if(includeSigning){
                    headers.push('Unterschrift')
                }*/

                let filename = this.$t('global.menubar.preferences') + '_' + this.storeSettings.name + '_' + ts;



                var repDoc = this.$helpers.tableReportDoc(
                    headers,
                    from.format("DD.MM.YYYY")+" - "+to.format("DD.MM.YYYY"),
                    this.$t('global.menubar.preferences') + ' '+this.storeSettings.name,
                    this.storeSettings.description,
                    this.userFullname,
                    9);
                var doc = repDoc.doc;
                let contentOffsetY = repDoc.contentOffsetY;
                doc.setFontSize(12);


                let empPrefMap = {};
                 prefs.sort((a, b) => {
                    let aDate = this.$helpers.getMomentFromStringTZ(a.from);
                    let bDate = this.$helpers.getMomentFromStringTZ(b.from);

                    return aDate.unix() - bDate.unix();
                }).forEach(p => {
                    if(empPrefMap[p.employeeId] == null){
                        empPrefMap[p.employeeId] = [];
                    }
                    empPrefMap[p.employeeId].push(p);
                })
                let count = 0;
                employees.forEach(employeeId => {

                    let body = [];
                    let currentContract = this.employeeMainContractMap[employeeId]
                    let workDays = currentContract ? currentContract.workDays : this.storeSettings.workDays;
                    let daySum = 0;
                    let workDaySum = 0;
                    let employee = this.employeeMap[employeeId];

                    let prefs = empPrefMap[employeeId] ? empPrefMap[employeeId] : [];
                    if(prefs.length > 0){
                        if(count > 0){
                            doc.addPage();
                        } else {
                            count +=1;
                        }
                        prefs.forEach(p => {
                            if(p.approved){
                                let pFrom = this.$helpers.getMomentFromStringTZ(p.from);
                                let pTo = this.$helpers.getMomentFromStringTZ(p.to);
                                let dc = 0;
                                let wdc = 0;
                                let temp = pFrom.clone();
                                while(temp < pTo){
                                    dc +=1;
                                    if(workDays.includes(temp.isoWeekday())){
                                        wdc +=1;
                                    }
                                    temp = temp.add(1,'days');
                                }
                                let stateName = this.employeeAvailabilityStateMap[p.state].label_de;
                                let typeName = p.type != null ? this.employeeAvailabilityTypeMap[p.type].label_de : '-';
                                let subtypeName = p.subtype != null ? this.employeeAvailabilitySubtypeMap[p.subtype].label_de : '-';
                                let line = [employee.personnelId, employee.lastName+' '+employee.firstName, pFrom.format("DD.MM.YYYY HH:mm"), pTo.format("DD.MM.YYYY HH:mm"), stateName, typeName];
                                if(includeDetail){
                                    line.push(subtypeName)
                                }
                                if(includeDays){
                                    line.push(dc)
                                }
                                if(includeWorkDays){
                                    line.push(wdc)
                                }
                                daySum += dc;
                                workDaySum += wdc;
                                body.push(line)
                            }
                        })
                        if(includeDays || includeWorkDays){
                            let line = [this.$t('global.ui.sum'), employee.lastName+' '+employee.firstName, '', '', '', ''];
                            if(includeDetail){
                                line.push('')
                            }
                            if(includeDays){
                                line.push(daySum)
                            }
                            if(includeWorkDays){
                                line.push(workDaySum)
                            }
                            body.push(line);

                        }


                        doc.autoTable({
                            startY: contentOffsetY,
                            head: [headers],
                            body: body,
                            headStyles: {
                                fillColor: [109,141,33],
                                fontSize: 7,
                            },
                            bodyStyles: {
                                fontSize: 7
                            },
                            columnStyles: {

                            }
                        })
                        if(includeSigning){
                            doc.text(this.$t('pref.main.signature') + ": ", 15, doc.lastAutoTable.finalY + 15);
                            doc.line(38, doc.lastAutoTable.finalY + 16, 90, doc.lastAutoTable.finalY + 16, 'F');
                        }

                        contentOffsetY = 20;
                    }

                })




                view.$helpers.previewPdf(doc, filename+ '.pdf');
            },
            OpenTransformHolidaysPopup(){
                let view = this;



                let typeItems = this.GenerateTypeSelect(1);
                let vacTypeItem = typeItems.find(i => i.value == 1);
                vacTypeItem.selected = true;



                let employeeItems = Object.values(this.employeeMap).filter(e => e.active).sort((a, b) => a.lastName.localeCompare(b.lastName)).map(e => {return {label: e.lastName+" "+e.firstName, value: e.id}});

                let dataEntries = [


                    {label: this.$t('pref.main.absenceType'), key: 'type', hidden: false, type: 'dropdownsearch', value: 1, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: typeItems,
                            selectMultiple: true,
                            selectedItems: typeItems.filter(i => i.value == 1),
                            selectFirst: false,

                            styleLight: true,
                        },

                    },
                    {label: this.$t('pref.main.createPcToo'), key: 'useEmployees', hidden: false, type: 'bool', value: false},
                    {label: this.$tc('global.general.employee'), key: 'employeeId', hidden: view.$helpers.CheckDatafillKeysForHidden('useEmployees'), type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: employeeItems,
                            selectMultiple: true,
                            selectedItems: [],
                            selectFirst: false,

                            styleLight: true,
                        }},


                ];





                let state =  {
                    description: this.$t('pref.main.convertWhichAbsencesPC'),
                    entries: dataEntries,
                    errorCheck: [

                    ],
                    selectCallback: function (data) {

                        view.transformHolidayDays(data.type, data.useEmployees ? data.employeeId : []);


                    }
                };


                this.$helpers.OpenPopup({

                    type: 'datafill',
                    componentState: state,
                    header: this.$t('pref.main.convertHolidaysIntoPc'),
                    centered: true,
                    expanded: true,
                });
            },
            transformHolidayDays(prefTypes = [], employees = []){
                let view = this;
                let holidays = new Set();
                let holidayMomentMap = {};

                Object.values(this.holidayMap).forEach(h => {

                    if(h.federalHoliday){
                        let from = this.$helpers.getMomentFromStringTZ(h.from);
                        let to = this.$helpers.getMomentFromStringTZ(h.to);

                        let temp = from.clone();
                        while(temp < to){
                            if(temp < this.currentMonthToTZ && temp >= this.currentMonthFromTZ){
                                holidays.add(temp.format("YYYY-MM-DD"));
                                let hDate = this.$helpers.getMomentFromStringTZ(temp.format("YYYY-MM-DD"), 'YYYY-MM-DD');
                                let hToDate = hDate.clone().add(1, 'days');
                                holidayMomentMap[temp.format("YYYY-MM-DD")] = {from: hDate, to: hToDate};
                            }

                            temp = temp.add(1, 'days');
                        }
                    }

                });

                let toCreate = [];
                let toUpdate = [];
                Object.values(this.employeePreferenceMap).filter(p => p.state == 1 && prefTypes.includes(p.type) && !p.alwaysWork && p.workValue == -1 && p.approved)
                .forEach(p => {
                    let from = this.$helpers.getMomentFromStringTZ(p.from);
                    let to = this.$helpers.getMomentFromStringTZ(p.to);
                    holidays.forEach(h => {
                        let hDate = holidayMomentMap[h].from;
                        let hToDate = holidayMomentMap[h].to;
                        if(hToDate > from && hDate < to){
                            if(hDate <= from){
                                toUpdate.push({id: p.id, from: hDate.format(), to: hToDate.format(), state: 1, type: 8, subtype: 20,
                                    updateFields: ["from", "to", "state", "type", "subtype"]
                                });

                            } else {
                                toUpdate.push({id: p.id, from: from.format(), to: hDate.format(),
                                    updateFields: ["from", "to"]
                                });
                                toCreate.push({employeeId: p.employeeId, from: hDate.format(), to: hToDate.format(), state: 1, type: 8, subtype: 20, workValue: -1, alwaysWork: false, approved: true, denied: false, exclusive: true, overrideContract: true, countsAsHoliday: false, factor: 1});

                            }
                            if(to > hToDate){
                                toCreate.push({employeeId: p.employeeId, from: hToDate.format(), to: to.format(), state: p.state, type: p.type, subtype: p.subtype, workValue: -1, alwaysWork: false, approved: true, denied: false, exclusive: true, overrideContract: true, countsAsHoliday: false, factor: 1});
                            }

                        }
                    })
                });

                if(employees.length > 0){

                    view.employees.forEach(employee => {
                        if(employee.active && employees.includes(employee.id)){

                            holidays.forEach(h => {
                                let hDate = holidayMomentMap[h].from;
                                let hToDate = holidayMomentMap[h].to;
                                let contracts = this.employeeIdEmployeeContractMap[employee.id] != null ? this.employeeIdEmployeeContractMap[employee.id] : [];

                                let validContracts = contracts.filter(c => view.employeeContractMomentMap[c.id].fromDate < hToDate && (view.employeeContractMomentMap[c.id].toDate == null || view.employeeContractMomentMap[c.id].toDate > hDate));

                                let prefs = Object.values(this.employeePreferenceMap).filter(p => p.employeeId == employee.id && p.state == 1 && view.employeePreferenceMomentMap[p.id].from < hToDate && view.employeePreferenceMomentMap[p.id].to > hDate);
                                if(prefs.length == 0 && validContracts.length > 0){
                                    toCreate.push({employeeId: employee.id, from: hDate.format(), to: hToDate.format(), state: 1, type: 8, subtype: 20, workValue: -1, alwaysWork: false, approved: true, denied: false, exclusive: true, overrideContract: true, countsAsHoliday: false, factor: 1});

                                }
                            })
                        }
                    })

                }

                if(toUpdate.length > 0){
                    this.updateMultipleEmployeePreferences(toUpdate)
                    .then(response => {
                        if(toCreate.length > 0){
                            view.createMultipleEmployeePreferences(toCreate);
                        } else {
                            view.$helpers.success(this.$t('global.notifications.updateMessage'), view.$t('global.ui.editedX', [view.$tc('global.general.absence')]));
                            this.Refresh(true);
                        }

                    }).catch(function (error) {
                        console.log(error)
                        view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('roster.comp.editAbsencesError'));
                    })
                } else if(toCreate.length > 0){
                    view.createMultipleEmployeePreferences(toCreate);
                } else {
                    view.$helpers.success(this.$t('pref.main.noChanges'), this.$t('pref.main.noChangesNeeded'));
                }


            },
            OpenTransformHolidaysToZeroWorkTimePopup(){
                let view = this;



                let typeItems = this.GenerateTypeSelect(1);
                typeItems.filter(i => i.value == 1 || i.value == 2 || i.value == 6).forEach(i => {
                    i.selected = true;
                })
                



                let employeeItems = Object.values(this.employeeMap).filter(e => e.active).sort((a, b) => a.lastName.localeCompare(b.lastName)).map(e => {return {label: e.lastName+" "+e.firstName, value: e.id}});

                let dataEntries = [


                    
                    {label: this.$t('global.ui.allEmployees'), key: 'allEmployees', hidden: false, type: 'bool', value: true},
                    {label: this.$tc('global.general.employee'), key: 'employeeIds', hidden: view.$helpers.CheckDatafillKeysForHiddenInverted('allEmployees'), type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: employeeItems,
                            selectMultiple: true,
                            selectedItems: [],
                            selectFirst: false,

                            styleLight: true,
                    }},
                    {label: this.$t('pref.main.absenceType'), key: 'type', hidden: false, type: 'dropdownsearch', value: [1, 2, 6], selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: typeItems,
                            selectMultiple: true,
                            selectedItems: typeItems.filter(i => i.value == 1 || i.value == 2 || i.value == 6),
                            selectFirst: false,

                            styleLight: true,
                        },

                    },


                ];





                let state =  {
                    description: this.$t('pref.main.convertWhichAbsencesZeroWorkTime'),
                    entries: dataEntries,
                    errorCheck: [

                    ],
                    selectCallback: function (data) {

                        view.transformHolidayDaysToZeroWorkTime(data.type, data.allEmployees, data.employeeIds);


                    }
                };


                this.$helpers.OpenPopup({

                    type: 'datafill',
                    componentState: state,
                    header: this.$t('pref.main.convertHolidaysIntoZeroWorkTime'),
                    centered: true,
                    expanded: true,
                });
            },
            transformHolidayDaysToZeroWorkTime(prefTypes = [], allEmployees = true, employees = []){
                let view = this;
                let holidays = new Set();
                let holidayMomentMap = {};

                Object.values(this.holidayMap).forEach(h => {

                    if(h.federalHoliday){
                        let from = this.$helpers.getMomentFromStringTZ(h.from);
                        let to = this.$helpers.getMomentFromStringTZ(h.to);

                        let temp = from.clone();
                        while(temp < to){
                            if(temp < this.currentMonthToTZ && temp >= this.currentMonthFromTZ){
                                holidays.add(temp.format("YYYY-MM-DD"));
                                let hDate = this.$helpers.getMomentFromStringTZ(temp.format("YYYY-MM-DD"), 'YYYY-MM-DD');
                                let hToDate = hDate.clone().add(1, 'days');
                                holidayMomentMap[temp.format("YYYY-MM-DD")] = {from: hDate, to: hToDate};
                            }

                            temp = temp.add(1, 'days');
                        }
                    }

                });

                let toCreate = [];
                let toUpdate = [];
                Object.values(this.employeePreferenceMap)
                .filter(p => p.state == 1 && 
                             prefTypes.includes(p.type) && 
                             !p.alwaysWork && 
                             p.workValue == -1 && 
                             p.approved && 
                             (allEmployees || employees.includes(p.employeeId)))
                .forEach(p => {
                    let from = this.$helpers.getMomentFromStringTZ(p.from);
                    let to = this.$helpers.getMomentFromStringTZ(p.to);
                    holidays.forEach(h => {
                        let hDate = holidayMomentMap[h].from;
                        let hToDate = holidayMomentMap[h].to;
                        if(hToDate > from && hDate < to){
                            if(hDate <= from){
                                toUpdate.push({id: p.id, from: hDate.format(), to: hToDate.format(), workValue: 0, alwaysWork: false,
                                    updateFields: ["from", "to", "workValue", "alwaysWork"]
                                });

                            } else {
                                toUpdate.push({id: p.id, from: from.format(), to: hDate.format(),
                                    updateFields: ["from", "to"]
                                });
                                toCreate.push({employeeId: p.employeeId, from: hDate.format(), to: hToDate.format(), state: 1, type: p.type, subtype: p.subtype, workValue: 0, alwaysWork: false, approved: true, denied: false, exclusive: true, overrideContract: true, countsAsHoliday: false, factor: 1});

                            }
                            if(to > hToDate){
                                toCreate.push({employeeId: p.employeeId, from: hToDate.format(), to: to.format(), state: p.state, type: p.type, subtype: p.subtype, workValue: -1, alwaysWork: false, approved: true, denied: false, exclusive: true, overrideContract: true, countsAsHoliday: false, factor: 1});
                            }

                        }
                    })
                });

                

                if(toUpdate.length > 0){
                    this.updateMultipleEmployeePreferences(toUpdate)
                    .then(response => {
                        if(toCreate.length > 0){
                            view.createMultipleEmployeePreferences(toCreate);
                        } else {
                            view.$helpers.success(this.$t('global.notifications.updateMessage'), view.$t('global.ui.editedX', [view.$tc('global.general.absence')]));
                            this.Refresh(true);
                        }

                    }).catch(function (error) {
                        console.log(error)
                        view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('roster.comp.editAbsencesError'));
                    })
                } else if(toCreate.length > 0){
                    view.createMultipleEmployeePreferences(toCreate);
                } else {
                    view.$helpers.success(this.$t('pref.main.noChanges'), this.$t('pref.main.noChangesNeeded'));
                }


            },

        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .employee-preference-view{
        position: relative;
    }

    .employee-preference-view > .header{
        background: var(--contrast-1);
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 60px;
        text-align: center;
        z-index: 2;

    }
    .employee-preference-view > .header > * {
        display: inline-flex;
        align-items: center;
    }

    .employee-preference-view > .header {
        justify-content: center;

    }
    .employee-preference-view > .header > .button.filter{

        float: initial;
        margin: 0 10px;
        transform: translateY(1px);

    }

    .options{
        display: inline-block;
    }

    .options .label{
        text-align: center;
        border-radius: 5px;
        transition: .2s;
        height: 25px;
        width: 35px;
        border: 1px solid var(--contrast-5);
        border-right: none;
        border-radius: 0;
        line-height: 190%;
        cursor: pointer;
    }
    .options .label:first-child{
        border-radius: 5px 0 0 5px;
    }
    .options .label:last-child{
        border-radius: 0 5px 5px 0;
        border-right: 1px solid var(--contrast-5);
    }
    .options .label.selected, .options .label:hover{
        background: #6d8d23;
        color: white;
    }

    .grid{
        padding-top: 40px;
        text-align: center;
        position: relative;
        height: 100%;
    }

    .grid > .header{
        position: fixed;
        top: 145px;
        left: 6px;
        width: 100%;
        z-index: 20;
        padding-left: 10px;
    }

    .employee-preference-view .grid > .header{
        width: 16em;
    }

    .group{
        margin-bottom: 10px;
    }

    .group > .header{
        width: 255px;
        height: 19px;
        background: #6d8d23;
        border-top-left-radius: 50px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
        border-bottom-left-radius: 50px;
        position: relative;
        z-index: 2;
        margin-left: 5px;
    }

    .group > .header .label{
        color: white;
        font-size: 13px;
        padding-left: 20px;
    }
    .group.group-null > .header .label{
        padding-left: 10px;
    }



    .group > .header .fa-stack{
        position: absolute;
        right: -10px;
        transform: scale(0.55);
        top: -4px;
        margin: 0;
        cursor: pointer;
    }


    .group > .header .fa-stack > *{
        pointer-events: none;
    }

    .group > .header .fa-stack.add{
        right: 6px;
    }
    .group > .header .fa-stack *:not(.fa-circle){
        color: #6d8d23;
    }
    .group > .header .fa-stack .fa-circle{
        color: #e5e5e5;
    }
    .group > .header .fa-stack:hover .fa-circle{
        color: #707070 !important;
    }
    .group > .header .fa-stack:hover *:not(.fa-circle):not(.fa-arrows-alt){
        color: #e5e5e5 !important;
    }
    .group > .header .fa-stack.drag{
        right: initial;
        left: -10px;
    }
    .group > .header .fa-stack.drag .fa-arrows-alt{
        line-height: 130%;
        font-size: 20px;
        color: white;
    }

    .group > .header .fa-stack.drag .fa-circle{
        display: none;
    }


    .row{
        position: relative;
        width: calc(100% - 215px);
        padding: 5px;
        margin-left: 260px;
        height: 45px;
    }

    .grid .employee{
        position: absolute;
        top: 0;
        left: -245px;
        height: 46px;
        margin-bottom: 5px;
        padding-left: 45px;
        width: 245px;
        box-shadow: inset 0px -2px 0 -1px var(--contrast-1);
        z-index: 12;
    }

    .employee .picture {
        background-size: 100%;
        position: absolute;
        height: 30px;
        width: 30px;
        left: 5px;
        top: 7px;
        border-radius: 33px;
    }

    .employee .name {
        font-size: 13px;
        color: var(--contrast-5);
        text-align: left;
        height: 17px;
        white-space: nowrap;
        font-weight: 800;
        margin-top: 5px;
        margin-left: 0px;
        font-family: DistrictProBold;
        max-width: 100%;
        overflow: hidden;
    }

    .employee .name.shadow{
        height: 17px;
        white-space: nowrap;
        width: 30px;
        box-shadow: inset -30px 0 7px -7px var(--bg) !important;
        position: absolute;
        right: 0;
        top: 0;
    }

    .employee .progress {
        position: absolute;
        width: calc(100% - 45px);
        margin: auto;
        top: 30px;
        height: 6px;
        border-radius: 100px;
        background: var(--contrast-6);
        left: 45px;
        overflow: hidden;
    }

    .employee .entitled {
        position: absolute;
        width: calc(100% - 45px);
        margin: auto;
        top: 22px;
        height: 24px;
        left: 45px;
        overflow: hidden;
    }

    .employee .entitled .label{
        float: left;
        font-size: 12px;
        color: var(--contrast-5);
    }

    .employee .progress .progress-bar {
        position: absolute;
        width: 00%;
        bottom: 00px;
        height: 100%;
        border-radius: 100px;
        background: var(--contrast-5);
        left: 0;
    }

    .employee .progress .progress-bar{
    }


    .employee .add{
        position:absolute;
        top: -0px;
        right: -5px;
        transform: scale(0.4);
        cursor: pointer;
    }
    .employee .add .fa-plus{
        transform: scale(0.8);
    }

    .employee .fa-stack{

        position: absolute;
        right: 10px;
        top: 0;
        bottom: 0;
        margin: auto;
    }
    .employee:hover .fa-stack.detail{
        opacity: 1;
    }
    .employee .fa-stack.detail{
         opacity: 1;
        cursor: pointer;
        font-size:25px;
        width:25px;
        height:25px;
        right:5px;
    }

    .employee .fa-stack.detail:hover .fa-circle{
        color: #6d8d23 !important;
    }

    .employee .fa-stack.detail:hover .fa-map{
        color: #404040 !important;
    }

    .employee .fa-stack > .fas:not(.fa-circle){
        transform: scale(.55);
    }


    .event-info, .timeframe-popup, .drag-info, .drag-group{
        position: fixed;
        margin: auto;
        display: inline-block;
        background: var(--bg);
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        pointer-events: none;
        width: fit-content;
        padding: 5px;
        border-radius: 5px;
        opacity: 1;
        z-index: 20;
    }

    .drag-info .description{
        color: var(--contrast-4);
        z-index: 20;
    }

    .drag-group{
        background: none;
        box-shadow: none;
        z-index: 100;
        pointer-events: none;
    }

    .event-info .header{
        position: relative;
        width: 100%;
        font-weight: 600;
        text-align: center;
    }

    .event-info .description{
        position: relative;
        width: 100%;
        text-align: center;
    }
    .timeframe-popup{
        pointer-events: initial;
        z-index: 11;
    }

    .timeframe-popup .button{
        position: relative;
        font-weight: 600;
        text-align: center;
        margin: 5px 15px;
        width: 120px;
        display: block;
        height: 18px;
        border-radius: 100px;
        line-height: 100%;
    }

    .timeframe-popup .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }



    .time-marks{
        pointer-events: none;
        position: fixed;
        left: 260px;
        top: 200px;
        width: calc(100% - 278px);
        height: 100%;
        z-index: 10;
        padding: 0;
        white-space: nowrap;
    }

    .time-marks .label{
        position: absolute;
        top: -20px;
        left: -15px;
        width: 30px;
        text-align: center;
    }


    .time-marks.labels{
        z-index: 13;
    }

    .time-marks .mark{
        text-align: center;
        position: relative;
        width: calc(100% / 24);
        height: 100%;
        display: inline-block;
        box-shadow: inset 2px 0px 0 -1px  var(--contrast-1);
        background: none;
    }


    .time-marks .mark.day-split{
        box-shadow: inset 3px 0px 0 -1px  var(--contrast-4);
    }

    .day.hovered{
        background: var(--contrast-10);
    }

    .mark.hovered{
        background: var(--contrast-10);
        z-index: 9;
    }



    .time-marks.labels .mark{
        z-index: 13;
        height: 20px;;
    }

    .timeframe{
        position: absolute;
        height: calc(100% - 10px);
        background: #cccccc;
        z-index: 11;
        /*border-radius: 5px; */
        cursor: pointer;
        min-width: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .timeframe.vacationban{
        position: absolute;
        height: 100%;
        top: 0px;
        background: #cccccc;
        z-index: 0;
        /*border-radius: 5px; */
        cursor: pointer;
        min-width: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .timeframe:hover{
        overflow: visible;
    }

    .timeframe .label{
        color: white;
        white-space: nowrap;
        position: absolute;
        left: 5px;
        right: 5px;
        margin: auto;
        text-align: center;
        pointer-events: none;
        width: auto;
        overflow: hidden;
    }


    .timeframe .shadow{
        position: absolute;
        left: 0;
        top: 0;
        pointer-events: none;
        width: 100%;
        height: 100%;
        box-shadow: inherit !important;
        border-radius: 5px;
        z-index: -2;
    }

    .timeframe.show-under:hover .label{
        left: -1000px;
        right: -1000px;
        bottom: -25px;
        background: inherit;
        padding: 1px 5px;
        z-index: 10;
        width: fit-content;
        display: inline-block;
        border-radius: 5px;
    }

    .timeframe .handle{
        position: absolute;
        top: 0;
        bottom: 0;
        height: 100%;
        width: 15px;
        margin: auto;
        cursor: col-resize;
        color: #9f9f9f;
        text-align: center;
        transition: .2s;
        opacity: 0;
    }


    .timeframe .handle .inner{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        background: #9f9f9f;
        width: 2px;
        height: calc(100% - 20px);
        pointer-events: none;
    }

    .timeframe:hover .handle{
        opacity: 1;
    }

    .handle.start{
        left: -12px;

    }

    .handle.end{
        right: -12px;
    }
    .timeframe .handle.end{
    }

    .grid .backdrop{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 260px;
        background: var(--bg);
        /*-webkit-box-shadow: 0 0 30px  var(--bg);
        box-shadow: 0 0 15px 10px  var(--bg);*/
        z-index: 2;
        pointer-events: none;
    }

    .scrollbar-container{
        width: 100%;
        overflow-x: hidden;
        padding-top: 37px;
    }
    .loading{
        filter: none !important;
        position:absolute;
        box-sizing:content-box;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(100vh);
        background: rgba(0,0,0,.5);
        z-index: 100;
    }
    .loading .fa-spinner{
        position:absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 50px;
        height: 50px;
        font-size: 50px;
        color: var(--contrast-3);
        animation-name: spin;
        animation-duration: 2000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }
    @keyframes spin {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(360deg);
        }
    }

    .row .bottom-line,.row .top-line{
        box-shadow: inset 0px 2px 0 -1px  var(--contrast-1);
        height: 1px;
        position: absolute;
        bottom: 0px;
        width: calc(100% + 245px);
        left: -245px;
        z-index: 11;
    }

    .row .top-line{
        bottom: initial;
        top: 0px;
        display: none;
    }

    .row:nth-child(4) .top-line{
        display: initial;
    }

    .fa-refresh:before{
        content: '\f021';
    }

    .group.show-drag-area:not(.group-dragged){
        padding-top: 20px;
        margin-top: 5px;
    }
    .group .drag-catch-area{
        display: none;
    }
    .group .drag-catch-area.last{
        display: none;
    }

    .group.show-drag-area:not(.group-dragged) .drag-catch-area{
        display: inline-block;
        width: 230px;
        height: 19px;
        left: 5px;
        margin-top: -45px;
        background: none;
        border: dashed 1px var(--contrast-5);
        border-radius: 50px;
        position: absolute;
        z-index: 5;
        font-size: 13px;
        color: transparent;
        text-align: left;
        padding-left: 25px;
    }

    .group.show-drag-area:not(.group-dragged) .drag-catch-area:hover{
        background: var(--contrast-2);
        border: solid 1px var(--contrast-5);
        color: var(--contrast-4);
        line-height: 16px;
        font-weight: 600;
    }
    .group .drag-catch-area.last{
        display: none !important;
    }
    .group.show-drag-area-last
    {
        padding-bottom: 20px;
    }
    .group.show-drag-area-last .drag-catch-area.last{
        display: inline-block !important;
    }
    .group.show-drag-area:not(.group-dragged) .drag-catch-area.last{
        margin-top: 4px;
    }

    .group.sub-spot.show-drag-area:not(.group-dragged) .drag-catch-area{
        width: 210px;
        left: 25px;
    }

    .group.sub-spot.show-drag-area:not(.group-dragged) .drag-catch-area:hover{
        background: var(--contrast-2);
        border: solid 1px var(--contrast-5);
        color: var(--contrast-4);
        line-height: 16px;
        font-weight: 600;
    }


    .group.show-drag-area:not(.group-dragged) .header{
        background: var(--contrast-6);
    }

    .group-dragged{
        opacity: .5;
    }

    .group.sub-spot > .header{
        width: 235px;
        margin-left: 25px;
    }

    .group.sub-spot .employee{
        width: 225px;
        left: -225px;
    }


    .positions-filter, .employee-filter {
        position: absolute;
        top: 4px;
        left: 208px;
        z-index: 3;
    }

    .employee-filter {
        /*left: 80px;*/
    }

    .header > .filter.arrow.left{
        margin-right: 0;
    }

    .header > .filter.arrow.right{
        margin-left: 0;
    }
    .header > .filter.arrow{
        justify-content: center;
        height: 20px;
        width: 20px;
    }

    .filter.arrow .fas{
        transform: none;
        align-self: center;
    }



    .time-marks.monthly  .label{
        position: absolute;
        display: block;
        top: -14px;
        left: 0;
        right: 0;
        text-align: center;
        width: 100%;
        bottom: initial;
        height: 34px;
        line-height: 35px;
        cursor: pointer;
    }

    .day-container{
        height: 80px;
        width: calc(100% - 278px);
        white-space: nowrap;
        position: fixed;
        left: 260px;
        top: calc((2 * var(--header-height)) + var(--tab-menu-height) + 11px); /* 14px is the space needed to fit the weather and filter button */
        z-index: 12;
        background: var(--bg);
        overflow: hidden;
    }

    .day-container .day{
        transition: .2s;
        transform: scale(1);
        position: relative;
        opacity: 1 !important;
        padding-bottom: 0;
        height: 75px;
        width: 40px;
        margin: 0;
        cursor: pointer !important;
        top: 11px;
        z-index: 10;
        display: inline-block;
        box-shadow: inset 2px 0px 0 -1px #d5d5d5, inset 0px 0px 0 -1px #d5d5d5;
        border-radius: 0;
    }

    .day-container .day .name{
        position: absolute;
        height: 50%;
        width: 100%;
        left: 0;
        bottom: 0;
        right: 0;
        top: -10px;
        margin: auto;
        text-align: center;
        font-size: 13px;
        font-weight: 600;
        color: var(--contrast-4);
        border-radius: 0 !important;
        padding-top: 0 !important;
        background: none !important;
        cursor: pointer;
    }
    .day-container .day .date {

        position: absolute;
        height: 50%;
        width: 100%;
        left: 0;
        bottom: -20px;
        right: 0;
        top: 0;
        margin: auto;
        text-align: center;
        font-size: 10px;
        padding-top: 0 !important;
        border-radius: 0 !important;
        background: none !important;
        color: var(--contrast-4);
        cursor: pointer;
    }

    .day-container .day .income {
        width: calc(100% + 0px);
        position: absolute;
        bottom: 05px;
        font-size: 10px;
        background: transparent;
        height: 21px;
        padding-top: 3px;
        text-align: center;
        z-index: -1;
        cursor: pointer;
        box-shadow: inset 0px 2px 0 -1px #d5d5d5;
    }
    .day-container .day .weather {
        width: calc(100% + 1px);
        position: absolute;
        top: -16px;
        font-size: 10px;
        background: var(--bg);
        height: 25px;
        left: -1px;
        padding-top: 3px;
        padding-left: 1px;
        text-align: center;
        z-index: -1;
        cursor: pointer;
    }
    .day-container .day .weather .label{
        font-family: DistrictProLight;
        pointer-events: none;
        font-weight: 200;
        color: var(--contrast-4);
    }
    .day-container .day .weather .picture{

        width: 15px;
        margin-top: 2px;
        margin-left: 5px;
        height: 15px;
        display: inline-block;
        pointer-events: none;
        float: left;
    }
    .day-container .day:first-child .income {
        width: calc(100% + 1px);
        left: -1px;
    }
    .day-container .day .income .income-bar {
        position: absolute;
        border-radius: 100px;
        height: 8px;
        left: 5px;
        top: 9px;
        pointer-events: none;
    }
    .day-container .day .income .income-bar.red{
        background: #e51c50;

    }
    .day-container .day .income .income-bar.gray{
        background: var(--contrast-3);
    }

    .day-container .day .income .income-bar.green{
        background: #6d8d23;
    }

    .day-container-selected{
        position: fixed;
        top: 62px;
        left: 0px;
        margin: 0;
        z-index: 10000 !important;
        background: var(--bg);
        border-radius: 0;
        width: 90px;
    }

    .day-container-selected .day{

        position: fixed;
        left: 0px;
        margin: 0;
        margin-top: -5px;
        z-index: 10000 !important;
        background: var(--bg);
        border-radius: 0;
        width: 90px;
        height: 40px;
        top: 121px;
        cursor: pointer;
    }

    .day-container-selected .day *{
        pointer-events: none;
    }
    .day-container-selected .day .shadow{

        position: absolute;
        height: 40px;
        width: 140px;
        -webkit-box-shadow: 0 0 1px 0 #808080;
        box-shadow: 0 0 1px 0 #808080;
        left: -50px;
        top: 0;
    }

    .day-container-selected .day .name{

        position: absolute;
        height: 50%;
        width: 100%;
        left: 0;
        bottom: 0;
        right: 0;
        top: -10px;
        margin: auto;
        text-align: center;
        font-size: 13px;
        font-weight: 600;
        color: var(--contrast-4);
        border-radius: 0 !important;
        padding-top: 0 !important;
        background: none !important;
        cursor: pointer;
    }


    .day-container-selected .day .date{
        position: absolute;
        height: 50%;
        width: 100%;
        left: 0;
        bottom: -20px;
        right: 0;
        top: 0;
        margin: auto;
        text-align: center;
        font-size: 10px;
        padding-top: 0 !important;
        border-radius: 0 !important;
        background: none !important;
        color: var(--contrast-4);
        cursor: pointer;
    }



    .header.date{
        display: inline-flex;
        align-items: center;
        position: absolute;
        z-index: 10;
        background: none;
        left: 0;
        right: initial;
        width: initial;
        padding: 0 20px;
    }

    .header.date .label{
        color: var(--contrast-4);
        font-family: DistrictProLight;
        font-weight: 200;
    }

    .header.date .label.today{
        font-size: 15px;
        cursor:pointer;
    }

    .header.date .fa-angle-right,.header.date .fa-angle-left{
        color: var(--contrast-4);
        font-size: 20px;
        padding: 5px;
        cursor:pointer;
    }

    .header.date .fa-angle-right:hover,.header.date .fa-angle-left:hover, .header.date .fa-calendar:hover, .header.date .today:hover{
        color: var(--bg) !important;
    }

    .header.date .label.bold{
        font-family: DistrictProBold;
        font-weight: 800;
        margin: -3px 5px 0;
    }

    .header.date .fa-calendar{
        margin: 0 10px;
        font-size: 20px;
    }
    .timeframe.create{
        box-shadow: inset 0 0 0 1px var(--contrast-3);
        background: none;
    }


    .day .day-text{
        transform: scale(1) translateY(6px);
        transition: .2s;
        height: 37px;
        cursor: pointer;
    }

    .day .day-text:hover {
        transform: scale(1.3) translateY(1px);
    }

    .day .day-text * {
        pointer-events: none;
    }

    .sub-header{
        display: flex;
        justify-content: left;
        width: calc(100vw - 277px);
        left: 260px;
        height: 72px;
        position: fixed;
        top: 144px;
        background: var(--bg);
        box-shadow: 0 2px 0 -1px #d5d5d5;
        z-index: 12;
    }
    .sub-header .title{
        position: relative;
        display: flex;
        justify-content: center;
        padding: 0;
        align-self: flex-start;
        top: 1px;
    }

    .sub-header .title .label{
        font-size: 16px;
        font-weight: 500;
    }

    .sub-header .title .label.year{
        color: #6d8d23;;
        margin-right: 5px;
        font-weight: 800;
    }

    .employee .background{
        position: absolute;
        top: 0;
        left: -100px;
        width: calc(100% + 100px);
        height: 100%;
        background: var(--bg);
        box-shadow: none;
        z-index: -1;
    }

    .employee .background.shadow{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(100% - 1px);
        background: var(--bg);
        z-index: -1;
        box-shadow: inset 0px -2px 0 -1px var(--contrast-1) !important;
    }


    .grid .row:hover .employee .background.shadow{
        background: var(--contrast-10);
        border-radius: 0;
        border-top-left-radius: 100px;
        border-bottom-left-radius: 100px;
        box-shadow: none !important;
    }

    .row:hover .employee .name.shadow{
        box-shadow: inset -30px 0 7px -7px var(--contrast-10) !important;
    }

    .grid .row:hover {
        background: var(--contrast-10);
    }


    .event-marker{
        display: inline-block;
        height: 0;
        width: 0;
        font-size: 9px;
        text-align: center;
        padding-top: 2px;
        bottom: 26px;
        left: -2px;
        position: absolute;
        line-height: 110%;
        cursor: default;
        height: 13px;
        width: 10px;
        z-index: 1;
    }

    .always-work-bar{
        position: absolute;
        top: 0;
        height: 100%;
        background: #e5154f;
        z-index: -1;
        pointer-events: none;
    }

    .day-container.background{
        background: var(--bg);
        z-index: 12;
        margin-top: -12px;
    }



    .sub-header-button-container {
        width: 260px;
        height: 72px;
        padding-top: 42px;
        z-index: 13;
        position: fixed;
        background: var(--bg);
        top: 144px;
        box-shadow: 0 1px 1px 0 var(--contrast-1);
    }

    .sub-header-button-container > .button{
        margin: 0 0 0 15px !important;
       height: 25px !important;
       width: 25px !important;
       float: left;
       cursor: pointer;
        font-size: 17px;
        color: var(--contrast-4);
    }
    .sub-header-button-container > .button:first-of-type{
       float: left !important;
    }
    .sub-header-button-container > .button:last-of-type{
       float: right;
    }


</style>
